//#region Imports
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidatorFn,
	Validators
  } from '@angular/forms';
  import {
	ActionEventArgs,
	CellClickEventArgs,
	DragAndDropService,
	EventRenderedArgs,
	EventSettingsModel,
	GroupModel,
	ResizeService,
	ResourceDetails,
	ScheduleComponent,
	TimelineMonthService,
	TimelineViewsService,
	TimeScaleModel,
	View,
	WorkHoursModel
  } from '@syncfusion/ej2-angular-schedule';
  import { ActionName } from '@shared/enums/action-name';
  import {
	addClass,
	closest,
	createElement,
	extend,
	Internationalization,
	isNullOrUndefined,
	remove,
	removeClass
  } from '@syncfusion/ej2-base';
  import { AuthService } from '@services/auth.service';
  import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	Input,
	NgZone,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	HostListener
  } from '@angular/core';
  import { CommonService } from '@shared/services/common';
  import { ContextMenuComponent, TreeViewComponent, BeforeOpenCloseMenuEventArgs, MenuEventArgs, MenuItemModel } from '@syncfusion/ej2-angular-navigations';
  import { CustomerService } from '@fs/services/customer';
  import { DataManager, Predicate, Query } from '@syncfusion/ej2-data';
  import { DatePicker } from '@syncfusion/ej2-calendars';
  import { DatePipe } from '@angular/common';
  import {
	DetailRowService,
	Filter,
	FilterService,
	FilterSettingsModel,
	GridComponent,
	IFilter,
	RowDDService,
	RowDropSettingsModel,
	SelectionService,
	SortService
  } from '@syncfusion/ej2-angular-grids';
  import { DispatcherData, WorkOrderTechnician, DispatcherAppointment, Request_AppointmentModel, Sch_AppointmentModel, CommonAppointmentModel } from '@fs/models/work-order/dispatcher-model';
  import { DispatcherService } from '@fs/services/dispatcher';
  import { DropDownList } from '@syncfusion/ej2-dropdowns/src/drop-down-list';
  import { GetDepartmentIdPipe } from '@fs/pipes/get-department-id';
  import { groupBy, GroupResult } from '@progress/kendo-data-query';
  import { ISubscription } from 'rxjs/Subscription';
  import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
  import { PermissionPipe } from '@shared/pipes/permission';
  import { PhoneFormatPipe } from '@shared/pipes/phone-format';
  import { TabOpenService } from '@services/tab-open.service';
  import { Tabs } from '@enums/tab.enum';
  import { PopupSettings } from '@progress/kendo-angular-dateinputs';
  import { HttpErrorResponse } from '@angular/common/http';
  import { Constants } from '@shared/models/constants';
  import { CommonMethods } from '@services/common.method';
  import { TabsComponent } from '@shared/tab/tabs/tabs.component';
  import * as _ from 'lodash'
  import { AppointmentStatePipe } from '@fs/pipes/get-appointment-state';
  import { CodeTypeModel } from '@fs/models/code-type.model';
  import { NotificationsService } from '@shared/services/notification';
import { TabParams } from '@fs/services/tab-params.service';
  //#endregion
  
  interface SchedulerFilter {
	field: string;
	value: string
  }
  @Component({
	selector: "app-wo-dispatcher",
	templateUrl: "./wo-dispatcher.component.html",
	styleUrls: ["./wo-dispatcher.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
	  TimelineViewsService,
	  TimelineMonthService,
	  ResizeService,
	  DragAndDropService,
	  RowDDService,
	  FilterService,
	  SortService,
	  SelectionService,
	  DispatcherService,
	  DetailRowService,
	  CustomerService,
	  DatePipe,
	  AppointmentStatePipe
	]
  })
  export class WoDispatcherComponent implements OnInit {
	//#region View Child Elements
	@ViewChild("ElAdvancedSearch") ElAdvancedSearch: ElementRef;
	@ViewChild("ElAdvancedSearchOption") ElAdvancedSearchOption: any;
	@ViewChild("Grid") public Grid: GridComponent;
	@ViewChild("menuObj") public menuObj: ContextMenuComponent;
	@ViewChild("myform") nameInputRef: ElementRef;
	@ViewChild("scheduleObj") public scheduleObj: ScheduleComponent;
	@ViewChild("searchValue") searchValue: ElementRef;
	@ViewChild("treeObj") public treeObj: TreeViewComponent;
	@ViewChild(MultiSelectComponent) multiSelect: MultiSelectComponent;
	//#endregion	
	@Input() tabCounter: number;
	//#region Private Variables
	private TypeID_Static = '9e209ab2-13e1-4adc-afc6-eeca4e2c6fdd'; // Static ID for Tech Type (Tech or Non-tech)
	private instance: Internationalization = new Internationalization();
	private firstTimeCodeCheck: boolean = true; // true in case of view navigate or refreshall click/ tab refresh called
	/** To confirm whether to save WO changes in case of drag/ resize inside scheduler or from grid to scheduler */
	private confirmisDrag: boolean = false;
	/** Currently Selected WO - before change  -  used in case of dragging, resize warning.*/
	private beforeEditingWO: CommonAppointmentModel;
	/** Currently Selected WO - After change - used in case of dragging, resize warning.*/
	private afterEditingWO: CommonAppointmentModel;
	/** Whole Scheduler Data except the Selected WO(afterEditingWO) used in case of dragging, resize warning.*/
	private schedulerDataWithoutEditedWO: CommonAppointmentModel[];
	private subscriptions: ISubscription[] = [];
	private TimeSearchingArray_Cache: {} = {}; // to create cache work order by time zones to solve color problem while dragging
	private checkCompanyDataLoaded: boolean = false; // check to confirm company data loaded or not in case of first it will reload on refresh
	private WorkOrderArray: string[] = []; // to remove duplicacy  
	private openAppointmentID: string = ''; // to autorefresh Appointment in quickinfo and to track currently opened Appointment in quick info popup
	private draggedData_duration: number;
	private isInitialDataLoaded: { IsCompanyDataLoaded : boolean, IsSchedulerDataLoaded : boolean } = {IsCompanyDataLoaded : false, IsSchedulerDataLoaded : false};
	//#endregion
  
	//#region Public Variables
	public timeScale: TimeScaleModel = { enable: true, interval: 60, slotCount: 2 };
	public workHours: WorkHoursModel = { start: "08:00", end: "23:00" };
	public lastSyncDate: Date = new Date();
	public selectedDate: Date = (new Date());
	public schedulerStartDate: Date = (new Date());
	public schedulerEndDate: Date = (new Date());
	public groupIndex: number;
	public selectedTarget: Element;
	public EventEditingForm: FormGroup;
	public customFilterForm: FormGroup;
	public sortOptions: Object;
	public data: any[] = [];
	public dManager: Object[] = [];
	public srcData: Object[] = [];
	public advancedFilterFields = [];
	public PrioritiesDataSource: Object[] = [];
	public CustomerType: Object[] = [];
	public DepartmentTypeDataSource: Object[] = [];
	public FilteredTechnicianDataSource = [];
	public field: CommonAppointmentModel[] = [];//{ [key: string]: Object }[] = [];
	public ServiceTypeFilterDataSource: Object[] = [];
	public TechnicianDataSource: any[] = []; // scheduler left side axis data
	public TechnicianMasterDataSource: any[] = []; // scheduler Master data for left side axis data that will never change
	public TechnicianDataSourceWithEmpty: Object[] = []; // For Tech dropdown contains empty for Unassign
	public SelectedTechniciansForFilter: any = [];// technician picklist values
	/* Kendo TimePicker */
	public steps: any = { hour: 1, minute: 30, second: 30 };
	public value: Date = new Date(2000, 1, 1, 10, 30);
	public format = "hh:mm a";
	public IsGridRowDraggingAllowed: boolean = false;
	/* Kendo TimePicker End */
	public WorkOrderState_SubStateDataSource = [
	  // {
	  // 	ID: "1",
	  // 	Text: "Open - UnAssigned"
	  // },
	  {
		ID: "2",
		Text: "Open - Assigned"
	  },
	  {
		ID: "3",
		Text: "Open - Dispatched"
	  },
	  {
		ID: "4",
		Text: "Open - Tech Received"
	  },
	  {
		ID: "5",
		Text: "Open - Working"
	  },
	  {
		ID: "6",
		Text: "Completed - Ready For Review"
	  },
	  {
		ID: "7",
		Text: "Completed - Posted"
	  },
	  {
		ID: "8",
		Text: "Action Required - Rescheduled"
	  },
	  {
		ID: "9",
		Text: "Action Required - Parts Needed"
	  },
	  {
		ID: "10",
		Text: "Action Required - Posting Failure"
	  }
	  // ,
	  // {
	  // 	ID: "12",
	  // 	Text: "Cancelled"
	  // },
	  // {
	  // 	ID: "12",
	  // 	Text: "Void"
	  // }
	];
	public TechnicianTypeDataSource: Object[] = [
	  {
		Text: "Technician",
		ID: 0
	  },
	  {
		Text: "Non Technician",
		ID: 1
	  }
	];
	public TechnicianTypeFields: Object = { text: "Text", value: "ID" };
	public TechnicianDataFields: Object = { text: "Text", value: "ID" };
	public DataFields: Object = {
	  text: "Name",
	  value: "ID"
	};
	public statusFields: Object = {
	  text: "name",
	  value: "value"
	};
	public workOrdersFields: any = {
	  dataSource: [],
	  ID: "ID",
	  text: "Name"
	};
	public NoGrouping: GroupModel = {
	  enableCompactView: false,
	  resources: ["WorkOrdersDept"]
	};
	public GroupModelTech: GroupModel = {
	  enableCompactView: false,
	  resources: ["TechnicianType", "WorkOrdersTech"]
	};
	public GroupModelDepartment: GroupModel = {
	  enableCompactView: false,
	  resources: ["DepartmentType", "WorkOrdersDept"]
	};
	public eventSettings: EventSettingsModel = {
	  dataSource: this.data,
	  ignoreWhitespace: true,
	  fields: {
		followingID: "ID"
	  }
	};
	public synInterval = null;
	public completeWorkOrderData: any;
	public editingdata: any;
	public pageOptions: Object;
	public selectionOptions: Object;
	public Priorities: any;
	public SubState: any;
	public Department: any;
	public srcDropOptions: RowDropSettingsModel;
	public filterOptions: FilterSettingsModel;
	public filter: IFilter;
	public dropInstance: DropDownList;
	public selectedDateFilterType: string = "";
	public initialData: any;
	public Priority_Data: any;
	public PromisedTime_Data: any;
	/** used for Grid filter popup */
	public prevMappingGuid = undefined;
	public FilterStateSubState: string = 'All'; // be default show Work Order and Time Off
	public FilterType: string = 'All'; // be default show Work Order and Time Off
	public Filterpriority: string = 'All'; // be default priority
	public FilterTechType: string = 'All'; // be default sFilterSub State
	public FilterDepartment: string = 'All'; // be default Filter Department
	public FilterServiceType: string = 'All'; // be default Filter Service Type
	public GroupingModel: string = '1'; // by default grouping is by department
	public errorMessage: string = "";
	public draggedItemID: string = "";
	public currentWorkOrderID: string = "";
	public currentView: View = "TimelineDay";
	public activeEditorStartTime: string = "";
	public showunAssignAction: boolean = false;
	public showDispatchAction: boolean = false;
	public showunUndoDispatchAction: boolean = false;
	public showContinueAction: boolean = false;
	public isNagivated: number = 0; // variable to check date, view , update navigating, inprocess - to restrict databound call 0, -999 (two values used to control one method called again and again)- nothing, 2- editing,1- navigating
	public isCurrentWOBlocked: boolean = false;
	public chckWorkOrder: boolean = true;
	public chckTimeOff: boolean = true;
	public filtershowmodal: boolean = false;
	public editShowModal  : boolean = false;
	public errorshowmodal: boolean = false;
	/** To show warning with error message - used in case of dragging, resize */
	public warningshowmodal: boolean = false;
	public deleteshowmodal: boolean = false;
	public hideDepartmentCheck: boolean = false; // hide department in case of department grouping
	public isTreeItemDropped: boolean = false;
	public rowAutoHeight: boolean = true;
	public showQuickInfo: boolean = true;
	public allowMultiple: Boolean = true;
	/** 0 means not loaded , 1 means loaded and 2 means in editing state(not loaded) */
	public isLoaded: number = 0;
	public actionName = ActionName;
	public constants = Constants;
	public promDateColumnformat = {};
	public groupedTechData: GroupResult[];
	public AppliedTechniciansFilter: any[];
	public isPDateGridFilterActive: boolean = false;
	public isRefreshInProgress: boolean = false;
	public showUnAssignedPopup: boolean = false;
	/** used this to apply style to child group */
	filterSettings: Object;
	public formatoptions: Object;
	public templateOptions: IFilter;
	public datePicker1: DatePicker;
	public datePicker2: DatePicker;
	public predicate: Predicate;
	public dropDownData: any[] = [
	  // { sID: '', sname: 'Select Date' },
	  { sID: '1', sname: 'Today' },
	  { sID: '2', sname: 'Tomorrow' },
	  { sID: '3', sname: 'This Week' },
	  { sID: '4', sname: 'Custom' },
	  // { sID: '5', sname: 'Exclude selected dates' }
	];
	public dm1: any = this.dropDownData.find(x => x["sname"] == "Custom")["sID"];
	public dp1: any;
	public dp2: any;
	public popupSettings: PopupSettings = {
	  appendTo: 'root',
	  popupClass: 'dispatchertimer_outer'
	};
	public lblDurationValidationError: string = '';
	//public start: Date;
	public templatedata: any; // to update quick info template with automatic delta timer
	public SelectedModifiedDate: any;
	public hasWorkOrderManagePermission: boolean = true;
	public hasWorkOrderManageNewPermission: boolean = true;
	public hasWorkOrderManageEditPermission: boolean = true;
	public hasWorkOrderReviewEditPermission: boolean = true;
	public hasDispatchBoardEditPermission: boolean = true;
	public hasDispatchBoardManagePermission: boolean = true;
	public hasNewWorkOrderPermission: boolean = true;
	public qbVersion: string;
	public AppointmentForm: FormGroup;
	public showAppointmentModal: boolean
	public ApptType_Data: any = []
	public ApptType_Data_filterd: any= [];
	public menuItems: MenuItemModel[] = [
	  {
		text: 'New Work Order',
		iconCss: 'e-icons new',
		id: 'NewWorkOrder'
	  },
	  {
		text: 'New Appointment',
		iconCss: 'e-icons new',
		id: 'NewAppointment'
	  }
	];
	/** to contain cell data related to context menu */
	public contextData: any = {};
	public showAPTQuickInfo: boolean = false;
	public showWOQuickInfo: boolean = false;
	public apptModalHeader = { Header: "", SubHeader: "" };
	public showAPTWarningModal: boolean = false;
	public filter_APT_Types = [];
	public showHelperQuickInfo: boolean = false;
	public primaryTechCodeType: {};
	excludeAppointmentTypes = ['helper', 'estimate'];
	showEstimateQuickInfo: boolean = false;
	hasEstimateEditPermission = true;
	showEstimateDeptWarningModal = false;
	//#endregion	
  
	//#region LifeCycle Events
	constructor(private tabopen: TabOpenService, private httpCommon: CommonService,
	  private auth: AuthService, private httpService: DispatcherService, private toastr: NotificationsService,
	  private customerService: CustomerService, private permissionPipe: PermissionPipe, private datePipe: DatePipe, private zone: NgZone,
	  private tabsComponent: TabsComponent,
	  private commonMethods: CommonMethods,
	  private appointmentStatePipe: AppointmentStatePipe) {
	  let subscription = this.tabopen.focusTabEvent.subscribe(response => {
		if (response.tabCounter == this.tabCounter) {// on tab focus
		  setTimeout(() => {
			if (this.isLoaded == 1) {
			  if (!this.isDispatcherLoaded()) // second confirm scheduler to check loaded properly
			  {
				this.RefreshDispatchBoard();
			  }
			  //console.log('Loaded properly');
			}
			else {
			  //console.log('Not Loaded properly');
			  $('#Schedule').css('opacity', '0');
			  this.RefreshDispatchBoard();
			}
		  }, 200); // 300 ms assumption that scheduler is rendered
		}
		else if (response.previoustabCounter == this.tabCounter) { // on tab exit					
		  if (this.isNagivated == 1) {
			this.isLoaded = 2;
		  }
		  if (this.isLoaded != 1) // both 0 and 2
		  {
			//console.log('Not Loaded on exit properly');
			$('#Schedule').css('opacity', '0');
			this.showLoader();
		  }
		  else {
			//console.log('Loaded properly on exit');
		  }
		}
	  });
	  this.subscriptions.push(subscription);
	  this.qbVersion = (this.auth.getCompanyQBType()).toLocaleLowerCase();
	  if (this.qbVersion == 'none')
		this.WorkOrderState_SubStateDataSource = this.WorkOrderState_SubStateDataSource.filter(x => x.ID != '10');
	}
	  ngOnInit() {
		  //grid initialization
		  this.pageOptions = { pageCount: 2 };
		  this.selectionOptions = { type: "Single", mode: "Row" };
		  this.srcDropOptions = { targetID: "Schedule" };
		  this.filterOptions = {
		  type: "Menu",
		  operators: {
			  stringOperator: [
			  { value: 'contains', text: 'Contains' },
			  { value: 'startswith', text: 'Starts With' },
			  { value: 'endswith', text: 'Ends With' },
			  { value: 'equal', text: 'Equal' },
			  { value: 'notequal', text: 'Not Equal' }
			  ],
		  }
		  };
		  this.filter = {
		  type: "CheckBox"
		  };
		  this.EventEditingForm = this.InitializeEditEventForm();
		  this.AppointmentForm = this.InitAppointmentForm();
		  this.scheduleObj.eventSettings = this.eventSettings;
		  this.LoadCompanyData();
		  this.sortOptions = { columns: [{ field: 'PDate', direction: 'Descending' }] };
		  this.setCustomDateTemplate();
  
		  this.synInterval = setInterval(() => { // delta timer
		  if (!this.isRefreshInProgress) {
			  this.schedulerElementInsert();
		  }
		  }, 30000);
  
		  // Set Permission here
		  this.hasWorkOrderManagePermission = this.permissionPipe.transform(ActionName.ManageWorkOrders);
		  this.hasWorkOrderManageNewPermission = this.permissionPipe.transform(ActionName.NewWorkOrder);
		  this.hasWorkOrderManageEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrder);
		  this.hasWorkOrderReviewEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrderReview);
		  this.hasDispatchBoardEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrderDispatcher);
		  this.hasEstimateEditPermission = this.permissionPipe.transform(ActionName.EditEstimate);
		  this.hasDispatchBoardManagePermission = this.permissionPipe.transform(ActionName.Estimate);

		  if(!this.hasDispatchBoardEditPermission)
			  this.menuItems.splice(1, 1);
		  if(!this.hasWorkOrderManageNewPermission)
			  this.menuItems.splice(0, 1);
	  }
	  ngOnDestroy() {
		  this.subscriptions.forEach(element => {
		  element.unsubscribe();
		  });
  
		  if (this.synInterval != null)
		  clearInterval(this.synInterval);
	  }
	  load(args: any) {
		  this.Grid.element.addEventListener('click', this.gridClickHandler.bind(this));
	  }
	  //#endregion
  
	  //#region Page Host Listners
	  @HostListener('document:click', ['$event'])
	  closeUnassignedGridModalOnClick(event) {
		  if (this.showUnAssignedPopup
		  && (!isNullOrUndefined(event.srcElement) && $(event.srcElement).parents('.schedule-container-grid').length <= 0)) {
		  this.closeQuickInfo();
		  }
	  }
	  @HostListener("mousewheel", ['$event'])
	  closeUnassignedGridModalOnGridScroll(event) {
		  if (this.showUnAssignedPopup
		  && (!isNullOrUndefined(event.srcElement) && event.srcElement.classList.contains('e-rowcell'))) {
		  this.closeQuickInfo();
		  }
	  }
	  @HostListener('document:keydown.escape', ['$event'])
	  closeUnassignedGridModalOnEscape(event) {
		  if (this.showUnAssignedPopup)
		  this.closeQuickInfo();
	  }
	  //#endregion
  
	  //#region Private Methods	
	  private ToCustomTimeFormat(hour,minute): string // HH:MM:SS
	  {
		  return hour.toString().padStart(2, '0') + ":" + minute.toString().padStart(2, '0') + ":00";
	  }
	  private ShowErrorFromAPI(error: any) {
		  if (error instanceof HttpErrorResponse) {
		  if (error.status != 403) {
			  let errorFromAPI: string = isNullOrUndefined(error.error) ? null : error.error.Message;
			  errorFromAPI = errorFromAPI == (undefined || null) ? "" : (errorFromAPI);
			  this.toastr.error(errorFromAPI, "Error");
		  }
		  }
	  }
	  private CustomEventTypeValidator(control: AbstractControl): { [key: string]: boolean } | null {
		  if (control.value !== undefined && !(control.value == "TimeOff" || control.value == "WorkOrder")) {
		  return { EventType: true };
		  }
		  return null;
	  }
	  private CustomDateValidator(control: AbstractControl): { [key: string]: boolean } | null {
		  if (control.value !== undefined && isNaN(Date.parse(control.value)) == true) {
		  return { DateError: true };
		  }
		  return null;
	  }
	  private CustomTechnicianTypeValidator(control: AbstractControl): { [key: string]: boolean } | null {
		  if (control.value !== undefined && !(control.value == "0" || control.value == "1")) {
		  return { TechType: true };
		  }
		  return null;
	  }
	  private CustomPriorityIDValidator(PromiseIDList: any): ValidatorFn {
		  return (control: AbstractControl): { [key: string]: boolean } | null => {
		  if (control.value !== undefined && PromiseIDList.findIndex(x => x.ID == control.value) < 0) {
			  return { PriorityType: true };
		  }
		  return null;
		  };
	  }
	  private CustomPromIDValidator(PromiseIDList: any): ValidatorFn {
		  return (control: AbstractControl): { [key: string]: boolean } | null => {
		  if (control.value !== undefined && PromiseIDList.findIndex(x => x.ID == control.value) < 0) {
			  return { PromiseType: true };
		  }
		  return null;
		  };
	  }
	  private EventOneDayTimeValidator(control: FormControl): any {
		  if (
		  control != undefined &&
		  control.parent != undefined &&
		  !isNullOrUndefined(control.parent.controls["StartTime"].value) && control.parent.controls["StartTime"].value.toString() != "" &&
		  !isNullOrUndefined(control.parent.controls["DurationHour"].value) && control.parent.controls["DurationHour"].value.toString() != "" &&
		  !isNullOrUndefined(control.parent.controls["DurationMin"].value) && control.parent.controls["DurationMin"].value.toString() != ""
		  ) {
		  let objStartTime = control.parent.controls["StartTime"].value;
		  let DurationMin = isNaN(control.parent.controls["DurationMin"].value) ? 0 : control.parent.controls["DurationMin"].value;
		  DurationMin = parseInt(DurationMin) > 0 ? 30 : DurationMin; // Either 0 or 30
		  let DurationHour = isNaN(control.parent.controls["DurationHour"].value) ? 0 : control.parent.controls["DurationHour"].value;
		  let objEndTime = new Date((new Date(objStartTime).getTime() + (((parseInt(DurationHour) * 60) + parseInt(DurationMin)) * 60000)));
		  if (objStartTime == null && objEndTime == null) {
			  return null;
		  } else {
			  let startTime = objStartTime;
			  let endTime = new Date(objEndTime);
			  //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
			  if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
			  new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
			  new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
			  return null;
			  }
			  else {
			  return { InvalidOneDayTime: true };
			  }
		  }
		  }
		  return null;
	  }
	  private DurationValidator(control: FormControl): any {
		  if (
		  control != undefined &&
		  control.parent != undefined &&
		  !isNullOrUndefined(control.parent.controls["DurationHour"].value) && control.parent.controls["DurationHour"].value.toString() != "" &&
		  !isNullOrUndefined(control.parent.controls["DurationMin"].value) && control.parent.controls["DurationMin"].value.toString() != ""
		  ) {
		  let hour: any = control.parent.controls["DurationHour"].value;
		  let minutes: any = control.parent.controls["DurationMin"].value;
		  if (!isNaN(hour) && !isNaN(minutes)) {
			  if (parseInt(hour) <= 0 && parseInt(minutes) <= 0) {
			  return { InvalidHourMinute: true };
			  }
			  else {
			  return null;
			  }
		  }
		  }
	  }
	  private BlankTechValidator(control: FormControl): any {
		  if ((!CommonMethods.CheckNullOrUndefined(control)) && (control.value == "-" || control.value == "")){
		  return { required: true };
		  }
		  else
		  return null;
	  }
	  private setCommonError(errorMsg: string) {
		  this.deleteshowmodal = false;
		  this.editShowModal   = false;
		  this.errorshowmodal = true;
		  this.errorMessage = errorMsg;
	  }
	  private EditWorkOrder(data: any) {
		  return new Promise((resolve, reject) => {
		  this.showLoader();
		  let submitmodel = Object.assign({}, data);
		  let appointmentDate = (new Date(data.AppointmentDate).getFullYear().toString()) + "-" + ((new Date(data.AppointmentDate).getMonth() + 1).toString().padStart(2, '0')) + "-" + (new Date(data.AppointmentDate).getDate().toString().padStart(2, '0')) + "T00:00:00";
		  data.DurationMin = isNaN(data.DurationMin) ? 0 : data.DurationMin;
		  data.DurationMin = parseInt(data.DurationMin) > 0 ? 30 : data.DurationMin; // Either 0 or 30
		  data.DurationHour = isNaN(data.DurationHour) ? 0 : data.DurationHour;
  
		  submitmodel["AppointmentDt"] = appointmentDate;
		  submitmodel["AppointmentModifyDate"] = data.ModifyDate;
		  submitmodel["AppointmentNote"] = data.DispComment;
		  submitmodel["AppointmentStatusID"] = this.editingTemplatedata.WorkTicketStatusID;
		  submitmodel["AppointmentSubStatusID"] = this.editingTemplatedata.WorkTicketSubStatusID;
		  submitmodel["TypeID"] = this.primaryTechCodeType[0].ID; //this.TypeID_Static;
		  submitmodel["AppointmentTypeCode"] = this.primaryTechCodeType[0].Name;//"Work Order";
		  submitmodel["DurationHour"] = data.DurationHour;
		  submitmodel["DurationMin"] = data.DurationMin;
		  submitmodel["ID"] = data.ID;
		  submitmodel["IsNew"] = false;
		  submitmodel["IsSchedule"] = !CommonMethods.CheckNullOrUndefined(data.IsSchedule) ? data.IsSchedule : false;
  
		  submitmodel["WorkTicketNumber"] = this.editingTemplatedata["WorkTicketNumber"],
		  submitmodel["PriorityID"] = data.PriorityID,
		  submitmodel["Priority"] = data.Priority,
		  submitmodel["PromID"] = data.PromID,
		  submitmodel["StartTime"] = data.StartTime, //(new Date(data.StartTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(data.StartTime).getMinutes().toString().padStart(2, '0')) + ":00";
		  submitmodel["TechDepartmentID"] = data.TechDepartmentID;
		  submitmodel["TechID"] = data.UserID;
  
		  //#endregion
		  let formData = this.InitAppointmentForm(submitmodel);
		  this.AddOrEditAppointmentData(formData).then((response: any) => {
			  resolve(response);
		  }).catch(error => { reject(error) });
		  });
	  }
	  private ChangeActionStatus(StateParam: any, SubStateParam: any) {
		  if (!(isNullOrUndefined(StateParam) || isNullOrUndefined(SubStateParam))) {
		  let state: string = StateParam.toString().toLocaleLowerCase().replace(/ /g, '');
		  let SubState: string = SubStateParam.toString().toLowerCase().replace(/ /g, '');
		  this.showunAssignAction = false;
		  this.showDispatchAction = false;
		  this.showunUndoDispatchAction = false;
		  this.showContinueAction = false;
  
		  if (state == Constants.WOStaticStatus().open && SubState == Constants.WOStaticStatus().unassigned) { }
		  else if (state == Constants.WOStaticStatus().open && SubState == Constants.WOStaticStatus().assigned) {
			  this.showunAssignAction = true;
			  this.showDispatchAction = true;
			  this.showunUndoDispatchAction = false;
			  this.showContinueAction = false;
		  }
		  else if (state == Constants.WOStaticStatus().open && SubState == Constants.WOStaticStatus().dispatched) {
			  this.showunAssignAction = false;
			  this.showDispatchAction = false;
			  this.showunUndoDispatchAction = true;
			  this.showContinueAction = false;
		  }
		  else if (state == Constants.WOStaticStatus().open && SubState == Constants.WOStaticStatus().techreceived) { }
		  else if (state == Constants.WOStaticStatus().open && SubState == Constants.WOStaticStatus().working) { }
		  else if (state == Constants.WOStaticStatus().completed && SubState == Constants.WOStaticStatus().readyforreview) { }
		  else if (state == Constants.WOStaticStatus().completed && SubState == Constants.WOStaticStatus().posted) { }
		  else if (state == Constants.WOStaticStatus().actionrequired && SubState == Constants.WOStaticStatus().rescheduled) {
			  this.showunAssignAction = false;
			  this.showDispatchAction = false;
			  this.showunUndoDispatchAction = false;
			  this.showContinueAction = true;
		  }
		  else if (state == Constants.WOStaticStatus().actionrequired && SubState == Constants.WOStaticStatus().partsneeded) {
			  this.showunAssignAction = false;
			  this.showDispatchAction = false;
			  this.showunUndoDispatchAction = false;
			  this.showContinueAction = true;
		  }
		  else if (state == Constants.WOStaticStatus().actionrequired && SubState == Constants.WOStaticStatus().postingfailure) { }
		  else if (state == Constants.WOStaticStatus().cancelled) { }
		  else if (state == Constants.WOStaticStatus().void) { }
		  }
	  }
	  private setCurrentTarget(args) {
		  //#region Set Current Target
		  const newEventElement: HTMLElement = document.querySelector(".e-new-event") as HTMLElement;
		  if (newEventElement) {
		  remove(newEventElement);
		  removeClass([document.querySelector(".e-selected-cell")], "e-selected-cell");
		  }
		  const targetElement: HTMLElement = <HTMLElement>args.element;
		  this.selectedTarget = closest(
		  targetElement,
		  ".e-appointment,.e-work-cells," +
		  ".e-vertical-view .e-date-header-wrap .e-all-day-cells,.e-vertical-view .e-date-header-wrap .e-header-cells"
		  );
		  if (isNullOrUndefined(this.selectedTarget)) {
		  args.cancel = true;
		  return;
		  }
		  //#endRegion
	  }
	  private formatTime(time: string, returntype: number): number // 0 for hour, 1 for minute, 2 for second
	  {
		  if (!isNaN(Date.parse(time))) { // valid datetime object either in object or string format 
		  time = new Date(time).getHours().toString() + ":" + new Date(time).getMinutes().toString() + ":" + new Date(time).getSeconds().toString();
		  }
		  if (time != null && time.indexOf(":") > -1) {
		  let time_Array = time.split(":"); // split it at the colons
		  if (returntype == 0) {
			  return parseInt(time_Array[0]);
		  }
		  else if (returntype == 1) {
			  return parseInt(time_Array[1]);
		  }
		  else if (returntype == 2) {
			  return parseInt(time_Array[2]);
		  }
		  return 0;
		  }
		  else
		  return 0;
	  }
	  private GetPreviewData(eventObj) {
		  this.showLoader();
		  let subscription = this.customerService.GetJobSiteDetail(eventObj.CustomerID, eventObj.JobSiteID, "Customer,TaxGroup,Contacts,PaymentTerm").subscribe(response => {
		  if (response != null) {
			  let detailData: any;
			  if (response.Customer != null) {
			  detailData = response.Customer;
			  response.Customer = null;
			  }
			  detailData.JobSites = [response];
			  if (this.permissionPipe.transform(ActionName.EditCustomer)) {
			  let customerData = Object.assign({}, detailData);
			  customerData.JobSites = [];
			  this.tabopen.OpenTab({
				  tabId: Tabs.FsLiteCustomerJobSiteEdit,
				  params: {
				  ID: eventObj.JobSiteID,
				  jobsiteId: eventObj.JobSiteID,
				  objDetailData: customerData,
				  previewType: "JobSite"
				  },
				  tabTitle: "Job Site - " + eventObj.JobSiteDispName,
				  replaceIfOpen: {
				  replaceTab: true,
				  tabToReplace: Tabs.FsLiteCustomerJobSiteEdit,
				  action: "focus"
				  }
			  });
			  }
  
		  }
		  // this.detailData = response;
		  this.hideLoader();
		  }, () => {
		  this.hideLoader();
		  });
		  this.subscriptions.push(subscription);
	  }
	  private checkValidPromseTime(promisetime: string) {
		  let isvalidPromiseTime: boolean = false;
		  if (!isNullOrUndefined(promisetime)) {
		  if (promisetime.split(":").length == 3)// valid time
		  {
			  isvalidPromiseTime = true;
		  }
		  }
		  return isvalidPromiseTime;
	  }
	  private createCache(workorder) {
		  if (this.checkValidPromseTime(workorder.PromBeginTime) && this.checkValidPromseTime(workorder.PromEndTime)) {
		  let startingHour: number = parseInt(workorder.PromBeginTime.split(":")[0]);
		  let endHour: number = parseInt(workorder.PromEndTime.split(":")[0]);
		  for (var hour = startingHour; hour <= endHour; hour++) {
			  ["00", "30"].forEach(min => {
			  let ComparisonDate: Date = new Date();
			  ComparisonDate.setHours(parseInt(hour.toString()));
			  ComparisonDate.setMinutes(parseInt(min.toString()));
			  ComparisonDate.setSeconds(0);
			  const time: string = hour.toString().padStart(2, '0') + ":" + min.toString().padStart(2, '0') + ":00";
			  if (Object.keys(this.TimeSearchingArray_Cache).indexOf(workorder.WorkTicketNumber.toString()) > -1 &&
				  this.TimeSearchingArray_Cache[workorder.WorkTicketNumber.toString()].indexOf(time) > -1) {
  
			  }
			  else {
				  if (this.checkSchedulerCellWithinPromisedTime(workorder.PromBeginTime, workorder.PromEndTime, ComparisonDate))
				  //if(CheckSchedulerCellWithinPromisedTimePipe.prototype.transform(args.date,[element.PromBeginTime,element.PromEndTime,element.WorkTicketNumber]))
				  {
				  if (Object.keys(this.TimeSearchingArray_Cache).indexOf(workorder.WorkTicketNumber) > -1) // already exists
				  {
					  if (this.TimeSearchingArray_Cache[workorder.WorkTicketNumber].indexOf(time) < 0) {
					  this.TimeSearchingArray_Cache[workorder.WorkTicketNumber] = this.TimeSearchingArray_Cache[workorder.WorkTicketNumber].toString() + "," + time;
					  }
				  }
				  else {
					  this.TimeSearchingArray_Cache[workorder.WorkTicketNumber] = time;
				  }
				  }
			  }
			  });
		  }
		  }
	  }
	  private fetchSchedulerData(filters: SchedulerFilter[], IsRefreshAll: boolean = false) { // is IsRefreshAll is true then new technicians will be added in filter and scheduler
		  this.showLoader();
		  return new Promise(resolve => {
		  let subscription = this.httpService.GetDispatchData_New(filters).subscribe(response => {
			  let schData: DispatcherData = response;
			  this.completeWorkOrderData = response;
			  if (IsRefreshAll || this.TechnicianDataSource.length == 0) {
			  this.TechnicianDataSourceWithEmpty = []
			  this.DepartmentTypeDataSource = [];
			  this.TechnicianDataSource = [];
			  this.TechnicianMasterDataSource = [];
			  schData.Users.forEach((element: WorkOrderTechnician) => {
				  //technician data source
				  let techdata: {} = {};
				  techdata["Text"] = element.UserName;
				  techdata["ID"] = element.UserID;
				  techdata["UserGroupID"] = 0 //element.UserGroupID;
				  techdata["UserPhone"] = element.UserPhone;
				  techdata["DepartmentGroupID"] = element.DepartmentName;
				  techdata["Message"] = null;//element.Message;
				  techdata["MessageType"] = null;//element.MessageType; // can be Emergency/ NonEmergency  
				  element.DeptName = element.DepartmentName;
				  this.TechnicianDataSource.push(techdata);
				  this.TechnicianDataSourceWithEmpty.push(techdata);
				  this.TechnicianMasterDataSource.push(techdata);
				  if (!isNullOrUndefined(element.DeptName)) {
				  if (this.DepartmentTypeDataSource.findIndex(item => item["Text"] == element.DeptName) < 0) // department as per technician
				  {
					  if (!isNullOrUndefined(element.DeptName) && element.DeptName != '')
					  this.DepartmentTypeDataSource.push({ Text: element.DeptName, ID: element.DeptName }); // fill master priority data
				  }
				  }
			  });
			  this.TechnicianDataSource = this.sortByKey(this.TechnicianDataSource, "Text");
			  this.TechnicianDataSourceWithEmpty = this.sortByKey(this.TechnicianDataSourceWithEmpty, "Text");
			  this.TechnicianDataSourceWithEmpty.unshift({ "Text": "Choose Technician", "ID": "-", "UserGroupID": "", "DepartmentGroupID": "", "Message": "", "MessageType": "" });
			  this.TechnicianMasterDataSource = this.sortByKey(this.TechnicianMasterDataSource, "Text");
  
			  this.DepartmentTypeDataSource = this.sortByKey(this.DepartmentTypeDataSource, "Text");
			  this.groupedTechData = groupBy(this.TechnicianDataSource, [{ field: "DepartmentGroupID" }]);
			  // show all technician selected by default
			  this.multiSelectAllSelected();
			  this.AppliedTechniciansFilter = this.SelectedTechniciansForFilter;
			  }
			  //clear this.TimeSearchingArray_Cache // for next scheduler render
			  this.TimeSearchingArray_Cache = {};
			  let assignedAppointmentData: object[] = [];
			  this.WorkOrderArray = [];
  
			  this.field = schData["UnAssignedWorkOrders"].map(x => {
			  //#region updating properties
			  x.PDate = new Date(x.PromDate);
			  x.WorkTicketStatusName = this.appointmentStatePipe.transform(x.WorkTicketStatusID, 'state');
			  x.WorkTicketSubStatusName = this.appointmentStatePipe.transform(x.WorkTicketSubStatusID, 'substate');
			  //#endregion
			  return x;
			  });
			  // crate cache
			  this.field.forEach(workorder => {
			  this.createCache(workorder);
			  });
  
			  schData.Users.forEach((element: WorkOrderTechnician) => {
			  if (!isNullOrUndefined(element.Apppointments)) {
				  let assignedWorkorderstoTechnician: any = element.Apppointments;
				  if (assignedWorkorderstoTechnician.length > 0) {
				  assignedWorkorderstoTechnician.forEach(appointment => {
					  let assignedAppointmentElement: {} = {};
					  //#region set required data
					appointment["AppointmentDt"] = appointment.AppointmentDate;
					appointment["AppointmentTypeCode"] = appointment.AppointmentTypeCode;
					appointment["DepartmentID"] = appointment.DepartmentName;
					appointment["DeptName"] = appointment.DepartmentName;
					appointment["EventType"] = appointment.AppointmentTypeCode.toLowerCase() != "primarytech" ? "Appointment" : "WorkOrder";
					appointment["ID"] = appointment.AppointmentID;
					appointment["ModifyDate"] = appointment.ModifyDate;
					appointment["TechDepartmentID"] = appointment.DepartmentName;
					appointment["TypeID"] = appointment.AppointmentTypeID;
  
					  //#endregion
					  assignedAppointmentElement = this.createSchedulerItemModel(appointment, element);
					  assignedAppointmentData.push(assignedAppointmentElement);
					  // create cache for drag and drop color
					  // assign workorder promise time attribute for already assigned scheduler data										
					  ////#region This section will add WoNumber attribute to only first row											
					  this.createCache(appointment);
				  });
				  }
			  }
			  });
  
			  this.data = <Object[]>extend([], assignedAppointmentData, null, true);
			  this.eventSettings.dataSource = this.data;
			  this.scheduleObj.eventSettings = this.eventSettings;
			  this.resetWorkOrderFilters(false);
			  this.isLoaded = 1;
			  this.isInitialDataLoaded.IsSchedulerDataLoaded=true;
			  this.hideLoader();
			  resolve(this.eventSettings);
		  }, (error) => {
			  if (error instanceof HttpErrorResponse) {
			  if (error.status != 403) {
				  this.toastr.error("Failed to load", "Error");
			  }
			  }
			  this.isLoaded = 1;
			  this.isInitialDataLoaded.IsSchedulerDataLoaded=true;
			  this.hideLoader();
		  });
		  this.subscriptions.push(subscription);
		  //#endregion
  
		  });
	  }
	  private setCustomDateTemplate() {
		  this.setFormatOptions();
		  this.filterSettings = {
		  type: 'Menu',
		  operators: {
			  stringOperator: [
			  { value: 'contains', text: 'Contains' },
			  { value: 'startswith', text: 'Starts With' },
			  { value: 'endswith', text: 'Ends With' },
			  { value: 'equal', text: 'Equal' },
			  { value: 'notequal', text: 'Not Equal' }
			  ]
		  }
		  };
		  this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
		  let self = this;
		  this.templateOptions = {
		  ui: {
			  create: (args: { target: Element, column: Object }) => {
			  if (args.target.previousSibling != undefined && args.target.previousSibling != null) {
				  args.target.previousSibling["style"]["visibility"] = "hidden";
				  args.target.previousSibling["style"]["height"] = "0px";
			  }
			  const divElem: HTMLElement = createElement('div', { className: 'div-elem' });
			  const flValInput: HTMLElement = createElement('input', { className: 'flm-input' });
			  const divElem1: HTMLElement = createElement('div', { className: 'div-elem1' });
			  const datepick1Input: HTMLElement = createElement('input', { className: 'date-input', attrs: { ['PlaceHolder']: 'Start Date' } });
			  datepick1Input.style.cssFloat = 'left';
			  const datepick2Input: HTMLElement = createElement('input', { className: 'date-input2', attrs: { ['PlaceHolder']: 'End Date' } });
			  datepick2Input.style.cssFloat = 'right';
			  if (isNullOrUndefined(self.datePicker1))
				  self.datePicker1 = new DatePicker({ change: (e) => { self.promiseStartDateFunction(e); } });
			  if (isNullOrUndefined(self.datePicker2))
				  self.datePicker2 = new DatePicker({ change: (e) => { self.promiseEndDateFunction(e); } });
			  if (isNullOrUndefined(self.dropInstance)) {
				  self.dropInstance = new DropDownList({
				  dataSource: new DataManager(self.dropDownData),
				  fields: { text: 'sname', value: 'sID' },
				  popupHeight: '200px',
				  change: (e) => self.promiseDateDropDownChange(e),
				  value: self.dropDownData.find(x => x["sname"] == "Custom")["sID"]
				  });
				  self.dm1 = self.dropDownData.find(x => x["sname"] == "Custom")["sID"];
				  args.target.appendChild(divElem);
				  divElem.appendChild(flValInput);
				  self.dropInstance.appendTo(flValInput);
				  args.target.appendChild(divElem1);// append datepicker controls wrapper div to popup
				  divElem1.appendChild(datepick1Input);// add date picker 1 wrapper input
				  self.datePicker1.appendTo(datepick1Input);
				  divElem1.appendChild(datepick2Input);// add date picker 2 wrapper input
				  self.datePicker2.appendTo(datepick2Input);
			  }
			  else {
				  setTimeout(() => {
				  args.target.appendChild(divElem);//append date type dropdown wrapper div to popup
				  divElem.appendChild(flValInput);
				  self.dropInstance.appendTo(flValInput);
				  self.dropInstance.popupHeight = "200px;";
				  args.target.appendChild(divElem1); //append datepicker controls wrapper div to popup
				  divElem1.appendChild(datepick1Input);
				  self.datePicker1.appendTo(datepick1Input);// add date picker 1 wrapper input
				  divElem1.appendChild(datepick2Input);
				  self.datePicker2.appendTo(datepick2Input);// add date picker 2 wrapper input
				  self.disableFilterButton();
				  }, 50);
			  }
			  if (!self.isPDateGridFilterActive) {
				  self.dropInstance.value = self.dm1 = self.dropDownData.find(x => x["sname"] == "Custom")["sID"];
				  self.setDefaultDatesForPDateFilter();
			  }
			  if (!isNullOrUndefined(self.dm1) && self.dm1 != "") {
				  self.dropInstance.value = self.dm1;
			  }
			  if (!isNullOrUndefined(self.dp1) && self.dp1 != "") {
				  self.datePicker1.value = self.dp1;
			  }
			  if (!isNullOrUndefined(self.dp2) && self.dp2 != "") {
				  self.datePicker2.value = self.dp2;
			  }
			  if (!$(divElem).hasClass("no-top-padding")) {
				  $(divElem).addClass("no-top-padding");
			  }
			  },
			  write: (args: {
			  column: Object, target: Element, parent: any,
			  filteredValue: number | string
			  }) => {
			  if (self.dropInstance.value == '4') {
				  self.datePicker1.readonly = false;
				  self.datePicker2.readonly = false;
			  }
			  self.dropInstance.value = self.dm1;
			  self.datePicker1.value = self.dp1;
			  self.datePicker2.value = self.dp2;
			  self.datePicker2.element.addEventListener("keyup", function (e) {
				  let updatedValue = Date.parse(self.datePicker2.element["value"])
				  if (isNaN(updatedValue)) {
				  self.disableFilterButton(true);
				  if (self.datePicker2.element["value"] == "") {
					  self.datePicker2.value = null;
				  }
				  }
				  else {
				  self.disableFilterButton((new Date(updatedValue)) < self.datePicker1.value);
				  }
			  });
			  self.datePicker1.element.addEventListener("keyup", function (e) {
				  let updatedValue = Date.parse(self.datePicker1.element["value"])
				  if (isNaN(updatedValue)) {
				  self.disableFilterButton(true);
				  if (self.datePicker1.element["value"] == "") {
					  self.datePicker1.value = null;
				  }
				  }
				  else {
				  self.disableFilterButton((new Date(updatedValue)) > self.datePicker2.value);
				  }
			  });
			  if (!$(".e-flmenu-valuediv").closest(".e-flmenu.e-filter-popup.e-popup-open").find(".e-flmenu-cancelbtn").hasClass("filter-Pdate"))
				  $(".e-flmenu-valuediv").closest(".e-flmenu.e-filter-popup.e-popup-open").find(".e-flmenu-cancelbtn").addClass("filter-Pdate");
			  },
			  read: (args: { target: Element, column: any, operator: string, fltrObj: Filter }) => {
			  self.dm1 = self.dropInstance.value;
			  self.dp1 = self.datePicker1.value;
			  self.dp2 = self.datePicker2.value;
			  let colFilter = [];
			  self.Grid.filterSettings.columns = self.Grid.filterSettings.columns.filter(x => x.field != "PDate");
			  switch (self.dropInstance.value) {
				  case this.dropDownData.find(x => x["sname"] == 'Today')["sID"]:
				  case this.dropDownData.find(x => x["sname"] == 'Tomorrow')["sID"]:
				  colFilter = [
					  { 'value': self.datePicker1.value, 'operator': 'equal', 'field': 'PDate' }
				  ];
				  self.Grid.filterSettings.columns = self.Grid.filterSettings.columns.concat(colFilter);
				  break;
				  case this.dropDownData.find(x => x["sname"] == 'This Week')["sID"]:
				  colFilter = [
					  { 'value': self.datePicker1.value, 'operator': 'greaterthanorequal', 'field': 'PDate', predicate: 'and' },
					  { 'value': self.datePicker2.value, 'operator': 'lessthanorequal', 'field': 'PDate', predicate: 'and' }
				  ];
				  self.Grid.filterSettings.columns = self.Grid.filterSettings.columns.concat(colFilter);
				  break;
				  case this.dropDownData.find(x => x["sname"] == 'Custom')["sID"]:
				  colFilter = [
					  { 'value': self.datePicker1.value, 'operator': 'greaterthanorequal', 'field': 'PDate', predicate: 'and' },
					  { 'value': self.datePicker2.value, 'operator': 'lessthanorequal', 'field': 'PDate', predicate: 'and' }
				  ];
				  self.Grid.filterSettings.columns = self.Grid.filterSettings.columns.concat(colFilter);
				  break;
				  default:
				  self.Grid.filterSettings.columns = [];
				  self.Grid.removeFilteredColsByField(args.target.id);
				  break;
			  }
			  self.isPDateGridFilterActive = true;
			  }
		  }
		  };
	  }
	  private createSchedulerItemModel(source: CommonAppointmentModel, element: any): any {
		  const aptDate = new Date(source.AppointmentDate);
		  const aptStartTime = source.AppointmentStartTime;
		  const aptEndTime = source.AppointmentEndTime;
		  const tech = this.TechnicianDataSource.find(x => x.ID == source.UserID);
		  //#region create and return work order model		  
		  source.StartTime = (new Date(aptDate.getFullYear(), aptDate.getMonth(), aptDate.getDate(), this.formatTime(aptStartTime, 0), this.formatTime(aptStartTime, 1))).toString();
		  source.EndTime = (new Date(aptDate.getFullYear(), aptDate.getMonth(), aptDate.getDate(), this.formatTime(aptEndTime, 0), this.formatTime(aptEndTime, 1))).toString();
		  source.TechID = source.UserID;
		  if (tech) {
			source.TechName = tech.DepartmentGroupID;
		  }
  
		  if ((!isNullOrUndefined(this.TechnicianMasterDataSource.filter((item: any) => item.ID == element.UserID)) && this.TechnicianDataSource.filter((item: any) => item.ID == element.UserID).length > 0)) {
			const tech_element = this.TechnicianMasterDataSource.filter((item: any) => item.ID == element.UserID)[0];
			source["TechDepartmentID"] = tech_element.DepartmentGroupID; // as json has no dept ID
			source["UserID"] = tech_element.ID;
			source["UserName"] = tech_element.Text;
			source["UserGroupID"] = tech_element.UserGroupID;
			source["DeptName"] = tech_element.DepartmentGroupID;
			source["UserPhone"] = tech_element.UserPhone;
		  }
		  return source;
		  //#endregion
	  }
	  
	  private setschedulerLoadingState() {
		  setTimeout(() => {
		  if (this.isDispatcherLoaded()) {
			  if (!(this.isNagivated == 2 || this.isNagivated == 1)) {
			  let selfRef = this;
			  if (this.firstTimeCodeCheck) {
				  this.firstTimeCodeCheck = false;
				  //#region Find all cells and add WorkTicketNumber attribute
				  selfRef.AssignWOAttribute().then(function () {
				  selfRef.hideLoaderWithAnimationToCurrentTime(selfRef);
				  });
				  //selfRef.hideLoaderWithAnimationToCurrentTime(selfRef);
				  //#endregion
			  }
			  else {
				  selfRef.hideLoader();
			  }
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setDispatcherAndGridMaxHeight();
			  }
		  }
		  else {
			  this.isLoaded = 0;
			  $('#Schedule').css('opacity', '0');
			  this.showLoader();
		  }
		  }, 200);
	  }
	  /**
	   * Set wo attributes to cells to handle color for same department, promise time
	   * */
	  private AssignWOAttribute()
	  {
		  let selfRef = this;
		  return new Promise(function (resolve, reject) {
		  selfRef.zone.runOutsideAngular(() => {
			  setTimeout(() => {
			  let woHtmlElements: any = $("td.e-work-cells[data-date]").not('.e-resource-group-cells');
			  for (let woElement of woHtmlElements) {
				  let timeint = parseInt($(woElement).attr('data-date'));
				  let groupIndex = $(woElement).attr('data-group-index');
				  let departmentID = GetDepartmentIdPipe.prototype.transform(groupIndex, selfRef.scheduleObj);
				  let userID = selfRef.scheduleObj.getResourcesByIndex(parseInt(groupIndex)).resourceData.ID;
				  const time: string = ((new Date(timeint).getHours()).toString().padStart(2, '0') + ":" + (new Date(timeint).getMinutes()).toString().padStart(2, '0') + ":00");
				  $(woElement).attr('time', time);
				  $(woElement).attr('dcID', departmentID);
				  $(woElement).attr('techID', userID.toLocaleString());
			  }
			  resolve('');
			  }, 200);
		  });
		  });
	  }
	  private animatteToCurrentTime(Ref: any) {
		  let selfRef = Ref;
		  selfRef.zone.runOutsideAngular(() => {
		  if (!isNullOrUndefined($('div.e-current-time').css('left'))) { // if today date and time exits , scroll it to there after animation
			  $('div.e-content-wrap').animate({ scrollLeft: (parseInt($('div.e-current-time').css('left').replace('px', '')) - 140) + 'px' }, {
			  duration: 500, complete: function () {
  
			  }
			  });
		  }
		  });
	  }
	  private hideLoaderWithAnimationToCurrentTime(Ref: any) {
		  let selfRef = Ref;
		  selfRef.zone.runOutsideAngular(() => {
		  if (!isNullOrUndefined($('div.e-current-time').css('left'))) { // if today date and time exits , scroll it to there after animation
			  $('div.e-content-wrap').animate({ scrollLeft: (parseInt($('div.e-current-time').css('left').replace('px', '')) - 140) + 'px' }, {
			  duration: 500, complete: function () {
				  selfRef.hideLoader();
			  }
			  });
		  }
		  else {
			  selfRef.hideLoader();
		  }
		  });
	  }
	  private hideLoader() {
		  if (this.isInitialDataLoaded.IsCompanyDataLoaded && this.isInitialDataLoaded.IsSchedulerDataLoaded && this.isLoaded == 1) // when dispatcher is not loaded properly during tab change then let loader visible and scheduler hidden for next time current tab focus
		  {
		  setTimeout(() => {
			  this.zone.runOutsideAngular(() => {
			  $('.schedule-outercontainer').find('.fs-circle-container').hide();
			  $('#Schedule').css('opacity', '1');
			  });
		  }, 50);
		  }
	  }
	  private showLoader() {
		  this.zone.runOutsideAngular(() => {
		  $('.schedule-outercontainer').find('.fs-circle-container').show();
		  });
	  }
	  private isDispatcherLoaded(): boolean {
		  /** Using the max-height to check if dispatcher is loaded properly or not.  */
		  if (this.TechnicianDataSourceWithEmpty.length == 1)
		  return true;
		  let cellelement;
		  let widthOfCell: number = 70;
		  let timeHeaderelement;
		  let widthOftimeHeader: number = 70;
		  if ($('td.e-work-cells').length > 0) {
		  cellelement = $('td.e-work-cells')[0];
		  widthOfCell = $(cellelement).width();
		  }
		  if ($('.e-time-slots').length > 0) {
		  timeHeaderelement = $('.e-time-slots')[0];
		  widthOftimeHeader = $(timeHeaderelement).width();
		  }
  
		  //#region TimeLine error handled
		  let isTimelineLoaded: boolean = true;
		  let currentTimeLabel: any = $('.e-current-time');
		  let currentTimeLine: any = $('.e-current-timeline');
		  if (!isNullOrUndefined(currentTimeLabel) && !isNullOrUndefined(currentTimeLine)) {
		  if (!isNullOrUndefined($($('.e-current-time')).css('left')) &&
			  !isNullOrUndefined($($('.e-current-time')).css('width')) &&
			  !isNullOrUndefined($($('.e-current-timeline')).css('left'))) {
			  let leftBorder_timeline: number = parseInt($($('.e-current-time')).css('left').replace("px", ""));
			  let rightBorder_timeline: number = parseInt($($('.e-current-time')).css('left').replace("px", "")) + parseInt($($('.e-current-time')).css('width').replace("px", ""));
			  let position_timeline: number = parseInt($($('.e-current-timeline')).css('left').replace("px", ""));
			  if (position_timeline < leftBorder_timeline || position_timeline > rightBorder_timeline) {
			  isTimelineLoaded = false;
			  }
		  }
		  }
		  //#endregion
		  if ($(".e-resource-column-wrap").css("max-height") == "0px" ||
		  (!isNullOrUndefined(cellelement) && widthOfCell < 50) ||
		  (!isNullOrUndefined(timeHeaderelement) && widthOftimeHeader < 50) ||
		  !isTimelineLoaded
		  ) {
		  return false;
		  }
		  else {
		  return true;
		  }
	  }
	  private RefreshDispatchBoard() {
		  $('#Schedule').css('opacity', '0');
		  this.showLoader();
		  this.isNagivated = 0;
		  this.firstTimeCodeCheck = true;
		  this.scheduleObj.refresh();
		  this.Grid.refresh(); // refresh grid to avoid row expand issue
	  }
	  private checkOnlyEndTimeEdited(previousCellData: any, newCellData: any): boolean {
		  let result: boolean = true;
		  for (var [key, value] of Object.entries(previousCellData)) {
		  if (key != "EndTime") {
			  if (newCellData[key] != value) {
			  result = false;
			  break;
			  }
		  }
		  }
		  return result;
	  }
	  private removeWorkOrder(ID: any) {
		  return new Promise((resolve, reject) => {
		  this.showLoader();
		  let subscription = this.httpService.DeleteDispatchWorkOrder(ID).subscribe(
			  () => {
			  let schedulerDataSource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
			  let removeIndex = schedulerDataSource.findIndex(item => item.ID == ID);
			  schedulerDataSource.splice(removeIndex, 1); // new datasource for scheduler					
			  this.scheduleObj.eventSettings.dataSource = schedulerDataSource;
			  this.scheduleObj.refreshEvents();
			  this.hideLoader();
			  resolve(true);
			  },
			  error => {
			  this.hideLoader();
			  reject(error);
			  }
		  );
		  this.subscriptions.push(subscription);
		  });
	  }
	  private validateUpdateRequest(data: any) {
		  let form: FormGroup = this.InitializeEditEventForm(data);
		  if (form.invalid) {
		  return false;
		  }
		  else {
		  return true;
		  }
	  }
	  private updateWorkOrder(data: any) {
		  // before update validate required fields // which are required in editing popup
		  return new Promise((resolve, reject) => {
		  if (!this.validateUpdateRequest(data)) // before update check data validation // catches error if wo dragged from grid to scheduler but still some invalid value
		  {
			  this.toastr.error(Constants.CustomToastMessages_Dispatcher().WOInvalidData, "Error");
			  resolve("invalid data")
		  }
		  else {
			  let submitmodel = Object.assign({}, data);
			  submitmodel["TypeID"] = this.TypeID_Static;
			  submitmodel["AppointmentTypeCode"] = "Work Order";
			  submitmodel["EndTime"] = (new Date(data.EndTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(data.EndTime).getMinutes().toString().padStart(2, '0')) + ":00";
			  submitmodel["StartTime"] = (new Date(data.StartTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(data.StartTime).getMinutes().toString().padStart(2, '0')) + ":00";
			  // prmise date same as start date as it will update on change of day
			  submitmodel["PromDate"] = (new Date(data.StartTime).getFullYear().toString()) + "-" + ((new Date(data.StartTime).getMonth() + 1).toString().padStart(2, '0')) + "-" + (new Date(data.StartTime).getDate().toString().padStart(2, '0')) + "T00:00:00";
			  let subscription = this.httpService.UpdateDispatchWorkOrder(submitmodel).subscribe(
			  response => {
				  this.updatescheduler(response, data);
				  let schedulerDatasource: any = this.scheduleObj.eventSettings.dataSource;
				  let index = schedulerDatasource.findIndex((item: any) => item.WorkTicketNumber === response.WorkTicketNumber);
				  schedulerDatasource[index]["ModifyDate"] = response["ModifyDate"];
				  resolve({ message: "success", response: response });
			  },
			  error => {
				  reject(error);
			  }
			  );
			  this.subscriptions.push(subscription);
		  }
		  });
	  }
	  private disableFilterButton(isDisable: boolean = false) {
		  if (document.getElementsByClassName('e-flmenu-okbtn e-primary e-flat').length > 0) {
		  const btn = (document.getElementsByClassName('e-flmenu-okbtn e-primary e-flat')[0] as any).ej2_instances[0];
		  btn.disabled = isDisable;
		  }
	  }
	  private isTimeSlotAvailable(cellData: any): boolean {
		  let returnResult: boolean = true;
		  // check event data clash
		  let userid_Of_draggedEvent: string = '';
		  if (isNullOrUndefined(cellData.groupIndex)) {
		  userid_Of_draggedEvent = cellData.UserID; // dragged assigned wo inside scheduler as it already contains UserID
		  }
		  else {
		  let resourceDetails: ResourceDetails = this.scheduleObj.getResourcesByIndex(cellData.groupIndex);
		  userid_Of_draggedEvent = resourceDetails.resourceData.ID.toString(); // when dragged from outside scheduler, need to check UserID from groupindex
		  }
		  if (this.scheduleObj.eventsData.length > 0) {
		  this.scheduleObj.eventsData.forEach((element: any) => {
			  if (!(isNullOrUndefined(element.EndTime) || isNullOrUndefined(element.StartTime))) {
			  if (element.EndTime > element.StartTime) // to avoid wrong data with end time less that start time
			  {
				  if (
				  ((!isNullOrUndefined(cellData.ID) && cellData.ID != element.ID) || // to avoid self check in case of drag inside scheduler
					  (isNullOrUndefined(cellData.ID))) && element.UserID == userid_Of_draggedEvent
				  ) {
				  // to avoid checking with itself as it is in the case of editing
				  if (
					  ((cellData.StartTime > (element.StartTime as Date) && cellData.StartTime < (element.EndTime as Date)) ||
					  (cellData.EndTime > (element.StartTime as Date) && cellData.EndTime < (element.EndTime as Date)) ) && (element.EstimateConvertedToID != cellData.WorkTicketID)
				  ) {
					  returnResult = false;
				  } else if (
					  (cellData.StartTime <= (element.StartTime as Date) &&
					  cellData.EndTime >= (element.EndTime as Date)) && (element.EstimateConvertedToID != cellData.WorkTicketID)
				  ) {
					  returnResult = false;
				  }
				  }
			  }
			  }
		  });
		  } else {
		  returnResult = true;
		  }
		  // check block data clash
		  if (returnResult) {
		  // check block data only if event data do not overlap
		  if (this.scheduleObj.blockData.length > 0) {
			  this.scheduleObj.blockData.forEach((element: any) => {
			  if (
				  (element.UserID == userid_Of_draggedEvent)
			  ) {
				  if (!(isNullOrUndefined(element.EndTime) || isNullOrUndefined(element.StartTime))) {
				  if (element.EndTime > element.StartTime) // to avoid wrong data with end time less that start time
				  {
					  if (
					  (cellData.StartTime > (element.StartTime as Date) && cellData.StartTime < (element.EndTime as Date)) ||
					  (cellData.EndTime > (element.StartTime as Date) && cellData.EndTime < (element.EndTime as Date))
					  ) {
					  returnResult = false;
					  } else if (
					  cellData.StartTime <= (element.StartTime as Date) &&
					  cellData.EndTime >= (element.EndTime as Date)
					  ) {
					  returnResult = false;
					  }
				  }
				  }
			  }
			  });
		  } else {
			  returnResult = true;
		  }
		  }
		  return returnResult;
	  }
	  private sortByKey(array, key: string) {
		  let sortedData = array.sort((a, b) => a[key].localeCompare(b[key]));
		  return sortedData;
	  }
	  private getColorAsperState(data: any): [number, number, number] {
		  let data_State: string = (data.WorkTicketStatusCode!=null)? data.WorkTicketStatusCode.toLowerCase().replace(/ /g, ''):"";
		  let data_SubState: string = (data.WorkTicketSubStatusCode!=null)?data.WorkTicketSubStatusCode.toLowerCase().replace(/ /g, ''):"";
		  switch (data_State) {
		  case Constants.WOStaticStatus().open: {
			  switch (data_SubState) {
			  case Constants.WOStaticStatus().assigned: {
				  return [255, 255, 0];// "#ffff00"; // 255,255,0
			  }
			  case Constants.WOStaticStatus().dispatched: {
				  return [146, 208, 80];// "#92d050"; // 146,208,80
			  }
			  case Constants.WOStaticStatus().techreceived: {
				  return [84, 130, 53]; //"#548235"; //84,130,53
				  break;
			  }
			  case Constants.WOStaticStatus().working: {
				  return [255, 192, 0];// "#ffc000"; // 255,192,0//
			  }
			  }
			  break;
		  }
		  case Constants.WOStaticStatus().completed: {
			  switch (data_SubState) {
			  case Constants.WOStaticStatus().readyforreview: {
				  return [155, 194, 230]; //"#9bc2e6"; // 155,194,230
			  }
			  case Constants.WOStaticStatus().posted: {
				  return [156, 91, 205]; //"#9c5bcd"; // 156,91,205
			  }
			  }
			  break;
		  }
		  case Constants.WOStaticStatus().actionrequired: {
			  switch (data_SubState) {
			  case Constants.WOStaticStatus().partsneeded: {
				  return [255, 87, 87]; //"#ff5757"; //255,87,87
			  }
			  case "postingfailure": {
				  return [255, 0, 0]; //"#ff0000"; // 255,0,0
			  }
			  case Constants.WOStaticStatus().rescheduled: {
				  return [255, 87, 87]; //"#ff5757"; //255,87,87
			  }
			  }
			  break;
		  }
		  default: {
			  return [242, 201, 201]; //"#f2c9c9"; //242,201,201
		  }
  
		  }
	  }
	  /**
	   * Used for both work order and helper appointments
	   * @param StatusCode
	   * @param SubStatusCode
	   */
	  private SetAppointmentEditableStatus(StatusCode, SubStatusCode): boolean {
		  this.isCurrentWOBlocked = false;
		  if (StatusCode != null && SubStatusCode != null) {
		  const status = (StatusCode.toLowerCase().replace(/ /g, ''));
		  const substate = (SubStatusCode.toLowerCase().replace(/ /g, ''));
			  switch (status) {
			  case Constants.WOStaticStatus().open:
				  this.isCurrentWOBlocked = substate == Constants.WOStaticStatus().dispatched || substate == Constants.WOStaticStatus().techreceived || substate.replace(" ", "") == Constants.WOStaticStatus().techreceived || substate == Constants.WOStaticStatus().working;// for tech received replaced space exceptionally to sync with api response, not changed in constants as its used at other forms
				  break;
			  case Constants.WOStaticStatus().actionrequired:
				  this.isCurrentWOBlocked = substate == Constants.WOStaticStatus().postingfailure;
				  break;
			  case Constants.WOStaticStatus().completed:
				  this.isCurrentWOBlocked = substate == Constants.WOStaticStatus().readyforreview || substate == Constants.WOStaticStatus().posted;
				  break;
			  }
		  }
		  return this.isCurrentWOBlocked;
	  }
	  private updatescheduler(updatedData: any, resourceData: any = null) {
		let schedulerDataSource = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
		const removeIndex = schedulerDataSource.findIndex(item => item.ID == updatedData.ID);
		if (!isNullOrUndefined(removeIndex)) // remove only when it exists
			schedulerDataSource.splice(removeIndex, 1); // new datasource for scheduler
			
		const cellResourceData = (isNullOrUndefined(resourceData) ? updatedData : resourceData);
		let aptModel = this.createSchedulerItemModel(updatedData, cellResourceData);
		if (!CommonMethods.CheckNullOrUndefined(updatedData.AppointmentTypeCode)
		    && updatedData.AppointmentTypeCode == "PrimaryTech") {
			aptModel.EventType = "WorkOrder";
	    } else {
			this.UpdateSchedulerSourceForHelper(aptModel);
		}
		schedulerDataSource.push(Object.assign({}, aptModel));
		this.scheduleObj.eventSettings.dataSource = schedulerDataSource;
		this.scheduleObj.refreshEvents();
	  }
	  private setDefaultDatesForPDateFilter() {
		  let currentDate = new Date();
		  let milliSec = currentDate.setHours(0, 0, 0, 0);
		  this.dp1 = currentDate;
  
		  let tomorrowDate = (new Date(milliSec + 86400000));
		  this.dp2 = tomorrowDate;
	  }
	  //utilities function used in template
	  // public getTimeString(value: Date): string {
	  // 	return this.instance.formatDate(value, { skeleton: 'hm' });
	  // }
	  //utilities function used in template
	  private getDateString(value: Date): string {
		  return this.instance.formatDate(value, { skeleton: 'yMd' });
	  }
	  private InitializeEditEventForm(obj = null) {
		  let form: FormGroup = null;
		  if (!isNullOrUndefined(obj)) {
		  let promiseData = this.PromisedTime_Data;
		  let PriorityData = this.Priority_Data;
		  let DurationHour: number = 0;
		  let DurationMin: number = 0;
		  if (!isNullOrUndefined(obj.EndTime) && !isNullOrUndefined(obj.StartTime)) {
			  if (new Date(obj.EndTime).getHours() >= new Date(obj.StartTime).getHours()) {
			  let datedifference = (new Date(obj.EndTime).getTime() - new Date(obj.StartTime).getTime());
			  DurationHour = Math.floor((datedifference / 60000) / 60);
			  DurationMin = Math.floor((datedifference / 60000) % 60);
			  }
			  else {
			  DurationHour = 0;
			  DurationMin = 30;
			  }
		  }
		  else {
			  DurationHour = 0;
			  DurationMin = 30;
		  }
		  form = new FormGroup({
			  ID: new FormControl(obj.ID),
			  WorkTicketID: new FormControl(obj.WorkTicketID),
			  TechDepartmentID: new FormControl(obj.TechDepartmentID),
			  WorkTicketNumber: new FormControl(obj.WorkTicketNumber),
			  CustomerID: new FormControl(obj.CustomerID),
			  JobSiteID: new FormControl(obj.JobSiteID),
			  EventType: new FormControl(obj.EventType, [Validators.required, this.CustomEventTypeValidator]),
			  StartTime: new FormControl(new Date(obj.StartTime), [
			  Validators.required,
			  this.CustomDateValidator,
			  this.EventOneDayTimeValidator
			  ]),
			  EndTime: new FormControl(new Date(obj.EndTime), [
			  this.CustomDateValidator,
			  this.EventOneDayTimeValidator
			  ]),
			  DispComment: new FormControl(obj.DispComment),
			  UserGroupID: new FormControl(obj.UserGroupID, [Validators.required, this.CustomTechnicianTypeValidator]),
			  UserID: new FormControl(obj.UserID, [Validators.required]),
			  Priority: new FormControl(obj.Priority),
			  PriorityID: new FormControl(obj.PriorityID, [Validators.required, this.CustomPriorityIDValidator(PriorityData)]),
			  AppointmentDate: new FormControl(obj.AppointmentDate, [Validators.required, this.CustomDateValidator]),
			  PromID: new FormControl(obj.PromID, [Validators.required, this.CustomPromIDValidator(promiseData)]),
			  DurationHour: new FormControl(DurationHour, [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
			  DurationMin: new FormControl(DurationMin, [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
			  ModifyDate: new FormControl(obj.WorkTicketModifyDate, [Validators.required])
		  });
		  }
		  else {
		  form = new FormGroup({
			  ID: new FormControl(""),
			  WorkTicketID: new FormControl(""),
			  TechDepartmentID: new FormControl(""),
			  WorkTicketNumber: new FormControl("", [Validators.required]),
			  CustomerID: new FormControl(""),
			  JobSiteID: new FormControl(""),
			  EventType: new FormControl("", [Validators.required, this.CustomEventTypeValidator]),
			  StartTime: new FormControl("", [this.CustomDateValidator, this.EventOneDayTimeValidator]),
			  EndTime: new FormControl("", [this.CustomDateValidator, this.EventOneDayTimeValidator]),
			  DispComment: new FormControl("", [Validators.required]),
			  UserGroupID: new FormControl("", [Validators.required, this.CustomTechnicianTypeValidator]),
			  UserID: new FormControl("", [Validators.required]),
			  Priority: new FormControl("", [Validators.required]),
			  AppointmentDate: new FormControl("", [Validators.required, this.CustomDateValidator]),
			  PromID: new FormControl("", [Validators.required]),
			  PriorityID: new FormControl("", [Validators.required]),
			  DurationHour: new FormControl('0', [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
			  DurationMin: new FormControl('30', [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
			  ModifyDate: new FormControl('', [Validators.required])
		  });
		  }
		  return form;
	  }
	  /**
	   * Initialise appointment form
	   * @param obj
	   */
	  private InitAppointmentForm(obj = null) {
		  let IsObjNull = CommonMethods.CheckNullOrUndefined(obj, true);
		  this.ApptType_Data_filterd = this.BindAPTFilterValues(['timeoff', 'meeting', 'other'])
		  let form: FormGroup = null;
		  form = new FormGroup({
		  AppointmentDate: new FormControl(!IsObjNull ? new Date(obj.AppointmentDt) : "", [Validators.required, this.CustomDateValidator]),
		  AppointmentModifyDate: new FormControl(!IsObjNull ? obj.AppointmentModifyDate : ""),
		  AppointmentNote: new FormControl(!IsObjNull ? obj.AppointmentNote : ""),
		  AppointmentStatusID: new FormControl(!IsObjNull ? obj.AppointmentStatusID : ""),
		  AppointmentSubStatusID: new FormControl(!IsObjNull ? obj.AppointmentSubStatusID : ""),
		  AppointmentTypeID: new FormControl(!IsObjNull ? obj.TypeID : "", Validators.required),
		  DurationHour: new FormControl(!IsObjNull ? obj.DurationHour : "1", [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
		  DurationMin: new FormControl(!IsObjNull ? obj.DurationMin : "00", [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
		  ID: new FormControl(!IsObjNull ? obj.ID : CommonMethods.GetID()),
		  IsNew: new FormControl(IsObjNull ? true : false),
		  IsSchedule: new FormControl(!IsObjNull && !CommonMethods.CheckNullOrUndefined(obj.IsSchedule) ? obj.IsSchedule : false),
		  Priority: new FormControl(!IsObjNull ? obj.Priority : ""),
		  PriorityID: new FormControl(!IsObjNull ? obj.PriorityID : ""),
		  PromID: new FormControl(!IsObjNull ? obj.PromID : ""),
		  StartTime: new FormControl(new Date(!IsObjNull ? obj.StartTime : "00"), [Validators.required, this.CustomDateValidator, this.EventOneDayTimeValidator]),
		  TechDepartmentID: new FormControl(!IsObjNull ? obj.TechDepartmentID : ""),
		  UserID: new FormControl(!IsObjNull ? obj.TechID : "", [this.BlankTechValidator]),
		  WorkTicketID: new FormControl(!IsObjNull ? obj.WorkTicketID : ""),
		  WorkTicketNumber: new FormControl(!IsObjNull ? obj.WorkTicketNumber : ""),
		  EstimateID: new FormControl((!IsObjNull && obj.EstimateID)? obj.EstimateID : ""),
		  EstimateConvertedToID: new FormControl((!IsObjNull && obj.EstimateConvertedToID)? obj.EstimateConvertedToID : "")
		  });
		  return form;
	  }
	  private async LoadCompanyData() {
		  this.showLoader();
		  let subscription = await this.httpCommon.GetIntialData(this.auth.getCompanyId(),
		  "PromisedTimes,ServiceTypes,Departments,workticketprioritylookup,codetypedata")
		  .subscribe(response => {
			  this.initialData = response;
			  this.Priority_Data =
			  response.WorkTicketPriorityLookup != null
				  ? response.WorkTicketPriorityLookup.filter(x => x.IsActive)
				  : [];
			  this.PromisedTime_Data =
			  response.PromisedTimes != null
				  ? response.PromisedTimes.filter(x => x.IsActive)
				  : [];
  
			  this.ServiceTypeFilterDataSource = response["ServiceTypes"] != null ? response["ServiceTypes"].map(x => {
			  return {
				  value: x.Name.replace(/ +/g, "_"),
				  name: x.Name
			  }
			  }) : [];
			  
			  this.ApptType_Data =
			  !CommonMethods.CheckNullOrUndefined(response.CodeTypeData, true) && !CommonMethods.CheckNullOrUndefined(response.CodeTypeData.AppointmentType)
				  ? response.CodeTypeData.AppointmentType.filter(x => x.Code != "PrimaryTech")
				  : [];
  
			  this.ApptType_Data_filterd = this.BindAPTFilterValues(['timeoff', 'meeting', 'other'])
  
  
			  this.primaryTechCodeType = response.CodeTypeData.AppointmentType.filter(x => x.Code == "PrimaryTech");
			  
			  this.filter_APT_Types = [];
			  this.filter_APT_Types.push({ ID: 0, Name: "Work Order", Code: 'workorder' });
			  this.filter_APT_Types = this.filter_APT_Types.concat(this.BindAPTFilterValues(['helper', 'timeoff', 'meeting', 'other', 'estimate']));
  
			  this.PrioritiesDataSource = [];
			  this.CustomerType = [];
			  if (!isNullOrUndefined(response.WorkTicketPriorityLookup)) {
			  response.WorkTicketPriorityLookup.forEach((element: any) => {
				  if (this.PrioritiesDataSource.findIndex(item => item["Text"] == element.Name) < 0) // priority as per work order
				  {
				  if (!isNullOrUndefined(element.Name) && element.Name != '' && element.IsActive == true)
					  this.PrioritiesDataSource.push({ Text: element.Name, ID: element.ID }); // fill master priority data
				  }
			  });
			  }
			  if (!isNullOrUndefined(response.CodeTypeData.CustomerType)) {
			  response.CodeTypeData.CustomerType.forEach((element: any) => {
				  if (this.CustomerType.findIndex(item => item["ID"] == element.ID) < 0) // priority as per work order
				  {
				  if (!isNullOrUndefined(element.ID) && element.ID != '')
					  this.CustomerType.push({ Text: element.Name, ID: element.ID }); // fill master priority data
				  }
			  });
			  }
			  this.checkCompanyDataLoaded = true;
			  this.isInitialDataLoaded.IsCompanyDataLoaded=true;
			  this.hideLoader();
		  }, () => {
			  // error loading company data
			  this.checkCompanyDataLoaded = false;
			  this.isInitialDataLoaded.IsCompanyDataLoaded=true;
			  this.hideLoader();
		  });
		  this.subscriptions.push(subscription);
	  }
	  private async InitializeSchedulerData(startDate: Date, endDate: Date = null, IsRefreshAll: boolean = false) {
		  this.showLoader();
		  let defaultStartDate = startDate;
		  let defaultEndDate = endDate == null ? startDate : endDate;
		  let filter_startdate = defaultStartDate.getFullYear().toString() + "-" + (defaultStartDate.getMonth() + 1).toString() + "-" + (defaultStartDate.getDate()).toString();
		  let filter_enddate = defaultEndDate.getFullYear().toString() + "-" + (defaultEndDate.getMonth() + 1).toString() + "-" + (defaultEndDate.getDate()).toString();
		  let filters: SchedulerFilter[] = [
		  {
			  field: "StartDate",
			  value: filter_startdate + "T00:00:00"
		  },
		  {
			  field: "EndDate",
			  value: filter_enddate + "T23:59:59"
		  }
		  ];
		  await this.fetchSchedulerData(filters, IsRefreshAll).then(() => {
		  this.eventSettings.dataSource = this.data;
		  // subchild grid rows
		  this.scheduleObj.eventSettings = this.eventSettings;
		  this.scheduleObj.refresh();
		  this.FilteredTechnicianDataSource = this.sortByKey(this.TechnicianMasterDataSource, "Text");
		  }).catch(() => {
		  });
	  }
	  private setFormatOptions() {
		  this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
	  }
	  private NoGroupingData() {
		  this.isNagivated = 0;
		  this.scheduleObj.group = this.NoGrouping;
		  this.firstTimeCodeCheck = true;
		  this.scheduleObj.refresh();
		  this.chckWorkOrder = true;
		  this.hideDepartmentCheck = true;
	  }
	  private ByDepartment() {
		  this.scheduleObj.group = this.GroupModelDepartment;
		  this.firstTimeCodeCheck = true;
		  this.scheduleObj.refresh();
		  this.chckWorkOrder = true;
		  this.hideDepartmentCheck = false;
	  }
	  private ByTechType() {
		  this.scheduleObj.group = this.GroupModelTech;
		  this.firstTimeCodeCheck = true;
		  this.scheduleObj.refresh();
		  this.chckWorkOrder = true;
	  }
	  private comparePromisedDate(draggedData_PromDate: any, cellData_StartTime: any) {
		  if (!(isNullOrUndefined(draggedData_PromDate) || isNullOrUndefined(draggedData_PromDate))) {
		  let draggedDay = new Date(draggedData_PromDate).getDate();
		  let draggedMonth = new Date(draggedData_PromDate).getMonth();
		  let draggedYear = new Date(draggedData_PromDate).getFullYear();
		  let cellDataDay = new Date(cellData_StartTime).getDate();
		  let cellDataMonth = new Date(cellData_StartTime).getMonth();
		  let cellDataYear = new Date(cellData_StartTime).getFullYear();
		  if (draggedDay == cellDataDay && draggedMonth == cellDataMonth && draggedYear == cellDataYear) {
			  return true;
		  }
		  else {
			  return false;
		  }
		  }
		  else {
		  return true; // if null then allow to drag
		  }
	  }
	  private checkSchedulerCellWithinPromisedTime(PromBeginTime: any, PromEndTime: any, cellTime: any) // celltime is starttime of cell
	  {
		  if (!(isNullOrUndefined(PromBeginTime) || isNullOrUndefined(PromEndTime) || isNullOrUndefined(cellTime))) {
		  if (!(PromBeginTime.toString().indexOf(':') < 0 || PromEndTime.toString().indexOf(':') < 0)) {
			  let PST_Array = PromBeginTime.split(":"); // split it at the colons
			  let PET_Array = PromEndTime.split(":"); // split it at the colons
			  let PST_Hour = PST_Array[0];
			  let PST_Minute = PST_Array[1];
			  let PET_Hour = PET_Array[0];
			  let PET_Minute = PET_Array[1];
  
			  let box_time_Hour = new Date(cellTime.toString()).getHours();
			  let box_time_Minutes = new Date(cellTime.toString()).getMinutes();
			  if (
			  (box_time_Hour >= PST_Hour &&
				  box_time_Hour < PET_Hour &&
				  (PST_Minute < 30 || (box_time_Minutes == 30 && PST_Minute >= 30))) || // starting box
			  (box_time_Hour == PET_Hour && box_time_Minutes < PET_Minute && box_time_Hour != PST_Hour) || // ending box
			  (box_time_Hour > PST_Hour &&
				  box_time_Hour < PET_Hour &&
				  box_time_Hour != PST_Hour &&
				  box_time_Hour != PET_Hour) || // between boxes
			  (box_time_Hour == PST_Hour && box_time_Hour == PET_Hour && box_time_Minutes < PET_Minute) // start and end same box
			  ) {
			  return true;
			  }
			  else
			  return false;
		  }
		  else
			  return false;
		  }
		  return false;
	  }
	  private promiseStartDateFunction(e) {
		  const e1 = e.value;
		  let isDateExists = !isNullOrUndefined(e.value);
		  let isOperatorSelected = this.dropInstance.value != "" && this.dropInstance.value != null;
		  let isValidDate = e1 <= this.datePicker2.value;
		  this.disableFilterButton(!(isDateExists && isValidDate && isOperatorSelected));
	  }
	  private promiseEndDateFunction(e) {
		  const e1 = ((document.getElementsByClassName('e-input e-keyboard')[0] as any).ej2_instances[0]).value;
		  const e2 = e.value;
		  this.disableFilterButton(e1 > e2 || (this.dropInstance.value == null || this.dropInstance.value == ''));
	  }
	  private schedulerElementInsert() {
		  let defaultStartDate = this.scheduleObj.selectedDate;
		  let defaultEndDate = new Date(this.scheduleObj.selectedDate);
		  if (!isNullOrUndefined(this.scheduleObj.timelineViewsModule.renderDates)) {
		  if (this.scheduleObj.timelineViewsModule.renderDates.length > 0) {
			  defaultStartDate = this.scheduleObj.timelineViewsModule.renderDates[0];
			  defaultEndDate = this.scheduleObj.timelineViewsModule.renderDates[this.scheduleObj.timelineViewsModule.renderDates.length - 1];
		  }
		  }
		  else {
		  if (this.scheduleObj.currentView.toString() == "TimelineWeek" || this.scheduleObj.currentView.toString() == "Week") {
			  defaultEndDate.setDate(defaultStartDate.getDate() + 6);
		  }
		  }
		  let filter_startdate = defaultStartDate.getFullYear().toString() + "-" + (defaultStartDate.getMonth() + 1).toString() + "-" + (defaultStartDate.getDate()).toString();
		  let filter_enddate = defaultEndDate.getFullYear().toString() + "-" + (defaultEndDate.getMonth() + 1).toString() + "-" + (defaultEndDate.getDate()).toString();
		  let filters: SchedulerFilter[] = [
		  {
			  field: "StartDate",
			  value: filter_startdate + "T00:00:00"
		  },
		  {
			  field: "EndDate",
			  value: filter_enddate + "T23:59:59"
		  }
		  ];
		  var self = this;
		  let currentTime = new Date();
		  let tempcurrentUTCDate = new Date(currentTime.getUTCFullYear(), currentTime.getUTCMonth(), currentTime.getUTCDate(), currentTime.getUTCHours(), currentTime.getUTCMinutes(), currentTime.getUTCSeconds());
		  let formattedLastSyncDate = this.datePipe.transform(self.lastSyncDate, "yyyy-MM-dd HH:mm:ss");
		  self.isRefreshInProgress = true;
		  //#region Appointments delta fetch
		  let subscription1 = this.httpService.GetDispatchData_New(filters, true, formattedLastSyncDate).subscribe(response => {
		  response.Users.forEach((element: WorkOrderTechnician) => { 
			  if (!isNullOrUndefined(element.Apppointments)) {
			  if (element.Apppointments.length > 0) {
				element.Apppointments.forEach((x: any) => {
					let index = self.data.findIndex(y => y.ID == x.AppointmentID);
					switch (x.Action) {
					case 'R':
						if (index != -1) {
							self.data.splice(index, 1);
							// close quick into template where unassigned (Removed)
							if (!isNullOrUndefined(x.AppointmentID)) {
								if (this.openAppointmentID == x.AppointmentID) {
									this.closeQuickInfo();
								}
							}
							this.RemoveHelperFromWO(x.AppointmentID);
						}
						break;
					case 'U':
						//#region set required data
						if (x["AppointmentTypeCode"] == "Helper") {
							x["EventType"] = "Appointment";
						}
						else if (x["AppointmentTypeCode"] == "PrimaryTech") {
							x["EventType"] = "WorkOrder";
						}
						else {
							x["EventType"] = "Appointment";
						}
						
						x["DeptName"] = x.DepartmentName;
						x["DepartmentID"] = x.DepartmentName;
						x["TechDepartmentID"] = x.DepartmentName;
						x["ID"] = x.AppointmentID;
						x["TypeID"] = x.AppointmentTypeID;
						x["AppointmentModifyDate"] = x.AppointmentModifyDate;
						x["WorkTicketModifyDate"] = x.WorkTicketModifyDate;
						x["AppointmentDt"] = x.AppointmentDate;
						x["AppointmentTypeCode"] = x.AppointmentTypeCode;
						//#endregion
						const aptModel = self.createSchedulerItemModel(x, element);
						if (index != -1) {
							self.data.splice(index, 1, aptModel);
							delete this.TimeSearchingArray_Cache[aptModel["WorkTicketNumber"]];
						}
						else {
							self.data.push(aptModel);
						}
						this.createCache(aptModel);
						//#region refresh quick info popup
						if (this.showWOQuickInfo && this.openAppointmentID == x.AppointmentID) {
							this.getCurrentWOData(x);
						}
						else if ((this.showHelperQuickInfo || this.showAPTQuickInfo || this.showEstimateQuickInfo) && this.openAppointmentID == x.AppointmentID) {
							let args = Object.assign({}, { data: x });
							this.templatedata = this.GetAppointmentQuickInfo(args);
						}
						//#endregion
						
						break;
					default:
						break;
					}
				});
			  }
			  }
		  });
		  if (response.Users.length > 0) {
			  self.eventSettings.dataSource = self.data;
			  if (self.scheduleObj.activeView != null) {
			  	self.scheduleObj.refreshEvents();
			  }
		  }
		  response.UnAssignedWorkOrders.forEach(x => {
			  let index = self.field.findIndex(y => y.WorkTicketID == x.WorkTicketID);
			  switch (x.Action) {
			  case 'R':
				  if (index != -1)
				  self.field.splice(index, 1);
				  break;
			  case 'U':
				  //#region updating properties
				  x.PDate = new Date(x.PromDate);
				  x.WorkTicketStatusName = this.appointmentStatePipe.transform(x.WorkTicketStatusID, 'state');
				  x.WorkTicketSubStatusName = this.appointmentStatePipe.transform(x.WorkTicketSubStatusID, 'substate');
				  //#endregion
				  if (index != -1) {
				  self.field.splice(index, 1, x);
				  delete this.TimeSearchingArray_Cache[x["WorkTicketNumber"]];
				  }
				  else {
				  self.field.push(x);
				  }
				  this.createCache(x);
				  break;
			  default:
				  break;
			  }
		  });
		  self.Grid.dataSource = self.field;
		  self.Grid.refresh();
		  self.lastSyncDate = tempcurrentUTCDate;
		  self.isRefreshInProgress = false;
		  }, (err) => {
		  self.isRefreshInProgress = false;
		  });
		  this.subscriptions.push(subscription1);
		  //#endregion
	  }
	  private setDragRowEndtime(source: any) {
		this.draggedData_duration = 0;
		if (source.Duration && source.Duration.indexOf(":") > -1) {
			let EndTimeHourPart = source.Duration.split(":")[0];
			let EndTimeMinutesPart = source.Duration.split(":")[1];
			if (!isNaN(EndTimeHourPart) && !isNaN(EndTimeMinutesPart)) {
				let EndTimehour: number = parseInt(EndTimeHourPart) * 60;
				let EndTimeMinutes: number = parseInt(EndTimeMinutesPart);
				this.draggedData_duration = (EndTimehour + EndTimeMinutes);
			}
		}
	  }
	  private GridDraggableTemplate(data: any) {
		  let template = '';
		  if (!isNullOrUndefined(data)) {
		  template = `<div 
								  class='template-wrap'
								  style="color: #615f5f;width:200px;padding:8px 8px 8px 0;">
							  <div class="d-flex">
								  <div class="w-50">
									  <div class="text-truncate">
										  <b class="m-0"
											  style="font-size: 12px;">${(data.Priority == null || data.Priority == undefined) ? "" : data.Priority}</b>
									  </div>
									  <div class="text-truncate">
										  <small style="color:#6f6fd2;"
												  class="text-truncate">${(data.PromName == null || data.PromName == undefined) ? "" : data.PromName} </small>
									  </div>
								  </div>
								  <div class="w-50 text-right">
									  <div class="text-truncate">
										  <span>${(data.ServiceType == null || data.ServiceType == undefined) ? "" : data.ServiceType}</span>
									  </div>
								  </div>
							  </div>
							  <div class="d-flex">
								  <div class="w-50">
									  <div class="text-truncate">
										  <b
											  style="font-size: 12px;">${(data.JobSiteDispName == null || data.JobSiteDispName == undefined) ? "" : data.JobSiteDispName}</b>
									  </div>
								  </div>
								  <div class="w-50 text-right">
									  <div class="text-truncate">
										  <span>[${(data.JobSiteAddr == null || data.JobSiteAddr == undefined) ? "" : data.JobSiteAddr}]</span>
									  </div>
								  </div>
							  </div>
						  </div>`
		  }
		  return template;
	  }
	  private resetDragHighlight() // This will reset scehduler cell to default color
	  {
		  $('td.e-work-cells').removeClass('border-cell-all border-cell-leftall border-cell-rightall border-cell-topbottom');
	  }
	  private GetAppointmentQuickInfo(args: any) {
		this.apptModalHeader = { Header: "", SubHeader: "" };
		let appointmentData: DispatcherAppointment = new DispatcherAppointment();
		  let title = "";
		  let appointmentDate = "";
		  let startTime = "";
		  let endTime = "";
		  let duration = "";
		  let techName = "";
		  let AppointmentNote = "";
		  let workOrderInfo = {};
		  let helperWorkOrderInfo = {};
		  let JobSiteID="";
		  let CustomerID = "";
		  let JobSiteDispName = "";
		  let helperStatus = new CodeTypeModel();
  
		  if (!CommonMethods.CheckNullOrUndefined(args, true)) {
		  let schedulerDataSource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
		  let item = schedulerDataSource.find(item => item.ID == args.data.ID);
			if (!CommonMethods.CheckNullOrUndefined(item)) {
			  //#region Appointment Edit Data
			  appointmentData.AppointmentDt = item["StartTime"];
			  appointmentData.AppointmentModifyDate = item["AppointmentModifyDate"];
			  appointmentData.AppointmentNote = item["AppointmentNote"];
			  appointmentData.AppointmentStatusID = item["AppointmentStatusID"];
			  appointmentData.AppointmentSubStatusID = item["AppointmentSubStatusID"];
			  appointmentData.EndTime = args.data.EndTime;
			  appointmentData.ID = item["ID"];
			  appointmentData.Priority = item["Priority"];
			  appointmentData.PriorityID = item["PriorityID"];
			  appointmentData.PromID = item["PromID"];
			  appointmentData.StartTime = args.data.StartTime;
			  appointmentData.TechID = item["TechID"];
			  appointmentData.TypeID = item["TypeID"];
			  appointmentData.WorkTicketID = item["WorkTicketID"];
			  appointmentData.WorkTicketNumber = item["WorkTicketNumber"];
			  //#endregion
			  /* Need contextData.ID to fetch item from datasource */
			  this.contextData = { time: null, departmentId: null, techId: item["TechID"], cellDate: null, cellData: null, resourceDetails: null, isTempID: false, ID: args.data.ID };
		  }
		  if (!CommonMethods.CheckNullOrUndefined(args.data.AppointmentTypeCode)) {
			  title = args.data.AppointmentTypeCode.toUpperCase() + " APPOINTMENT";
		  }
		  if (!CommonMethods.CheckNullOrUndefined(args.data.EstimateNumber)) {
			let estimateAppointmentStatus = this.commonMethods.GetHelperStatus(args.data.AppointmentStatusID, args.data.AppointmentSubStatusID);
			appointmentData["EstimateSubState"]= estimateAppointmentStatus;
		  }
		  if (!CommonMethods.CheckNullOrUndefined(args.data.StartTime) && !CommonMethods.CheckNullOrUndefined(args.data.EndTime)) {
			  let startDt = new Date(args.data.StartTime);
			  let startTm =(startDt.getHours().toString().length < 2 ? "0" + startDt.getHours() : startDt.getHours())+":" + (startDt.getMinutes().toString().length < 2 ? "0" + startDt.getMinutes() : startDt.getMinutes()) + ":00";
			  startTime = CommonMethods.Convert24HrsTo12Hrs(startTm, false)
  
			  let endDt = new Date(args.data.EndTime);
			  let endTm = (endDt.getHours().toString().length < 2 ? "0" + endDt.getHours() : endDt.getHours())  + ":" + (endDt.getMinutes().toString().length < 2 ? "0" + endDt.getMinutes() : endDt.getMinutes()) + ":00";
			  endTime = CommonMethods.Convert24HrsTo12Hrs(endTm, false)
  
			  let timeDiff = CommonMethods.GetTimeDiff(startDt, endDt);
			  appointmentData["DurationHour"] = timeDiff.hours;
			  appointmentData["DurationMin"] = timeDiff.minutes;
			  duration = timeDiff.hours + (timeDiff.hours > 1 ? " hours and " : " hour and ") + timeDiff.minutes + " minutes";
			  appointmentDate = this.commonMethods.formatPromisedDate(args.data.AppointmentDate);
		  }
  
		  if (!CommonMethods.CheckNullOrUndefined(args.data.TechName))
			  techName = args.data.UserName;
  
		  if (!CommonMethods.CheckNullOrUndefined(args.data.AppointmentNote))
			  AppointmentNote = args.data.AppointmentNote;
  
		  //#region Helper work order info
		  if (args.data.AppointmentTypeCode.toLowerCase() == "helper") {
			helperStatus = this.commonMethods.GetHelperStatus(args.data.AppointmentStatusID, args.data.AppointmentSubStatusID);
			workOrderInfo = Object.assign({}, args.data);
			helperWorkOrderInfo =  Object.assign({}, args.data.HelperWorkOrderInfo);// workorder;
			workOrderInfo["AppointmentDate"] = this.commonMethods.formatPromisedDate(args.data["WorkTicketPromisedDate"]);
			workOrderInfo["State"] = workOrderInfo["WorkTicketStatusCode"];
			workOrderInfo["SubState"] = workOrderInfo["WorkTicketSubStatusCode"];
			JobSiteID = workOrderInfo["JobSiteID"];
			CustomerID = workOrderInfo["CustomerID"];
			JobSiteDispName = workOrderInfo["JobSiteDispName"];  
		  }
		  //#endregion
  
		  }
		  return {  data: Object.assign({}, args.data), title: title, appointmentDate: appointmentDate, startTime: startTime, endTime: endTime, 
				    duration: duration, techName: techName, AppointmentNote: AppointmentNote, workOrderInfo: workOrderInfo, JobSiteID: JobSiteID, 
					CustomerID: CustomerID, JobSiteDispName: JobSiteDispName, helperStatus: helperStatus, helperWorkOrderInfo: helperWorkOrderInfo, 
					WorkTicketID: args.data.WorkTicketID, WorkTicketNumber: args.data.WorkTicketNumber, appointmentData: appointmentData
				};
	  }
	  //#endregion
	  //#region Public Methods
  
		  public gridActionComplete()
		  {
			  if(this.Grid.getDataRows().length > 0 ) this.IsGridRowDraggingAllowed = true;
			  else this.IsGridRowDraggingAllowed = false;
		  }
  
	  // To display scheduler filter 
	  public showFilters() {
		  this.zone.runOutsideAngular(() => {
		  $("#mainContainer").scrollTop(0);
		  $('#custominnerfiltermodal').show();
		  });
	  }
	  public CloseFilter() {
		  $("#mainContainer").scrollTop(0);
		  $('#custominnerfiltermodal').css({ overflow: "hidden" }).hide(100);
		  this.SelectedTechniciansForFilter = this.AppliedTechniciansFilter;
	  }
	  public refreshAll() {
		  ////refresh Scheduler
		  if (!this.checkCompanyDataLoaded) // in case company data was not loaded
		  {
		  this.LoadCompanyData();
		  }
		  this.firstTimeCodeCheck = true;
		  this.isNagivated = 0;
		  if (this.scheduleObj.currentView.toString() == "TimelineWeek" || this.scheduleObj.currentView.toString() == "Week") {
		  this.InitializeSchedulerData(this.schedulerStartDate, this.schedulerEndDate, true);
		  }
		  else
		  this.InitializeSchedulerData(this.scheduleObj.selectedDate, null, true);
  
		  // clear grid columns filtering
		  this.Grid.clearFiltering();
		  this.Grid.refresh();
	  }
	  public DurationValidationError(formGroup) {
		  this.lblDurationValidationError = '';
		  if (formGroup.controls['DurationHour'].hasError('required') && formGroup.controls['DurationMin'].hasError('required')) {
		  this.lblDurationValidationError = "Hour is required field<br>Minute is required field";
		  }
		  else if (formGroup.controls['DurationHour'].hasError('required') && !formGroup.controls['DurationMin'].hasError('required')) {
		  this.lblDurationValidationError = "Hour is required field";
		  }
		  else if (!formGroup.controls['DurationHour'].hasError('required') && formGroup.controls['DurationMin'].hasError('required')) {
		  this.lblDurationValidationError = "Minute is required field";
		  }
		  else if (formGroup.controls['DurationHour'].hasError('pattern') && formGroup.controls['DurationMin'].hasError('pattern')) {
		  this.lblDurationValidationError = "Hour should be between 0-23<br>Minute should be 0 or 30";
		  }
		  else if (formGroup.controls['DurationHour'].hasError('pattern') && !formGroup.controls['DurationMin'].hasError('pattern')) {
		  this.lblDurationValidationError = "Hour should be between 0-23";
		  }
		  else if (!formGroup.controls['DurationHour'].hasError('pattern') && formGroup.controls['DurationMin'].hasError('pattern')) {
		  this.lblDurationValidationError = "Minute should be 0 or 30";
		  }
		  else if (formGroup.controls['DurationHour'].hasError('InvalidOneDayTime') || formGroup.controls['DurationMin'].hasError('InvalidOneDayTime')) {
		  this.lblDurationValidationError = Constants.DispatcherMessages().Validation_OneCalendarDay_With_BRTag;
		  }
		  else if (formGroup.controls['DurationHour'].hasError('InvalidHourMinute') || formGroup.controls['DurationMin'].hasError('InvalidHourMinute')) {
		  this.lblDurationValidationError = "Duration cannot be<br> 0 hour and 0 minute";
		  }
	  }
	  public EditWorkOrderData(formdata) {
		  if (this.EventEditingForm.valid) {
		  if (formdata.value.UserID == "-") // remove technician
		  {
			  this.HelperAction_unassignWorkOrder();
		  }
		  else {
			  if (this.isTimeSlotAvailable(formdata.value)) {
			  formdata.value.DurationMin = isNaN(formdata.value.DurationMin) ? 0 : formdata.value.DurationMin;
			  formdata.value.DurationMin = parseInt(formdata.value.DurationMin) > 0 ? 30 : formdata.value.DurationMin; // Either 0 or 30
			  formdata.value.DurationHour = isNaN(formdata.value.DurationHour) ? 0 : formdata.value.DurationHour;
			  formdata.value.EndTime = new Date((new Date(formdata.value.StartTime).getTime() + (((parseInt(formdata.value.DurationHour) * 60) + parseInt(formdata.value.DurationMin)) * 60000)));
			  let endTime = new Date(formdata.value.EndTime);
			  let startTime = new Date(formdata.value.StartTime);
			  //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
			  //formdata.value.EndTime.setMinutes(formdata.value.EndTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
			  if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
				  new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
				  new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
				  this.showLoader();
				  this.isLoaded = 2;
				  this.EditWorkOrder(formdata.value).then((response: any) => {
				  this.editingdata = null;
				  this.editShowModal   = false;
				  this.errorshowmodal = false;
				  this.deleteshowmodal = false;
				  this.chckWorkOrder = true;
				  this.isLoaded = 1;
				  this.hideLoader();
				  this.setschedulerLoadingState();
				  this.toastr.success(Constants.CustomToastMessages_Dispatcher(formdata.value.WorkTicketNumber.toString()).WOUpdateSuccess, "Success");
				  this.scheduleObj.refreshEvents();
				  this.EventEditingForm.reset();
  
				  }).catch(error => {
				  //undo the changes
				  let schedulerDataSource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
				  this.beforeEditingWO = Object.assign({}, schedulerDataSource[schedulerDataSource.findIndex(item => item.ID == formdata.value.ID)]);
				  this.afterEditingWO = formdata.value;
				  this.schedulerDataWithoutEditedWO = schedulerDataSource.filter(item => item.ID != formdata.value.ID);
				  this.confirmisDrag = false;
				  this.ShowErrorFromAPI(error);
				  this.cancelAssginedWorkorder();
				  this.editingdata = null;
				  this.editShowModal   = false;
				  this.errorshowmodal = false;
				  this.deleteshowmodal = false;
				  this.chckWorkOrder = true;
				  this.isLoaded = 1;
				  this.hideLoader();
				  this.setschedulerLoadingState();
				  this.EventEditingForm.reset();
				  });
			  }
			  else {
				  this.setCommonError(Constants.DispatcherMessages().Validation_OneCalendarDay);
			  }
			  } else {
			  this.setCommonError(Constants.DispatcherMessages().Validation_OverlappingEvents);
			  }
		  }
		  }
	  }
	  public cancelEditForm() {
		  this.EventEditingForm.reset();
		  this.editingdata = null;
		  this.editShowModal   = false;
		  this.errorshowmodal = false;
		  this.deleteshowmodal = false;
	  }
	  /**
	   * Cancel appointment form and reset
	   * */
	  public cancelAppointmentForm() {
		  this.AppointmentForm = this.InitAppointmentForm(null);
		  this.contextData = {};
		  this.showAppointmentModal = false;
		  this.errorshowmodal = false;
		  this.deleteshowmodal = false;
		  this.apptModalHeader.SubHeader = "";
		  this.templatedata = {};
		  this.hideLoader();
	  }
	  public deleteAssignedEvent() {
		  // remove assigned event
		  if (!isNullOrUndefined(this.editingdata)) {
		  this.scheduleObj.deleteEvent(this.editingdata.ID);
		  this.editShowModal   = false;
		  this.errorshowmodal = false;
		  this.deleteshowmodal = false;
		  this.editingdata = null;
		  this.resetDragHighlight();
		  }
	  }
	  public closeDeleteModal() {
		  this.editingdata = null;
		  this.editShowModal   = false;
		  this.errorshowmodal = false;
		  this.deleteshowmodal = false;
		  this.resetDragHighlight();
	  }
	  public onPopupOpen(args) {
		  if (args.type == "ValidationAlert") {
		  args.cancel = true;
		  this.setCommonError("Events cannot be scheduled within this time range.");
		  } else if (args.type == "DeleteAlert") {
		  this.editingdata = args.data.event;
		  this.editShowModal   = false;
		  this.errorshowmodal = false;
		  this.deleteshowmodal = true;
		  args.cancel = true;
		  } else if (args.type == "QuickInfo") {
		  this.closeQuickInfo();
		  if(args.data.EventType == "Appointment"){
			  this.templatedata = this.GetAppointmentQuickInfo(args);
			  this.ChangeActionStatus(this.templatedata.workOrderInfo.AppointmentStatusCode, this.templatedata.workOrderInfo.AppointmentSubStatusCode);
			  this.openAppointmentID = args.data.AppointmentID;
		  }
		  else
		  {
			  this.openAppointmentID = args.data.AppointmentID;
			  // get data to show in quick info
			  this.getCurrentWOData(args.data);
		  }
		  } else {
		  args.cancel = true;
		  }
		  //Editor,QuickInfo,EditEventInfo,ViewEventInfo,EventContainer,RecurrenceAlert,DeleteAlert,ValidationAlert,RecurrenceValidationAlert
	  }
	  public closeQuickInfo() {
		  this.scheduleObj.closeQuickInfoPopup();
		  this.templatedata = {};
		  this.showUnAssignedPopup = false;
		  this.openAppointmentID = '';
	  }
	  public onCancel(args) {
		  if (args.type == "Editor") {
		  this.activeEditorStartTime = "";
		  }
	  }
	  public closeErrorModal() {
		  this.editShowModal   = false;
		  this.errorshowmodal = false;
		  this.errorMessage = "";
		  this.resetDragHighlight();
	  }
	  public openWorkorderDetail(eventObj) {
		  if (eventObj != undefined && eventObj != null) {
		  this.showUnAssignedPopup = false;
		  let missingWorkOrderID =
			  eventObj.WorkTicketNumber == undefined || eventObj.WorkTicketNumber == null || eventObj.WorkTicketNumber == "";
		  let missingJobSiteID =
			  eventObj.JobSiteID == undefined || eventObj.JobSiteID == null || eventObj.JobSiteID == "";
		  let missingCustomerID =
			  eventObj.CustomerID == undefined || eventObj.CustomerID == null || eventObj.CustomerID == "";
		  if (missingWorkOrderID || missingCustomerID || missingJobSiteID) {
			  return;
		  }
		  this.tabopen.OpenTab({
			  tabId: Tabs.FsLiteWorkOrderView,
			  params: {
			  ID: eventObj.WorkTicketID,
			  jobsiteId: eventObj.JobSiteID,
			  customerId: eventObj.CustomerID
			  },
			  tabTitle: eventObj.WorkTicketNumber
		  });
		  }
	  }
	  public openJobSiteDetail(eventObj) {
		  if (eventObj != undefined && eventObj != null) {
		  this.showUnAssignedPopup = false;
		  let missingJobSiteID =
			  eventObj.JobSiteID == undefined || eventObj.JobSiteID == null || eventObj.JobSiteID == "";
		  let missingCustomerID =
			  eventObj.CustomerID == undefined || eventObj.CustomerID == null || eventObj.CustomerID == "";
		  if (missingCustomerID || missingJobSiteID) {
			  return;
		  }
		  this.GetPreviewData(eventObj);
		  }
	  }
	  public onDispatcherCellDoubleClick(event: CellClickEventArgs) {
		  this.closeQuickInfo();
		  event.cancel = true;
	  }
	  //#region Action Methods
	  public Action_unassignWorkOrder() {
		  // delete the event - assigned to unassigned		
		  this.showLoader();
		  let tempTemplateData = _.cloneDeep(this.templatedata);
		  this.closeQuickInfo();
		  let gridRowData = this.ConvertToGridRow(tempTemplateData)
		  let appointmentID = tempTemplateData.AppointmentID;
		  this.DeleteAppointmentData(appointmentID).then(() => {
		  this.RemoveAppointmentTile(appointmentID);
		  this.hideLoader();
		  this.toastr.success(Constants.CustomToastMessages_Dispatcher().AppointmentUnassignSuccess, "Success");
		  if (this.field.findIndex((item: any) => item.WorkTicketID == gridRowData["WorkTicketID"]) < 0) // already exists in grid data no need to push
		  {
			  this.field.push(gridRowData);
			  this.Grid.refresh();
		  }
		  }).catch(error => {
			this.hideLoader();
			if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
				this.toastr.showMultiLineError(error.error.Message, "Error");
		  });
	  }
	  public HelperAction_unassignWorkOrder() {
		  // delete the event - assigned to unassigned		
		  this.showLoader();
		  let localTemplateData = _.cloneDeep(this.templatedata);
		  this.closeQuickInfo();
		  this.editShowModal = false;
		  let appointmentID = localTemplateData.workOrderInfo.AppointmentID;
		  this.DeleteAppointmentData(appointmentID).then((response) => {
		  this.RemoveAppointmentTile(appointmentID);
		  this.hideLoader();
		  this.toastr.success(Constants.CustomToastMessages_Dispatcher().AppointmentUnassignSuccess, "Success");
		  }).catch(error => {
		  this.hideLoader();
		  });
	  }
	  public Action_ContinueWorkOrder() {
		  // update the event -- change status only
		  let eventObj: CommonAppointmentModel;
		  eventObj = _.cloneDeep(this.templatedata);
		  this.closeQuickInfo();
		  if (eventObj != undefined && eventObj != null) {
		  // update work order - resize or drag	
		  let StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
		  let SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned).ID;
		  eventObj["StateID"] = StatusID;
		  eventObj["State"] = Constants.WOStaticStatus().open;
		  eventObj["SubStateID"] = SubStatusID;
		  eventObj["SubState"] = Constants.WOStaticStatus().assigned;
		  eventObj["WorkTicketStatusAction"] = Constants.WOStaticStatus().assign;
		  eventObj["ID"] = eventObj["workOrderInfo"]["WorkTicketID"];
		  eventObj["TechID"] = eventObj["UserID"];
		  eventObj["WorkTicketStatusCode"] = Constants.WOStaticStatus().open;
		  eventObj["WorkTicketSubStatusCode"] = Constants.WOStaticStatus().assigned;
		  this.showLoader();
		  this.isLoaded = 2;
		  this.updateWorkOrder_Dispatch(eventObj).then(() => {
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setschedulerLoadingState();
			  this.toastr.success(Constants.CustomToastMessages_Dispatcher((isNullOrUndefined(eventObj.WorkTicketNumber) ? "" : eventObj.WorkTicketNumber.toString())).WOAssignSuccess, "Success");
		  }).catch(error => {
			  this.isLoaded = 1;
			  //undo the changes
			  this.hideLoader();
			  let schedulerdatasource: any = {};
			  schedulerdatasource = this.scheduleObj.eventSettings.dataSource;
			  this.beforeEditingWO = Object.assign({}, schedulerdatasource[schedulerdatasource.findIndex(item => item.ID == eventObj.ID)]);
			  this.afterEditingWO = eventObj;
			  this.schedulerDataWithoutEditedWO = schedulerdatasource.filter(item => item.ID != eventObj.ID);
			  this.confirmisDrag = false;
			  this.ShowErrorFromAPI(error);
			  this.setschedulerLoadingState();
			  this.cancelAssginedWorkorder();
		  });
		  }
	  }
	  public onSchedulerCreated(data) {
		  //setSpinner({ template: "<div class='loader'></div>" });
		  let currentTime = new Date();
		  this.lastSyncDate = new Date(currentTime.getUTCFullYear(), currentTime.getUTCMonth(), currentTime.getUTCDate(), currentTime.getUTCHours(), currentTime.getUTCMinutes(), currentTime.getUTCSeconds());
		  this.InitializeSchedulerData(this.selectedDate, null, false);
		  //#region Code to navigate to today on "Today" button click
		  var self = this;
		  $(document).on('click', '.e-today > button', function () {
		  self.animatteToCurrentTime(self);
		  });
		  this.scheduleObj.renderCompleted = () => {
		  this.setschedulerLoadingState();
		  };
		  //#endregion
	  }
	  public onGridcreated(data) {
		  this.Grid.hideSpinner = () => true;
	  }
	  public onDispatcherDataBounding() {
		  if (this.isNagivated == 0) {	// in any case if scheduler is in loading state, no need to call databound
		  this.isNagivated = -999; // to avoid recalling of onDispatcherResize() automatically.
		  this.setDispatcherAndGridMaxHeight();
		  //clear this.TimeSearchingArray_Cache // for next scheduler render
		  //this.TimeSearchingArray_Cache = {};
		  //performance testing logs
		  //let end = new Date();
		  //let diff = end.getTime() - this.start.getTime();
		  //console.log(diff + " ms");
		  this.setschedulerLoadingState();
		  }
	  }
	  public setDispatcherAndGridMaxHeight() {
		  this.zone.runOutsideAngular(() => {
		  if (!isNullOrUndefined($(".e-content-wrap")) && $(".e-content-wrap").length > 0) {
			  let maxHeight = Math.ceil(parseFloat($(".e-content-wrap").css("max-height")));
			  let height = ($(".e-content-wrap")[0]).scrollHeight;
			  if (height < maxHeight) {
			  let isFullscreen: boolean = $("app-wo-dispatcher").find(".tabs__content__box").hasClass("scheduler-outer-container");
			  let headerHeight = $(".main__Header.fixed-top").height();
			  let tablinksHeight = $(".tabs__link").height() + 20 + 20;//padding with height
			  let wrapperPadding = 15 + 15;// top and bottom padding
			  let titleHeight = $(".title-container").height() + 10;//padding with height
			  let schedulerToolbar = $(".e-schedule-toolbar-container").height();
			  let scheduleHeaderHeight = $(".e-table-container").find(".e-date-header-container").height();
			  let schedulerContentHeight = $(".e-table-wrap.e-current-panel").find(".e-content-wrap").height();
			  let bottomMarginAndPadding = 40;
			  if (isFullscreen) {
				  headerHeight = tablinksHeight = 0;
				  bottomMarginAndPadding = 0;
				  scheduleHeaderHeight += 10;
			  }
			  let gridHeader = $(".e-gridheader.e-lib.e-droppable").height();
			  let availableHeight = Math.floor(window.innerHeight - (wrapperPadding + headerHeight
				  + tablinksHeight + titleHeight + gridHeader + scheduleHeaderHeight + schedulerContentHeight
				  + schedulerToolbar + bottomMarginAndPadding));
			  $(".unassigned-wo-grid.e-grid").find(".e-content").css("max-height", availableHeight + "px");
			  $(".e-table-wrap.e-current-panel").find("table tbody .e-resource-column-wrap").css("max-height", schedulerContentHeight + "px");
			  }
			  else {
			  $(".unassigned-wo-grid.e-grid").find(".e-content").css("max-height", "");
			  $(".e-table-wrap.e-current-panel").find("table tbody .e-resource-column-wrap").css("max-height", "");
			  }
			  let minHeight = $("#Schedule").height();
			  $("#customscheduler").css("min-height", minHeight + "px");
		  }
		  });
	  }
	  public getDepartmentName(value: ResourceDetails): string {
		  return (value.resourceData.DepartmentGroupID) as string;
	  }
	  public getDepartmentNameandMobile(value: ResourceDetails): string {
		  if (this.hideDepartmentCheck) {
		  if (!(isNullOrUndefined(value.resourceData.DepartmentGroupID) || isNullOrUndefined(value.resourceData.UserPhone))) {
			  return ((value.resourceData.DepartmentGroupID).toString() + " - " + PhoneFormatPipe.prototype.transform((value.resourceData.UserPhone).toString()));
		  }
		  else if (isNullOrUndefined(value.resourceData.DepartmentGroupID)) {
			  return ((PhoneFormatPipe.prototype.transform((value.resourceData.UserPhone).toString())));
		  }
		  else {
			  return ((value.resourceData.DepartmentGroupID).toString());
		  }
		  }
		  else {
		  if (!isNullOrUndefined(value.resourceData.UserPhone)) {
			  return PhoneFormatPipe.prototype.transform(((value.resourceData.UserPhone).toString()));
		  }
		  else {
			  return "";
		  }
		  }
	  }
	  public getJobSiteType(jobsitetypeID: string) {
		  let jobsiteType: any = (this.CustomerType.filter((item: any) => item.ID == jobsitetypeID));
		  if (!isNullOrUndefined(jobsiteType)) {
		  if (!isNullOrUndefined(jobsitetypeID) && jobsiteType.length > 0) {
			  if (isNullOrUndefined(jobsiteType[0].Text))
			  return "";
			  else
			  return jobsiteType[0].Text;
		  }
		  else {
			  return "";
		  }
		  }
		  else {
		  return "";
		  }
	  }
	  public onSchedulerNavigating(event: any) {
		  this.showLoader();
		  this.isNagivated = 1;
	  }
	  async onDispatcherDatabinding(obj) {
		  if (this.isNagivated == 1) {
		  // updated view and date is visible here, So new request is initialized here as per new Selected Date and View
		  let startDate = obj.query.params.find(x => x.key == "StartDate");
		  let endDate = obj.query.params.find(x => x.key == "EndDate");
		  let defaultStartDate = new Date(startDate["value"]);
		  let defaultEndDate = new Date(endDate["value"]);
		  // if (this.scheduleObj.currentView.toString() == "TimelineWeek" || this.scheduleObj.currentView.toString() == "Week") {
		  // 	defaultEndDate.setDate(defaultStartDate.getDate() + 6);
		  // }
		  // else {
		  // 	defaultEndDate.setDate(defaultStartDate.getDate());
		  // }
		  defaultEndDate.setTime(defaultEndDate.getTime() - (1 * 24 * 60 * 60 * 1000));
		  let filter_startdate = defaultStartDate.getFullYear().toString() + "-" + (defaultStartDate.getMonth() + 1).toString() + "-" + (defaultStartDate.getDate()).toString();
		  let filter_enddate = defaultEndDate.getFullYear().toString() + "-" + (defaultEndDate.getMonth() + 1).toString() + "-" + (defaultEndDate.getDate()).toString();
		  this.schedulerStartDate = defaultStartDate;
		  this.schedulerEndDate = defaultEndDate;
		  let filters: SchedulerFilter[] = [
			  {
			  field: "StartDate",
			  value: filter_startdate + "T00:00:00"
			  },
			  {
			  field: "EndDate",
			  value: filter_enddate + "T23:59:59"
			  }
		  ];
  
		  await this.fetchSchedulerData(filters).then(() => {
			  this.firstTimeCodeCheck = true;
			  this.isNagivated = 0;
		  }).catch(error => {
			  this.isNagivated = 0;
			  this.hideLoader();
			  this.ShowErrorFromAPI(error);
		  });
		  }
	  }
	  public onDispatcherActionBegin(event: ActionEventArgs): void {
		  //this.start = new Date();
		  let cellData: any = null;
		  // dateNavigate is not required and it's being triggered on every click on the board
		  switch (event.requestType) {
		  case "viewNavigate":
			  this.showLoader();
			  this.isNagivated = 1;
			  //this.setDispatcherAndGridMaxHeight();				
			  break;
		  case "eventChange":
			  cellData = event.changedRecords[0];
			  //while editing the existing event
			  // check -Enforcing 1- day work order validation
			  
			  let IsAllPropertiesMatch: boolean = true;
			  let state = cellData["EventType"] == "WorkOrder" ? cellData["WorkTicketStatusCode"] : cellData["AppointmentStatusCode"];
			  let substate = cellData["EventType"] == "WorkOrder" ? cellData["WorkTicketSubStatusCode"] : cellData["AppointmentSubStatusCode"];
			  let IsWorkOrderAllowEdit = this.SetAppointmentEditableStatus(state, substate); // if false then allow to drag/edit/ change starttime else only allow editing of endtime(Duration)
			  let schedulerdatasource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
			  if (IsWorkOrderAllowEdit) {
				let oldCellData = Object.assign({}, schedulerdatasource[schedulerdatasource.findIndex(item => item.ID == cellData.ID)]);
				IsAllPropertiesMatch = this.checkOnlyEndTimeEdited(oldCellData, cellData); // if false then properties mismatch but only duration was allowed to change
			  }
			  if (IsAllPropertiesMatch) {
				const startTime = cellData.StartTime;
				const endTime = new Date(cellData.EndTime);
				if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
				new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
				new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
					if (this.isTimeSlotAvailable(cellData) && !isNullOrUndefined(cellData.UserID)) {
						if (cellData.DeptName !== cellData.TechDepartmentID) { 
							this.showEstimateDeptWarningModal = true; 
							this.templatedata = cellData;
							return;
						}
						this.ApplyEventChange(cellData);
					}
					else {
						event.cancel = true;
						this.setCommonError("Events cannot be scheduled within this time range.");
					}
				}
				else {
					event.cancel = true;
					this.setCommonError(Constants.DispatcherMessages().Validation_OneCalendarDay);
				}
			  }
			  else {
			  }
			  break;
		  case "eventCreate":
			  if (this.isTreeItemDropped)
			  this.activeEditorStartTime = "";
			  break;
		  }
	  }
	  public ApplyEventChange(cellData: any) {
		this.showEstimateDeptWarningModal = false;
		let schedulerdatasource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
		this.beforeEditingWO = Object.assign({}, schedulerdatasource[schedulerdatasource.findIndex(item => item.ID == cellData.ID)]); // to make copy before updating							
		//#region set fields needed for InitAppointmentForm
		cellData["AppointmentDt"] = cellData.StartTime;
		let duration = CommonMethods.GetTimeDiff(cellData["StartTime"], cellData["EndTime"]);
		cellData["DurationHour"] = duration.hours;
		cellData["DurationMin"] = duration.minutes;
		cellData["TechID"] = cellData.UserID
		//#endregion
		this.templatedata = {};
		this.templatedata["workOrderInfo"] = cellData;
		let formInputData = {
		AppointmentDt: cellData.AppointmentDt,
		TypeID: cellData.TypeID,//
		TechID: cellData.UserID,
		EndTime: cellData.EndTime,
		StartTime: cellData.StartTime,
		DurationHour: cellData.DurationHour,
		DurationMin: cellData.DurationMin,
		AppointmentNote: cellData.TypeID == this.primaryTechCodeType[0].ID ? cellData.DispComment : cellData.AppointmentNote,
		AppointmentModifyDate: cellData.TypeID == this.primaryTechCodeType[0].ID ? cellData.WorkTicketModifyDate : cellData.AppointmentModifyDate,
		ID: cellData.ID,
		IsDirty: true,
		IsSchedule: false,
		Priority: cellData.Priority,
		PriorityID: cellData.PriorityID,
		PromID: cellData.PromID,
		WorkTicketNumber: cellData.WorkTicketNumber,
		AppointmentStatusID: !CommonMethods.CheckNullOrUndefined(cellData.AppointmentStatusID) ? cellData.AppointmentStatusID : cellData.StateID,
		AppointmentSubStatusID: !CommonMethods.CheckNullOrUndefined(cellData.AppointmentSubStatusID) ? cellData.AppointmentSubStatusID :cellData.SubStateID,
		UserID: cellData.UserID,
		WorkTicketID: cellData.WorkTicketID,
		EstimateID: cellData.EstimateID
		}
		if (CommonMethods.CheckNullOrUndefined(formInputData.AppointmentNote))
		formInputData.AppointmentNote = "";
		let formData = this.InitAppointmentForm(formInputData)
		this.AddOrEditAppointmentData(formData, true).then(() => {
		this.isLoaded = 1;
		this.hideLoader();
		}).catch(error => {
		this.hideLoader();
		});

		this.isNagivated = 2;
		setTimeout(() => {
		this.isNagivated = 0;
		}, 2000);
	  }
	  public CancelEstimateDept() {
		  this.templatedata = {};
		  this.showEstimateDeptWarningModal = false;
	  }
	  public onDispatcherActionComplete(event: ActionEventArgs) {
		  switch (event.requestType) {
		  case "resourceCollapsed":
		  case "resourceExpanded":
			  this.setDispatcherAndGridMaxHeight();
			  break;
		  }
	  }
	  public updateWorkOrder_Dispatch(data: any) {
		  return new Promise((resolve, reject) => {
		  this.showLoader();
		  let submitmodel = Object.assign({}, data);
		  submitmodel["TypeID"] = this.TypeID_Static;
		  submitmodel["AppointmentTypeCode"] = "Work Order";
		  submitmodel["EndTime"] = (new Date(data.EndTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(data.EndTime).getMinutes().toString().padStart(2, '0')) + ":00";
		  submitmodel["StartTime"] = (new Date(data.StartTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(data.StartTime).getMinutes().toString().padStart(2, '0')) + ":00";
		  submitmodel["WorkTicketStatusID"] = submitmodel.StateID;
		  submitmodel["WorkTicketSubStatusID"] = submitmodel.SubStateID;
		  // prmise date same as start date as it will update on change of day
		  submitmodel["PromDate"] = (new Date(data.StartTime).getFullYear().toString()) + "-" + ((new Date(data.StartTime).getMonth() + 1).toString().padStart(2, '0')) + "-" + (new Date(data.StartTime).getDate().toString().padStart(2, '0')) + "T00:00:00";
		  let subscription = this.httpService.UpdateDispatchWorkOrder_Patch(submitmodel).subscribe(
			  (response) => {
			  data["ID"] = data["AppointmentID"];
			  this.updatescheduler(data);
			  let schedulerDatasource: any = this.scheduleObj.eventSettings.dataSource;
			  let index = schedulerDatasource.findIndex((item: any) => item.WorkTicketNumber === data.WorkTicketNumber);
			  schedulerDatasource[index]["WorkTicketModifyDate"] = response["ModifyDate"];
			  this.hideLoader();
			  resolve(true);
			  },
			  error => {
			  this.hideLoader();
			  reject(error);
			  }
		  );
		  this.subscriptions.push(subscription);
		  });
	  }
	  public clearGridFilters() {
		  this.Grid.clearFiltering();
	  }
	  public expandscheduler(element) {
		  this.zone.runOutsideAngular(() => {
		  $("app-wo-dispatcher")
			  .find(".tabs__content__box")
			  .toggleClass("scheduler-outer-container");
		  let isFullscreen = element.target.innerHTML.trim() == "fullscreen";
		  if (isFullscreen) {
			  element.target.innerHTML = "fullscreen_exit";
			  element.target.removeAttribute("title");
			  element.target.setAttribute("title", "Exit Fullscreen");
		  } else {
			  element.target.innerHTML = "fullscreen";
			  element.target.removeAttribute("title");
			  element.target.setAttribute("title", "Fullscreen");
		  }
		  this.setDispatcherAndGridMaxHeight();
		  });
	  }
	  public onEventRendered(args: EventRenderedArgs): void {
		  if (args.data.IsBlock != undefined && args.data.IsBlock == true) {
		  (args.element as HTMLElement).style.backgroundColor = "#bcbcbc";
		  (args.element as HTMLElement).setAttribute("customtype", "timeoff");
		  } else {
		  switch ((isNullOrUndefined(args.data.EventType) ? "" : args.data.EventType).toString().replace(/ /g, '')) {
			  case "Event":
				(args.element as HTMLElement).style.backgroundColor = "#bcbcbc";
				(args.element as HTMLElement).setAttribute("customtype", "timeoff");
			  	break;
			  case "TimeOff":
				(args.element as HTMLElement).style.backgroundColor = "#bcbcbc";
				(args.element as HTMLElement).setAttribute("customtype", "timeoff");
				break;
			  case "Appointment": {
				let colorRGBArray: [number, number, number] = [105, 105, 105];
				if (this.excludeAppointmentTypes.includes(args.data.AppointmentTypeCode.toString().toLowerCase())) {
					args.data.WorkTicketStatusCode = args.data["AppointmentStatusCode"];
					args.data.WorkTicketSubStatusCode = args.data["AppointmentSubStatusCode"];
					colorRGBArray = this.getColorAsperState(args.data);
					let state: string = isNullOrUndefined(args.data.AppointmentStatusCode) ? "" : args.data.AppointmentStatusCode.toString().replace(/ /g, '').toLocaleLowerCase();
					let subState: string = isNullOrUndefined(args.data.AppointmentSubStatusCode) ? "" : args.data.AppointmentSubStatusCode.toString().replace(/ /g, '').toLocaleLowerCase();
					this.renderStateOrSubstateForFilters(args, state, subState);
				}
				let colorstringWithOpacity: string = "rgba(" + colorRGBArray[0].toString() + "," + colorRGBArray[1].toString() + "," + colorRGBArray[2].toString() + ",0.15)"; // 15% opacity
				let colorstring: string = "rgb(" + colorRGBArray[0].toString() + "," + colorRGBArray[1].toString() + "," + colorRGBArray[2].toString() + ")"; // 15% opacity
				(args.element as HTMLElement).style.backgroundColor = colorstringWithOpacity;
				(args.element as HTMLElement).style.backgroundImage = "-webkit-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
				(args.element as HTMLElement).style.backgroundImage = "-moz-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
				(args.element as HTMLElement).style.backgroundImage = "-ms-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
				(args.element as HTMLElement).style.backgroundImage = "linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
				// for Filters
				(args.element as HTMLElement).setAttribute("customtype", "appointment");
				(args.element as HTMLElement).setAttribute("typeid", args.data.AppointmentTypeID.toString());
				if (this.excludeAppointmentTypes[1].includes(args.data.AppointmentTypeCode.toString().toLowerCase())) {
					(args.element as HTMLElement).setAttribute("customDepartmentID", isNullOrUndefined(args.data.DepartmentID) ? "" : args.data.DepartmentID.toString());
			  		(args.element as HTMLElement).setAttribute("customPriority", isNullOrUndefined(args.data.PriorityID) ? "" : args.data.PriorityID.toString());
					let serviceTypeCode = isNullOrUndefined(args.data.ServiceTypeName) ? "" : args.data.ServiceTypeName.toString();
					if (!CommonMethods.CheckNullOrUndefined(serviceTypeCode, false)) {
						serviceTypeCode = serviceTypeCode.replace(/ +/g, "_");
						(args.element as HTMLElement).setAttribute("serviceType", serviceTypeCode);
					}
				}
			  }
			  break;
			  case "WorkOrder":
			  let colorRGBArray: [number, number, number] = this.getColorAsperState(args.data);
			  let colorstringWithOpacity: string = "rgba(" + colorRGBArray[0].toString() + "," + colorRGBArray[1].toString() + "," + colorRGBArray[2].toString() + ",0.15)"; // 15% opacity
			  let colorstring: string = "rgb(" + colorRGBArray[0].toString() + "," + colorRGBArray[1].toString() + "," + colorRGBArray[2].toString() + ")"; // 15% opacity
			  (args.element as HTMLElement).style.backgroundColor = colorstringWithOpacity;
			  (args.element as HTMLElement).style.backgroundImage = "-webkit-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
			  (args.element as HTMLElement).style.backgroundImage = "-moz-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
			  (args.element as HTMLElement).style.backgroundImage = "-ms-linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
			  (args.element as HTMLElement).style.backgroundImage = "linear-gradient(left," + colorstring + " 3px, " + colorstringWithOpacity + " 0%)";//"thick solid "+ colorstring;
			  // for Filters
			  (args.element as HTMLElement).setAttribute("customType", "workorder");
			  (args.element as HTMLElement).setAttribute("customDepartmentID", isNullOrUndefined(args.data.DepartmentID) ? "" : args.data.DepartmentID.toString());
			  (args.element as HTMLElement).setAttribute("customPriority", isNullOrUndefined(args.data.PriorityID) ? "" : args.data.PriorityID.toString());
			  (args.element as HTMLElement).setAttribute("customTechType", isNullOrUndefined(args.data.UserGroupID) ? "" : args.data.UserGroupID.toString());
			  (args.element as HTMLElement).setAttribute("typeid", "0");
			  (args.element as HTMLElement).setAttribute("typename", "Work Order");
			  let serviceTypeCode = isNullOrUndefined(args.data.ServiceTypeName) ? "" : args.data.ServiceTypeName.toString();
			  if (!CommonMethods.CheckNullOrUndefined(serviceTypeCode, false)) {
				  serviceTypeCode = serviceTypeCode.replace(/ +/g, "_");
				  (args.element as HTMLElement).setAttribute("serviceType", serviceTypeCode);
			  }
  
			  let state: string = isNullOrUndefined(args.data.WorkTicketStatusCode) ? "" : args.data.WorkTicketStatusCode.toString().replace(/ /g, '').toLocaleLowerCase();
			  let subState: string = isNullOrUndefined(args.data.WorkTicketSubStatusCode) ? "" : args.data.WorkTicketSubStatusCode.toString().replace(/ /g, '').toLocaleLowerCase();
			  this.renderStateOrSubstateForFilters(args, state, subState)
			  break;
		  }
		  }
		  
		  if (args.element.getAttribute("class") != "e-block-appointment") {
		  (args.element as HTMLElement).style.height =
			  document.querySelectorAll('td[data-group-index="' + args.element.getAttribute("data-group-index") + '"]')[0]
			  .scrollHeight + "px";
		  }
	  }
	  public renderStateOrSubstateForFilters(args: EventRenderedArgs, state: string, subState: string){
		  if (state == Constants.WOStaticStatus().open && subState == Constants.WOStaticStatus().unassigned) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "1");
		  }
		  else if (state == Constants.WOStaticStatus().open && subState == Constants.WOStaticStatus().assigned) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "2");
		  }
		  else if (state == Constants.WOStaticStatus().open && subState == Constants.WOStaticStatus().dispatched) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "3");
		  }
		  else if (state == Constants.WOStaticStatus().open && subState == Constants.WOStaticStatus().techreceived) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "4");
		  }
		  else if (state == Constants.WOStaticStatus().open && subState == Constants.WOStaticStatus().working) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "5");
		  }
		  else if (state == Constants.WOStaticStatus().completed && subState == Constants.WOStaticStatus().readyforreview) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "6");
		  }
		  else if (state == Constants.WOStaticStatus().completed && subState == Constants.WOStaticStatus().posted) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "7");
		  }
		  else if (state == Constants.WOStaticStatus().actionrequired && subState == Constants.WOStaticStatus().rescheduled) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "8");
		  }
		  else if (state == Constants.WOStaticStatus().actionrequired && subState == Constants.WOStaticStatus().partsneeded) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "9");
		  }
		  else if (state == Constants.WOStaticStatus().actionrequired && subState == Constants.WOStaticStatus().postingfailure) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "10");
		  }
		  else if (state == Constants.WOStaticStatus().cancelled) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "11");
		  }
		  else if (state == Constants.WOStaticStatus().void) {
		  (args.element as HTMLElement).setAttribute("customStateSubState", "12");
		  }
	  }
	  public onItemDrag(event: any): void {
		  if (this.scheduleObj.isAdaptive) {
		  let classElement: HTMLElement = this.scheduleObj.element.querySelector(".e-device-hover");
		  if (classElement) {
			  classElement.classList.remove("e-device-hover");
		  }
		  if (event.target.classList.contains("e-work-cells")) {
			  addClass([event.target], "e-device-hover");
		  }
		  }
		  if (document.body.style.cursor === "not-allowed") {
		  document.body.style.cursor = "";
		  }
	  }
	  public onEventClick(args) {
		  this.showWOQuickInfo = false;
		  this.showAPTQuickInfo = false;
		  this.showHelperQuickInfo = false;
		  this.showEstimateQuickInfo = false;
		  if (this.scheduleObj.element.querySelector(".e-quick-popup-wrapper.e-popup-open") != null) {
		  this.closeQuickInfo();
		  this.scheduleObj.showQuickInfo = false;
		  this.showAPTQuickInfo = false;
		  this.showWOQuickInfo = false;
		  } else {
		  if (!isNullOrUndefined(args["event"])) {
			  if (args.event.EventType == "Appointment") {
			  this.scheduleObj.showQuickInfo = true;
			  if (this.excludeAppointmentTypes.includes(args.event.AppointmentTypeCode.toLocaleLowerCase())) {
				  if (this.excludeAppointmentTypes[0] === args.event.AppointmentTypeCode.toLocaleLowerCase()) {
				  	this.showHelperQuickInfo = true;
				  } else {
					this.showEstimateQuickInfo = true;
				  }
				  this.SetAppointmentEditableStatus(args["event"]["AppointmentStatusCode"], args["event"]["AppointmentSubStatusCode"]);
			  }
			  else {
				  this.showAPTQuickInfo = true;
			  }
			  }
			  else {
			  this.scheduleObj.showQuickInfo = true;
			  this.showWOQuickInfo = true;
			  this.SetAppointmentEditableStatus(args["event"]["WorkTicketStatusCode"], args["event"]["WorkTicketSubStatusCode"]);
			  }
		  }
		  }
		  this.setCurrentTarget(args);
	  }
	  public onGridRowDragStart(event: any): void {
		  this.zone.runOutsideAngular(() => {
		  if (!isNullOrUndefined(event.data) && event.fromIndex != NaN) {
			  let draggedElement = $('div.e-cloneproperties.e-draganddrop.e-grid').find('div.treenodewithdepartmentID');
			  if (!isNullOrUndefined(draggedElement)) {
			  const draggedRowData: any = (!isNullOrUndefined(event.data) && !isNullOrUndefined(event.data.length)) ?
				  event.data[0] : !isNullOrUndefined(event.data) ? event.data : null;
			  if (!isNullOrUndefined(draggedRowData)) {
				  const gridElement = $('div.e-cloneproperties.e-draganddrop.e-grid');
				  const childTable = gridElement.children().find('table')['prevObject'];
				  $(childTable[0]).css('display', 'none');
				  const wo: string = draggedRowData.WorkTicketNumber;
				  const DeptName: string = draggedRowData.DeptName;
				  gridElement.append(this.GridDraggableTemplate(draggedRowData));
				  this.setDragRowEndtime(draggedRowData);
				  if (Object.keys(this.TimeSearchingArray_Cache).indexOf(wo) > -1) {
				  const timerange: string[] = this.TimeSearchingArray_Cache[wo].split(",");
				  timerange.forEach(time => {
					  $("td.e-work-cells[time='" + time + "']").css('background-color', '#d9f9f3');// promise time match (only in case of department match)       
				  });
				  }
				  $("td.e-work-cells[dcID]").not("[dcID='" + DeptName + "']").css('background-color', '#e0e0e0'); // department (mis)match, high priority than promise time match- overlap promise time color // 					
			  }
			  else {
				  event.cancel = true;
			  }
			  }
			  else {
			  event.cancel = true;
			  }
		  } else {
			  event.cancel = true;
		  }
		  });
	  }
	  public onGridRowDragging(event: any): void {
		  this.zone.runOutsideAngular(() => {
		  this.resetDragHighlight();
		  if ($(event.target).is('.e-work-cells')) {
			  let final_endtime: Date;
			  let starttime: Date = new Date(parseInt($(event.target).attr('data-date')));
			  let newendtime_Asper_EndTime = new Date(starttime.getTime() + (this.draggedData_duration * 60000));
			  final_endtime = Object.assign(newendtime_Asper_EndTime); // update endtime if there else it will set to dragged box by default					
			  let endTime: Date = final_endtime; // Check for next day validation after adding duration if any
			  let checkIfWholeelement = ((endTime.getTime() - starttime.getTime()) % 1800000);
			  let nexttilesinDuration = ((endTime.getTime() - starttime.getTime()) / 1800000);
			  if (checkIfWholeelement == 0) {
			  if (nexttilesinDuration <= 1) {
				  $(event.target).addClass('border-cell-all');
			  }
			  else if (nexttilesinDuration == 2) {
				  $(event.target).addClass('border-cell-leftall');
				  $(event.target).nextAll(':lt(' + ((nexttilesinDuration) - 1) + ')').addClass('border-cell-rightall');
			  }
			  else {
				  $(event.target).addClass('border-cell-leftall');
				  $(event.target).nextAll(':lt(' + ((nexttilesinDuration) - 2) + ')').addClass('border-cell-topbottom');
				  $('.border-cell-topbottom').last().nextAll(':lt(1)').addClass('border-cell-rightall');
			  }
			  }
			  else {
			  if (nexttilesinDuration < 1) {
				  $(event.target).nextAll(':lt(' + ((nexttilesinDuration)) + ')').addClass('border-cell-all');
			  }
			  else {
				  for (var i = 0; i < nexttilesinDuration; i++) {
				  if (i == 0 && i != nexttilesinDuration) {
					  $(event.target).nextAll(':lt(' + ((nexttilesinDuration)) + ')').addClass('border-cell-leftall');
				  }
				  else if (i == 0 && i == nexttilesinDuration) {
					  $(event.target).nextAll(':lt(' + ((nexttilesinDuration)) + ')').addClass('border-cell-all');
				  }
				  else if (i != 0 && i < nexttilesinDuration) {
					  $(event.target).nextAll(':lt(' + ((nexttilesinDuration)) + ')').addClass('border-cell-topbottom');
				  }
				  else if (i != 0 && i == nexttilesinDuration) {
					  $(event.target).nextAll(':lt(' + ((nexttilesinDuration)) + ')').addClass('border-cell-rightall');
				  }
				  }
			  }
			  }
		  }
		  });
		  event.cancel = true;
	  }
	  public setFilterColor() {
		  if (!(this.FilterType == 'All' && this.Filterpriority == 'All' && this.FilterTechType == 'All' && this.FilterDepartment == 'All' && this.FilterStateSubState == 'All')) {
		  return "thin solid #1A6FB1";
		  }
	  }
	  public onGridRowDragStop(event: any): void {
		  //reset filters
		  this.RefreshFilters();
		  //
		  event.cancel = true;
		  this.zone.runOutsideAngular(() => {
		  // Reset color
		  $("td.e-work-cells").not('.e-resource-group-cells').css('background-color', '#f5f5f5'); 
		  $("td.e-work-cells.e-work-hours").not('.e-resource-group-cells').css('background-color', '#fff'); 
		  });
		  let scheduleElement: Element = <Element>closest(event.target, ".e-content-wrap");
		  if (scheduleElement) {
		  if (event.target.classList.contains("e-work-cells")) {
			  let draggedData: any = event.data;
			  let cellData: CellClickEventArgs = this.scheduleObj.getCellDetails(event.target);
			  let resourceDetails: ResourceDetails = this.scheduleObj.getResourcesByIndex(cellData.groupIndex);
			  if (
			  !isNullOrUndefined(draggedData) &&
			  !isNullOrUndefined(cellData) &&
			  !isNullOrUndefined(resourceDetails) &&
			  !isNullOrUndefined(resourceDetails.resourceData.UserGroupID) &&
			  !isNullOrUndefined(resourceDetails.resourceData.DepartmentGroupID)
			  ) {
			  if (Array.isArray(draggedData)) {
				  draggedData = draggedData[0];
			  }
			  if (isNullOrUndefined(draggedData.PromBeginTime) || isNullOrUndefined(draggedData.PromEndTime) || isNullOrUndefined(draggedData.PromDate)) {
				  this.setCommonError("Invalid Work Order.");
				  event.cancel = true;
			  }
			  else {
				  let startTime = cellData.startTime;
				  //#region EndTime Added 
				  let draggedData_EndTime = draggedData.Duration;
  
				  if (!isNullOrUndefined(draggedData_EndTime)) {
				  if (!isNaN(Date.parse(draggedData_EndTime))) {
					  draggedData_EndTime = new Date(draggedData_EndTime).getHours().toString() + ":" + new Date(draggedData_EndTime).getMinutes().toString() + ":" + new Date(draggedData_EndTime).getSeconds().toString();
				  }
				  if (draggedData_EndTime.indexOf(":") > -1) {
					  let EndTimeHourPart = draggedData_EndTime.toString().split(":")[0];
					  let EndTimeMinutesPart = draggedData_EndTime.toString().split(":")[1];
					  if (!isNaN(EndTimeHourPart) && !isNaN(EndTimeMinutesPart)) {
					  let EndTimehour: number = parseInt(EndTimeHourPart) * 60;
					  let EndTimeMinutes: number = parseInt(EndTimeMinutesPart);
					  let totalEndTime: number = (EndTimehour + EndTimeMinutes);
					  let newendtime_Asper_EndTime = new Date(new Date(startTime).getTime() + (totalEndTime * 60000))
					  cellData.endTime = Object.assign(newendtime_Asper_EndTime); // update endtime if there else it will set to dragged box by default
					  }
				  }
				  }
				  //#endregion					
				  let endTime: Date = new Date(cellData.endTime); // Check for next day validation after adding duration if any
				  //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
				  if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
				  new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
				  new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
				  cellData["StartTime"] = cellData.startTime;
				  cellData["EndTime"] = cellData.endTime;
				  if (this.isTimeSlotAvailable(cellData)) {
					  if (this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
					  && this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
					  && draggedData.DeptName == resourceDetails.resourceData.DepartmentGroupID
					  ) {
					  // as department/ Promised Time matches, assign the dragged work order
					  this.showLoader();
					  this.assignWorkOrder(draggedData, cellData, resourceDetails).then(() => {
						  this.hideLoader();
						  this.toastr.success(Constants.CustomToastMessages_Dispatcher((isNullOrUndefined(draggedData.WorkTicketNumber) ? "" : draggedData.WorkTicketNumber.toString())).WOAssignSuccess, "Success");
					  }).catch(error => {
  
						  event.cancel = true;
						  this.hideLoader();
						  //undo the changes
						  this.ShowErrorFromAPI(error);
					  });
					  this.resetDragHighlight();
					  }
					  else {
					  this.beforeEditingWO = draggedData;
					  this.beforeEditingWO.AppointmentTypeID = this.primaryTechCodeType[0].ID;
					  this.afterEditingWO = <CommonAppointmentModel>(cellData as any);
					  this.afterEditingWO.AppointmentStartTime = cellData.startTime.toString();
					  this.afterEditingWO.AppointmentEndTime = cellData.endTime.toString();
					  let PromiseDate = isNaN(Date.parse(draggedData.PromDate)) ? new Date(Date.parse(draggedData.PromDate.toString().split("T")[0])) : new Date(Date.parse(draggedData.PromDate)); // start time and endtime date will be promise date  
					  this.afterEditingWO["PromDate"] = this.getDateString(PromiseDate);
					  this.schedulerDataWithoutEditedWO = <CommonAppointmentModel[]>(resourceDetails as any);
					  this.confirmisDrag = true;
					  if (!this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName == resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only promised time not match
						  //show warning to user to ask to proceed or to undo the action
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseTimeMismatch;
					  }
					  else if (this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName != resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only department not match
						  this.errorMessage = Constants.DispatcherMessages().Validation_DepartmentMismatchForWOAndTech;
					  }
					  else if (this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && !this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName == resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only department not match
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseDateMismatchForWOAndTech;
					  }
					  else if (this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && !this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName != resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only department not match
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseDateDeptMismatchForWOAndTech;
					  }
					  else if (!this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && !this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName == resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only department not match
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseDateTimeMismatchForWOAndTech;
					  }
					  else if (!this.checkSchedulerCellWithinPromisedTime(draggedData.PromBeginTime, draggedData.PromEndTime, cellData.startTime)
						  && this.comparePromisedDate(draggedData.PromDate, cellData.startTime)
						  && draggedData.DeptName != resourceDetails.resourceData.DepartmentGroupID
					  ) {
						  // only department not match
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseTimeDeptMismatchForWOAndTech;
					  }
					  else {
						  this.errorMessage = Constants.DispatcherMessages().Validation_PromiseDateTimeDeptMismatchForWOAndTech;
					  }
					  this.warningshowmodal = true;
					  }
				  } else {
					  this.setCommonError(Constants.DispatcherMessages().Validation_WorkOrderTimeRange);
					  event.cancel = true;
				  }
				  }
				  else {
				  this.setCommonError(Constants.DispatcherMessages().Validation_OneCalendarDay);
				  event.cancel = true;
				  }
			  }
			  } else {
			  event.cancel = true;
			  this.setCommonError(Constants.DispatcherMessages().Validation_WorkOrderTimeRange);
			  }
		  }
		  else {
			  event.cancel = true;
			  this.setCommonError(Constants.DispatcherMessages().Validation_WorkOrderTimeRange);
		  }
		  }
	  }
	  public resetFilters() {
		  //reset filters
		  this.multiSelectAllSelected();
		  this.applyMultiSelectFilter();
		  this.resetWorkOrderFilters(true);
	  }
	  public resetWorkOrderFilters(isReflectFilters: boolean = false) {
		  this.RefreshFilters();
		  if (isReflectFilters) {
		  this.onSchedulerFilterChange();
		  }
	  }
	  public cancelAssginedWorkorder() {
		  if (!this.confirmisDrag) { // in case of editted - dragged/ resize inside scheduler , push back the original WO without editing
		  // delete changed id if it exists and push old data
		  this.updatescheduler(this.beforeEditingWO);
		  }
		  this.errorMessage = '';
		  this.warningshowmodal = false;
		  this.beforeEditingWO = null;
		  this.afterEditingWO = null;
		  this.schedulerDataWithoutEditedWO = null;
		  this.resetDragHighlight();
	  }
	  public saveassignedWorkOrder() {
		  // check if end time is next day 00:00:000
		  let startTime = new Date(this.afterEditingWO.AppointmentStartTime);
		  let endTime = new Date(this.afterEditingWO.AppointmentEndTime);
		  let nextday = new Date();
		  nextday.setDate(startTime.getDate() + 1);
		  if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
		  new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
		  new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
		  // same day work order - start and end time
		  }
		  else if (new Date(nextday).getDate() == new Date(endTime).getDate() &&
		  new Date(nextday).getMonth() == new Date(endTime).getMonth() &&
		  new Date(nextday).getFullYear() == new Date(endTime).getFullYear()) {
		  if (new Date(endTime).getHours() == 0 && new Date(endTime).getMinutes() == 0) {
			  endTime = new Date(new Date(startTime).getFullYear(), new Date(startTime).getMonth(), new Date(startTime).getDate(), 23, 59, 59);
			  this.afterEditingWO["AppointmentEndTime"] = endTime.toString();
		  }
		  }
		  if (this.confirmisDrag) {
		  // assign work order
		  this.showLoader();
		  this.isNagivated = 2;
		  this.isLoaded = 2;
		  this.assignWorkOrder(this.beforeEditingWO, this.afterEditingWO, this.schedulerDataWithoutEditedWO).then(() => {
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setschedulerLoadingState();
			  this.isNagivated = 0;
			  this.resetDragHighlight();
			  this.toastr.success(Constants.CustomToastMessages_Dispatcher((isNullOrUndefined(this.beforeEditingWO.WorkTicketNumber) ? "" : this.beforeEditingWO.WorkTicketNumber.toString())).WOAssignSuccess, "Success");
		  }).catch(error => {
			  //undo the changes
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setschedulerLoadingState();
			  this.isNagivated = 0;
			  this.ShowErrorFromAPI(error);
			  this.cancelAssginedWorkorder();
		  });
		  }
		  else {
		  // update work order - resize or drag    
		  this.showLoader();
		  this.isNagivated = 2;
		  this.isLoaded = 2;
		  this.updateWorkOrder(this.afterEditingWO).then((result: any) => {
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setschedulerLoadingState();
			  this.isNagivated = 0;
			  this.resetDragHighlight();
			  if (isNullOrUndefined(result) || (!isNullOrUndefined(result) && result.message == "success")) {
			  this.toastr.success(Constants.CustomToastMessages_Dispatcher((isNullOrUndefined(this.afterEditingWO.WorkTicketNumber) ? "" : this.afterEditingWO.WorkTicketNumber.toString())).WOUpdateSuccess, "Success");
			  }
			  else {
			  //undo the changes
			  this.cancelAssginedWorkorder();
			  }
		  }).catch(error => {
			  //undo the changes
			  this.isLoaded = 1;
			  this.hideLoader();
			  this.setschedulerLoadingState();
			  this.isNagivated = 0;
			  this.ShowErrorFromAPI(error);
			  this.cancelAssginedWorkorder();
		  });
		  }
		  this.errorMessage = '';
		  this.warningshowmodal = false;
	  }
	  private assignWorkOrder(draggedData: any, cellData: any, resourceDetails: any) {
		  return new Promise((resolve, reject) => {
		  
		  let eventData = this.ConvertToEventDataFromGridRow(draggedData, cellData, resourceDetails);
		  let submitmodel: Request_AppointmentModel = new Request_AppointmentModel();
		  //#region submitModel values assignment
		  submitmodel.ID = CommonMethods.GetID()
		  submitmodel.UserID = eventData.UserID.toString();
		  submitmodel.AppointmentTypeID = this.primaryTechCodeType[0].ID;
		  submitmodel.AppointmentDate = eventData.PromDate.toString();
		  submitmodel.StartTime = eventData.AppointmentStartTime.toString();
		  submitmodel.EndTime = eventData.AppointmentEndTime.toString();
		  submitmodel.Note = "";
		  submitmodel.StatusID = eventData.WorkTicketStatusID.toString();
		  submitmodel.SubStatusID = eventData.WorkTicketSubStatusID.toString();
		  submitmodel.ModifyDate = eventData.ModifyDate.toString();
		  submitmodel.IsDirty = true;
		  submitmodel.IsSchedule = false;
  
		  submitmodel.WorkTicketID = eventData.WorkTicketID.toString();
		  submitmodel.WorkTicketNumber = eventData.WorkTicketNumber.toString();
		  submitmodel.PriorityID = eventData.PriorityID.toString();
		  submitmodel.Priority = eventData.Priority.toString();
		  submitmodel.PromID = eventData.PromID.toString();
		  //#endregion
		  
		  this.SaveAppointment(submitmodel).then((response: any) => {
			  let newdatasource = this.field;
			  this.field = newdatasource.filter((item: any) => item.WorkTicketNumber != draggedData.WorkTicketNumber);
			  this.Grid.dataSource = this.field;
			  this.chckTimeOff = true;
			  this.chckWorkOrder = true;
  
			  let returnModel: CommonAppointmentModel = new CommonAppointmentModel();
			  CommonMethods.ObjectMapper(eventData, returnModel);
			  returnModel = this.ConvertToEventData(response, returnModel, false);
			  returnModel.PromID = submitmodel.PromID;
			  returnModel.PriorityID = submitmodel.PriorityID;
			  returnModel.Priority = submitmodel.Priority;
			  returnModel.DispComment = eventData.DispComment.toString();
			  returnModel.ID = response.ID;
			  let appointmentDate = new Date(returnModel.AppointmentDate);
			  let EndTime = returnModel.AppointmentEndTime;
			  let StartTime = returnModel.AppointmentStartTime;
			  let deptId = this.initialData.Users.find(x => x["ID"] == submitmodel.UserID).Department.Name;
			  returnModel.TechDepartmentID = deptId;
			  returnModel.TechID = submitmodel.UserID;
			  returnModel.StartTime = (new Date(appointmentDate.getFullYear(), appointmentDate.getMonth(), appointmentDate.getDate(), this.formatTime(StartTime, 0), this.formatTime(StartTime, 1))).toString();
			  returnModel.EndTime = (new Date(appointmentDate.getFullYear(), appointmentDate.getMonth(), appointmentDate.getDate(), this.formatTime(EndTime, 0), this.formatTime(EndTime, 1))).toString();
			  returnModel.WorkTicketModifyDate = response.ModifyDate;
  
			  this.scheduleObj.addEvent(returnModel);
			  this.scheduleObj.refreshEvents();
			  resolve(true);
			  //refresh filter to make things visible
			  this.RefreshFilters();
			  this.showAppointmentModal = false;
			  this.AppointmentForm = this.InitAppointmentForm(null);
			  this.templatedata = {};
  
		  }).catch(error => {
			  reject(error)
		  });
		  });
	  }
	  private editingTemplatedata: any;
	  public openEditor(eventData: any) {
		  // this.scheduleObj.openEditor(eventData, 'Save');
		  this.editingTemplatedata = _.cloneDeep(this.templatedata);
		  this.closeQuickInfo();
		  this.templatedata = _.cloneDeep(this.editingTemplatedata);
		  this.activeEditorStartTime = eventData.StartTime;
		  this.EventEditingForm = this.InitializeEditEventForm(eventData);
		  this.editShowModal   = true;
	  }
	  public onSchedulerFilterChange() {
		  var DepartmentSelected = this.FilterDepartment;
		  var TechSelected = this.FilterTechType;
		  var PrioritySelected = this.Filterpriority;
		  var FilterTypeSelected = this.FilterType;
		  var customStateSubState = this.FilterStateSubState;
		  var ServiceTypeSelected = this.FilterServiceType;
		  // create element to be searched
		  var eventsToFiltered = 'div[customtype]';
		  if (FilterTypeSelected != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[typeid='" + FilterTypeSelected + "']" : eventsToFiltered + "div[typeid='" + FilterTypeSelected + "']");
		  }
		  if (PrioritySelected != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[customPriority='" + PrioritySelected + "']" : eventsToFiltered + "div[customPriority='" + PrioritySelected + "']");
		  }
		  if (TechSelected != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[customTechType='" + TechSelected + "']" : eventsToFiltered + "div[customTechType='" + TechSelected + "']");
		  }
		  if (DepartmentSelected != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[customDepartmentID='" + DepartmentSelected + "']" : eventsToFiltered + "div[customDepartmentID='" + DepartmentSelected + "']");
		  }
		  if (customStateSubState != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[customStateSubState='" + customStateSubState + "']" : eventsToFiltered + "div[customStateSubState='" + customStateSubState + "']");
		  }
		  if (ServiceTypeSelected != 'All') {
		  eventsToFiltered = (eventsToFiltered.indexOf('div') > -1 ? eventsToFiltered + "[serviceType='" + ServiceTypeSelected + "']" : eventsToFiltered + "div[serviceType='" + ServiceTypeSelected + "']");
		  }
		  if (eventsToFiltered != '') {
		  this.zone.runOutsideAngular(() => {
			  $('div[customtype]').each(function () {
			  if ($(this).is(eventsToFiltered)) {
				  $(this).css({ opacity: "1", transition: "1s" });
			  }
			  else {
				  $(this).css({ opacity: "0", transition: "1s" });
			  }
			  });
		  });
		  }
	  }
	  public onGroupByDropDownChange(e) {
		  //reset filters
		  this.resetWorkOrderFilters();
		  if (e.value == "0") this.ByTechType();
		  else if (e.value == "1") this.ByDepartment();
		  else this.NoGroupingData();
	  }
  
	  /**
	   * Used to update form validity.
	   * @param formGroup
	   */
	  public updateformValidity(formGroup) {
		  Object.keys(formGroup.controls).forEach(key => {
		  formGroup.controls[key].updateValueAndValidity();
		  });
		  this.DurationValidationError(formGroup); // to print validation error related to hour or minute
	  }
	  public numberOnly(event): boolean {
		  const charCode = (event.which) ? event.which : event.keyCode;
		  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		  }
		  return true;
	  }
	  public onDispatcherCellClick(args) {
		  // close all other quick infos if open
		  if (this.scheduleObj.element.querySelector(".e-quick-popup-wrapper.e-popup-open") != null) {
		  this.closeQuickInfo();
		  this.scheduleObj.showQuickInfo = false;
		  this.showAPTQuickInfo = false;
		  this.showWOQuickInfo = false;
		  }
		  args.cancel = true; // Prevents the display of quick window on clicking the cells.
	  }
	  public getCurrentWOData(data) {
		  // This method not required when grid quickinfo opened and required in html to capture events of quick info
		  if (!isNullOrUndefined(data) && !isNullOrUndefined(data.ID) && !this.showUnAssignedPopup) {
		  let ID: string = data.ID;
		  this.templatedata = {};
		  this.templatedata = Object.assign({}, this.data.find(x => x["ID"] == ID));
		  this.templatedata["StateID"] = data.WorkTicketStatusID;
		  this.templatedata["SubStateID"] = data.WorkTicketSubStatusID;
  
		  if (!isNullOrUndefined(this.templatedata)) {
			  this.templatedata["StartTimeDisplay"] = this.commonMethods.formatPromisedDate(this.templatedata.StartTime);
			  this.ChangeActionStatus(this.templatedata.WorkTicketStatusCode, this.templatedata.WorkTicketSubStatusCode);
		  }
		  //#region Temp TechData
		  let helperList = [];
		  helperList = data.Helpers;
		  helperList.forEach(x => {
			  x.DisplayState = <CodeTypeModel>this.commonMethods.GetHelperStatus(x.AppointmentStatusID, x.AppointmentSubStatusID);
			  x.DisplayStartTime = CommonMethods.Convert24HrsTo12Hrs(x.AppointmentStartTime, false);
		  });
		  this.templatedata.HelperList = helperList
		  this.templatedata.workOrderInfo = data;
		  //#endregion
		  }
	  }
	  public refreshMultiSelectDataList() {
		  if (this.multiSelect.data.length < 1) {
		  this.FilteredTechnicianDataSource = this.TechnicianMasterDataSource;
		  }
	  }
	  public multiSelectAllSelected() {
		  this.SelectedTechniciansForFilter = this.TechnicianMasterDataSource.map(x => {
		  return {
			  ID: x["ID"],
			  Text: x["Text"]
		  }
		  });
	  }
	  public multiSelectDeselectAll() {
		  this.SelectedTechniciansForFilter = [];
	  }
	  public applyMultiSelectFilter() {
		  this.resetWorkOrderFilters();
		  if (this.SelectedTechniciansForFilter.length <= 0)
		  this.multiSelectAllSelected();
		  let selectedTechnicianList: any[] = this.SelectedTechniciansForFilter.map(x => {
		  return x["ID"];
		  });
		  this.FilteredTechnicianDataSource = this.TechnicianMasterDataSource.filter(x => {
		  return selectedTechnicianList.includes(x["ID"]);
		  });
		  this.TechnicianDataSource = this.FilteredTechnicianDataSource;
		  this.AppliedTechniciansFilter = this.SelectedTechniciansForFilter;
		  this.isNagivated = 0;
		  this.showLoader();
		  this.firstTimeCodeCheck = true;
		  this.scheduleObj.refresh();
	  }
	  public promiseDateDropDownChange(e) {
		  this.datePicker1.readonly = false;
		  this.datePicker2.readonly = false;
		  switch (this.dropInstance.value) {
		  case this.dropDownData.find(x => x["sname"] == 'Today')["sID"]:
			  {
			  let startingDate = new Date();
			  let endingDate = new Date();
			  startingDate.setHours(0, 0, 0, 0);
			  endingDate.setHours(23, 59, 59, 999);
			  this.datePicker1.value = startingDate;
			  this.datePicker2.value = endingDate;
			  this.datePicker1.readonly = true;
			  this.datePicker2.readonly = true;
			  this.disableFilterButton(false);
			  }
			  break;
		  case this.dropDownData.find(x => x["sname"] == 'Tomorrow')["sID"]:
			  {
			  let startingDate = new Date(new Date().setDate(new Date().getDate() + 1));
			  let endingDate = new Date(new Date().setDate(new Date().getDate() + 1));
			  startingDate.setHours(0, 0, 0, 0);
			  endingDate.setHours(23, 59, 59, 999);
  
			  this.datePicker1.value = startingDate;
			  this.datePicker2.value = endingDate;
			  this.datePicker1.readonly = true;
			  this.datePicker2.readonly = true;
			  this.disableFilterButton(false);
			  }
			  break;
		  case this.dropDownData.find(x => x["sname"] == 'This Week')["sID"]:
			  var startingDate = new Date(); // get First date				
			  var first = startingDate.getDate() - startingDate.getDay(); // First day is the day of the month - the day of the week				
			  const millisInOneDay = (24 * 60 * 60 * 1000);
			  const startDateMillis = startingDate.setDate(first);
			  const endDateMillis = startDateMillis + (6 * millisInOneDay);
			  let endingDate = new Date(endDateMillis);
			  startingDate.setHours(0, 0, 0, 0);
			  endingDate.setHours(23, 59, 59, 999);
			  this.datePicker1.value = startingDate;
			  this.datePicker2.value = endingDate;
			  this.datePicker1.readonly = true;
			  this.datePicker2.readonly = true;
			  this.disableFilterButton(false);
			  break;
		  case this.dropDownData.find(x => x["sname"] == 'Custom')["sID"]:
			  this.setDefaultDatesForPDateFilter();
			  this.datePicker1.value = this.dp1;
			  this.datePicker2.value = this.dp2;
			  this.datePicker1.readonly = false;
			  this.datePicker2.readonly = false;
			  this.disableFilterButton(false);
			  break;
		  default:
			  this.datePicker1.value = null;
			  this.datePicker2.value = null;
			  this.disableFilterButton(true);
			  break;
		  }
	  }
  
	  public gridClickHandler(e: any) {
		  let element = $(e.target);
  
		  /**check if clear button click and reset the filter */
		  if (element.hasClass("filter-Pdate") && element.text() === 'Clear') {
		  if (!isNullOrUndefined(this.dropInstance)) {
			  this.dropInstance.value = this.dm1 = this.dropDownData.find(x => x["sname"] == "Custom")["sID"];
			  this.setDefaultDatesForPDateFilter();
		  }
		  }
		  /** Toggle the Grid Column filter popup */
		  if (element.is(".e-filtermenudiv.e-icons.e-icon-filter")) {
		  if (!isNullOrUndefined(this.prevMappingGuid)) {
			  if (this.prevMappingGuid == element.attr("e-mappinguid")) {
			  $('.e-filter-popup').toggle();
			  }
		  }
		  this.prevMappingGuid = element.attr("e-mappinguid");
		  }
	  }
  
	  public showUnAssignedWODetail(data, event) {
		  this.closeQuickInfo();
		  //Need to create a model for the template
		  if (!isNullOrUndefined(data)) {
		  data["StartTimeDisplay"] = this.commonMethods.formatPromisedDate(data.PromDate);
		  // This needs to be revisited after having the same model structure
		  data["WorkTicketNumber"] = data.WorkTicketNumber;
		  data["WorkTicketStatusCode"] = data.State;
		  data["WorkTicketSubStatusCode"] = data.SubState;
		  data["ServiceTypeName"] = data.ServiceTypeName;
  
		  this.templatedata = data;
		  let helperList = [];
		  helperList = data.Helpers;
		  helperList.forEach(x => {
			  x.DisplayState = <CodeTypeModel>this.commonMethods.GetHelperStatus(x.AppointmentStatusID, x.AppointmentSubStatusID);
			  x.DisplayStartTime = CommonMethods.Convert24HrsTo12Hrs(x.AppointmentStartTime, false);
		  });
		  this.templatedata.HelperList = helperList
		  }
		  this.showUnAssignedPopup = true;
		  this.showWOQuickInfo = true;
		  this.showHelperQuickInfo = false;
		  this.showAPTQuickInfo = false;
		  this.showEstimateQuickInfo = false;
		  if (!isNullOrUndefined(event)) {
		  event.stopPropagation();
		  }
	  }
  
	  public onContextMenuBeforeOpen(args: BeforeOpenCloseMenuEventArgs): void {
		  let cellData: CellClickEventArgs = this.scheduleObj.getCellDetails(<any>args.event.target);
		  if (!CommonMethods.CheckNullOrUndefined(cellData, true)) {
		  if (!CommonMethods.CheckNullOrUndefined(cellData.groupIndex)) {
			  if (!this.hasNewWorkOrderPermission) {
			  this.menuObj.enableItems(['New Work Order'], false);
			  }
			  let resourceDetails: ResourceDetails = null;
			  if (!CommonMethods.CheckNullOrUndefined(cellData))
			  resourceDetails = this.scheduleObj.getResourcesByIndex(cellData.groupIndex);
  
			  if (
			  !isNullOrUndefined(cellData) &&
			  !isNullOrUndefined(resourceDetails) &&
			  !isNullOrUndefined(resourceDetails.resourceData.UserGroupID) &&
			  !isNullOrUndefined(resourceDetails.resourceData.DepartmentGroupID)
			  ) {
			  let selectedCell = <any>args.event.target;
			  let departmentId = selectedCell.attributes["dcid"].value;
			  let techId = selectedCell.attributes["techid"].value;
			  let cellDate = new Date(parseInt(selectedCell.attributes["data-date"].value));
			  let isTempID = true;
			  let ID = CommonMethods.GenerateRandomID();
			  this.contextData = { departmentId: departmentId, techId: techId, cellDate: cellDate, cellData: cellData, resourceDetails: resourceDetails, isTempID: isTempID, ID: ID };
			  const newEventElement: HTMLElement = document.querySelector('.e-new-event') as HTMLElement;
			  if (newEventElement) {
				  remove(newEventElement);
				  removeClass([document.querySelector('.e-selected-cell')], 'e-selected-cell');
			  }
			  const targetElement: HTMLElement = <HTMLElement>args.event.target;
			  if (closest(targetElement, '.e-contextmenu')) {
				  return;
			  }
			  this.selectedTarget = closest(targetElement, '.e-appointment,.e-work-cells,' +
				  '.e-vertical-view .e-date-header-wrap .e-all-day-cells,.e-vertical-view .e-date-header-wrap .e-header-cells');
			  if (isNullOrUndefined(this.selectedTarget)) {
				  args.cancel = true;
				  return;
			  }
			  }
			  else {
			  args.cancel = true;
			  }
		  }
		  else {
			  args.cancel = true;
			  return;
		  }
		  }
		  else {
		  args.cancel = true;
		  return;
		  }
	  }
  
	  public onMenuItemSelect(args: MenuEventArgs): void {
		  const selectedMenuItem: string = args.item.id;
		  switch (selectedMenuItem) {
		  case 'NewAppointment':
		  case 'NewWorkOrder':
			  let selectedCells: Element[] = this.scheduleObj.getSelectedElements();
			  let activeCellsData: CellClickEventArgs =
			  this.scheduleObj.getCellDetails(selectedCells.length > 0 ? selectedCells : this.selectedTarget);
			  this.AppointmentForm = this.InitAppointmentForm(null);
			  this.AppointmentForm.controls["StartTime"].setValue(activeCellsData.startTime);
  
			  if (selectedMenuItem === 'NewAppointment') {
			  //#region Open appointment modal
  
			  this.AppointmentForm.controls["UserID"].setValue(this.contextData["techId"]);
			  if (!CommonMethods.CheckNullOrUndefined(this.contextData)) {
				  if (!CommonMethods.CheckNullOrUndefined(this.contextData.cellDate)) {
					  this.AppointmentForm.controls["AppointmentDate"].setValue(this.contextData.cellDate);
				  }
			  }
			  this.apptModalHeader.Header = "NEW APPOINTMENT";
			  this.showAppointmentModal = true;
			  this.templatedata = {};
			  //#endregion
			  } else {
			  //#region Open new work order
			  if (!CommonMethods.CheckNullOrUndefined(this.contextData)) {			
				  if (!CommonMethods.CheckNullOrUndefined(this.contextData.cellDate)) {
				  this.AppointmentForm.controls["AppointmentDate"].setValue(this.contextData.cellDate);
				  }
  
				  let deptId = this.initialData.Departments.find(x => x["Name"] == this.contextData["departmentId"])["ID"];
				  let params = { ScheduleType: 1, PromisedDate: this.contextData.cellDate, StartTime: activeCellsData.startTime, TechID: this.contextData["techId"], DepartmentID: deptId };
				  this.OpenCreateWorkOrder(params)
			  }
			  //#endregion
			  }
			  break;
		  }
	  }
	  
	  public AddOrEditAppointmentData(formdata, isDrag = false) {
		  return new Promise((resolve, reject) => {
		  if (formdata.valid) {
			  let startTime = new Date(formdata.value.StartTime);
			  let successToastMsg = null;
  
			  startTime.setDate(formdata.value.AppointmentDate.getDate());
			  startTime.setMonth(formdata.value.AppointmentDate.getMonth());
			  startTime.setFullYear(formdata.value.AppointmentDate.getUTCFullYear());
			  startTime.setSeconds(0);
			  startTime.setMilliseconds(0);
  
			  formdata.value.StartTime = startTime;
			  formdata.value.DurationMin = isNaN(formdata.value.DurationMin) ? 0 : formdata.value.DurationMin;
			  formdata.value.DurationMin = parseInt(formdata.value.DurationMin) > 0 ? 30 : formdata.value.DurationMin; // Either 0 or 30
			  formdata.value.DurationHour = isNaN(formdata.value.DurationHour) ? 0 : formdata.value.DurationHour;
			  formdata.value.EndTime = new Date((new Date(startTime).getTime() + (((parseInt(formdata.value.DurationHour) * 60) + parseInt(formdata.value.DurationMin)) * 60000)));
  
			  let endTime = new Date(formdata.value.EndTime);
			  if (this.isTimeSlotAvailable(formdata.value)) {
				if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
					new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
					new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
					this.isLoaded = 2;
					this.showLoader();
					this.editingdata = null;
					this.errorshowmodal = false;
					this.deleteshowmodal = false;
					let requestModel = this.GetAppointmentModel(formdata.value);
					if (isDrag && formdata.value.AppointmentTypeID == this.primaryTechCodeType[0].ID)
					successToastMsg = "Work Order - " + formdata.value.WorkTicketNumber.toString() + " has been updated successfully.";
					this.SaveAppointment(requestModel, successToastMsg).
					then((response) => {
						/** In case of POST */
						if (requestModel.ID == CommonMethods.GetID()) {
						let returnModel: CommonAppointmentModel = new CommonAppointmentModel();
						returnModel = this.ConvertToEventData(response, null, true);
						let appointmentDate = new Date(returnModel.AppointmentDate);
						let EndTime = returnModel.AppointmentEndTime;
						let StartTime = returnModel.AppointmentStartTime;
						let deptId = this.initialData.Users.find(x => x["ID"] == requestModel.UserID).Department.Name;
						returnModel.TechDepartmentID = deptId; //formdata.value.TechDepartmentID;
						returnModel.TechID = requestModel.UserID;
						returnModel.StartTime = (new Date(appointmentDate.getFullYear(), appointmentDate.getMonth(), appointmentDate.getDate(), this.formatTime(StartTime, 0), this.formatTime(StartTime, 1))).toString();
						returnModel.EndTime = (new Date(appointmentDate.getFullYear(), appointmentDate.getMonth(), appointmentDate.getDate(), this.formatTime(EndTime, 0), this.formatTime(EndTime, 1))).toString();
						this.scheduleObj.addEvent(returnModel);
						this.scheduleObj.refreshEvents();
						this.RefreshFilters();
	
						this.showAppointmentModal = false;
						this.AppointmentForm = this.InitAppointmentForm(null);
						this.templatedata = {};
	
						if (CommonMethods.CheckNullOrUndefined(successToastMsg))
							this.toastr.success(Constants.CustomToastMessages_Dispatcher().AppointmentSaveSuccess, "Success");
						else
							this.toastr.success(successToastMsg, "Success");
						}
						/** In case of PUT */
						else {
						if (requestModel.AppointmentTypeID != this.primaryTechCodeType[0].ID) {
							if (CommonMethods.CheckNullOrUndefined(successToastMsg))
							this.toastr.success(Constants.CustomToastMessages_Dispatcher().AppointmentUpdateSuccess, "Success");
							else
							this.toastr.success(successToastMsg, "Success");
						}
						else {
							this.toastr.success(Constants.CustomToastMessages_Dispatcher(requestModel.WorkTicketNumber.toString()).WOUpdateSuccess, "Success");
						}
						const schedulerDataSource = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
						let item = schedulerDataSource.find(item => item.ID == requestModel.ID);
						let returnModel = this.ConvertToEventData(response, item, false);
	
						returnModel.WorkTicketNumber = requestModel.WorkTicketNumber;
						returnModel.PriorityID = requestModel.PriorityID;
						returnModel.PromID = requestModel.PromID;
						this.RefreshFilters();
	
						this.showAppointmentModal = false;
						this.templatedata = {};
						this.updatescheduler(returnModel);
						}
						resolve(response);
					}).
					catch(error => { reject(error) });
				}
				else {
					this.setCommonError(Constants.DispatcherMessages().Validation_OneCalendarDay);
					reject(Constants.DispatcherMessages().Validation_OneCalendarDay);
				}
			  }
			  else {
			  this.setCommonError(Constants.DispatcherMessages().Validation_OverlappingEvents);
			  reject(Constants.DispatcherMessages().Validation_OverlappingEvents);
			  }
		  }
		  else {
			  reject();
		  }
		  });
	  }
  
	  private GetAppointmentModel(data) {
		  let returnModel = new Request_AppointmentModel();
		  if (data["IsNew"] == false)
		  returnModel.ID = data["ID"];
		  else
		  returnModel.ModifyDate = data["ModifyDate"];
  
		  returnModel.AppointmentDate = this.datePipe.transform(data["AppointmentDate"], "MM/dd/yyyy");  //data["AppointmentDate"];
		  returnModel.AppointmentTypeID = data["AppointmentTypeID"];
		  returnModel.EndTime = (new Date(data["EndTime"]).getHours().toString().padStart(2, '0')) + ":" + (new Date(data["EndTime"]).getMinutes().toString().padStart(2, '0')) + ":00";;
		  returnModel.IsDirty = true;
		  returnModel.IsSchedule = data["IsSchedule"];
		  returnModel.IsSchedule = false
		  returnModel.ModifyDate = data["AppointmentModifyDate"];
		  returnModel.Note = data["AppointmentNote"];
		  returnModel.Priority = data["Priority"];
		  returnModel.PriorityID = data["PriorityID"];
		  returnModel.PromID = data["PromID"];
		  returnModel.StartTime = (new Date(data["StartTime"]).getHours().toString().padStart(2, '0')) + ":" + (new Date(data["StartTime"]).getMinutes().toString().padStart(2, '0')) + ":00";;
		  returnModel.StatusID = data["AppointmentStatusID"];
		  returnModel.SubStatusID = data["AppointmentSubStatusID"];
		  returnModel.UserID = data["UserID"];
		  returnModel.WorkTicketID = data["WorkTicketID"];
		  returnModel.WorkTicketNumber = data["WorkTicketNumber"];
		  returnModel.EstimateID = data["EstimateID"];
		  return returnModel;
	  }
  
	  /**
	   * Open new work order tab
	   * @param params
	   */
	  public OpenCreateWorkOrder(params: any) {
		  let tabAlreadyOpened = this.tabsComponent.openedTabs.find(
		  x =>
			  x.tabId == Tabs.FsLiteWorkOrderCreate &&
			  x.tabTitle == "New Work Order");
		  if (tabAlreadyOpened) {
		  this.errorshowmodal = true;
		  this.errorMessage = "Please save or close the open New Work Order tab and try again";
		  return;
		  }
		  this.tabopen.OpenTab({
		  tabId: Tabs.FsLiteWorkOrderCreate,
		  params: !CommonMethods.CheckNullOrUndefined(params) ? { ScheduleType: 1, PromisedDate: params.PromisedDate, StartTime: params.StartTime, TechID: params.TechID, DepartmentID: params.DepartmentID } : {},
		  tabTitle: "New Work Order"
		  });
	  }
  
	  public DeleteAppointment() {
		  this.showAPTWarningModal = true;
	  }
  
	  public ConfirmDeleteAppointment() {
		  this.showAPTWarningModal = false;
		  this.showAppointmentModal = false;
		  this.showLoader();
		  this.DeleteAppointmentData(this.openAppointmentID).then((response) => {
		  this.RemoveAppointmentTile(this.openAppointmentID);
		  this.hideLoader();
		  this.toastr.success(Constants.CustomToastMessages_Dispatcher().AppointmentDeleteSuccess, "Success");
		  }).catch(error => {
		  this.hideLoader();
		  });
	  }
  
	  public CancelDelAppointment() {
		  this.showAPTWarningModal = false;
	  }
  
	  public openEditAppointment(type: number) {
		if (type === 2 &&  this.templatedata.data.AppointmentStatusCode==='completed') return;
		let obj = Object.assign({}, this.templatedata.appointmentData);
		this.scheduleObj.closeQuickInfoPopup();
		this.showAPTQuickInfo = false;
		this.showAppointmentModal = true;
		switch(type) {
			case 1:
				this.apptModalHeader.Header = "EDIT HELPER APPOINTMENT";
				this.apptModalHeader.SubHeader = "for Work Order " + this.templatedata.workOrderInfo.WorkTicketNumber;
				break;
			case 2:
				this.apptModalHeader.Header = `Estimate - ${this.templatedata.data.EstimateNumber}`;
				this.apptModalHeader.SubHeader = this.templatedata.appointmentData.Priority;
				obj['EstimateID'] = this.templatedata.data.EstimateID;
				break;
			default:
				this.apptModalHeader.Header = "EDIT APPOINTMENT";
				break;
		}
		this.AppointmentForm = this.InitAppointmentForm(obj);
	  }
  
	  public OpenNewAppointment() {
		  this.templatedata = {};
		  this.apptModalHeader.SubHeader = "";
		  this.showAppointmentModal = true;
		  this.apptModalHeader.Header = "NEW APPOINTMENT";
		  this.AppointmentForm = this.InitAppointmentForm();
	  }
  
	  public OpenWOModalTab(showtabs, hideTabs, event) {
		  hideTabs.forEach((tab) => {
		  $(tab).hide();
		  });
  
		  showtabs.forEach((tab) => {
		  $(tab).show();
		  // $(tab).removeClass('tabcontent');
		  if ($(tab).hasClass('display-flex')){
			  $(tab).css("display", "flex");
		  }
		  });
		  if (!CommonMethods.CheckNullOrUndefined(event)) {
		  $(event.target).addClass("tab-active");
		  $(event.target).siblings('a').removeClass("tab-active");
		  }
	  }
	  
	  //#region  Helper Update
	  public DispatchHelperFromQI(helperObj, isUndo: boolean = false) {	
		  if (helperObj != null) {
		  this.closeQuickInfo();
		  let statusId = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
		  let subStatusId = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == (isUndo == true ? Constants.WOStaticStatus().assigned : Constants.WOStaticStatus().dispatched)).ID;
		  let model = this.RequestModelMapper(helperObj);
  
		  model.StatusID = statusId;
		  model.SubStatusID = subStatusId;
		  model.IsDirty = true;
		  model.IsSchedule = !isUndo;
  
		  this.showLoader();
		  let subscription = this.httpService.Put_Dispatch_Appointment(model).subscribe((res) => {
				helperObj.AppointmentStatusID = statusId;
				helperObj.AppointmentSubStatusID = subStatusId;
				helperObj.AppointmentStatusCode = Constants.WOStaticStatus().open;
				helperObj.AppointmentSubStatusCode = (isUndo) ? Constants.WOStaticStatus().assigned : Constants.WOStaticStatus().dispatched;
				helperObj.AppointmentModifyDate = res.ModifyDate;
				this.UpdateSchedulerSourceForHelper(helperObj);
				this.toastr.success((isUndo) ? Constants.DefaultWorkOrderMessages.HelperUndoDispatchedMessage : Constants.DefaultWorkOrderMessages.HelperDispatchedMessage, "Success");
				this.hideLoader();
			},
			error => {
				this.hideLoader();
				if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
					this.toastr.showMultiLineError(error.error.Message, "Error");
			});
		  	this.subscriptions.push(subscription);
		}
	  }
  
	  private UpdateSchedulerSourceForHelper(helperObj) {
		  if(!CommonMethods.CheckNullOrUndefined(helperObj.WorkTicketID)) {
			  let schedulerDatasource: any = this.scheduleObj.eventSettings.dataSource;
			  let wtTileIndex = schedulerDatasource.findIndex((item: any) => item.WorkTicketID === helperObj.WorkTicketID && item.AppointmentTypeID === this.primaryTechCodeType[0].ID);
						  
			  if (wtTileIndex != -1) {
				  let helperIndex = schedulerDatasource[wtTileIndex].Helpers.findIndex((item: any) => item.AppointmentID === helperObj.AppointmentID);
				  
				  if (helperIndex != -1) {
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentStatusID = helperObj.AppointmentStatusID;
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentSubStatusID = helperObj.AppointmentSubStatusID;
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentStatusCode = helperObj.AppointmentStatusCode;
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentSubStatusCode = helperObj.AppointmentSubStatusCode;
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentModifyDate = helperObj.AppointmentModifyDate;
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentStartTime = helperObj.AppointmentStartTime;			
					  schedulerDatasource[wtTileIndex].Helpers[helperIndex].AppointmentEndTime = helperObj.AppointmentEndTime;			
				  }
			  }
								  
			  let helperTileIndex = schedulerDatasource.findIndex((item: any) => item.AppointmentID === helperObj.AppointmentID);
				  
			  if (helperTileIndex != -1) {
				  schedulerDatasource[helperTileIndex].AppointmentStatusID = helperObj.AppointmentStatusID;
				  schedulerDatasource[helperTileIndex].AppointmentSubStatusID = helperObj.AppointmentSubStatusID;
				  schedulerDatasource[helperTileIndex].AppointmentStatusCode = helperObj.AppointmentStatusCode;
				  schedulerDatasource[helperTileIndex].AppointmentSubStatusCode = helperObj.AppointmentSubStatusCode;
				  schedulerDatasource[helperTileIndex].AppointmentModifyDate = helperObj.AppointmentModifyDate;			
			  }
  
			  this.scheduleObj.eventSettings.dataSource = schedulerDatasource;
			  this.scheduleObj.refreshEvents();
		  }
	  }
	  ////#endregion
  
	  //#region WorkOrder Status Update
	  public DispatchWorkOrderFromQI(isUndo: boolean = false) {
		  let wtObj = Object.assign({}, this.templatedata);
		  if (wtObj != null) {
			  this.closeQuickInfo();
			  let statusId = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
			  let subStatusId = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == (isUndo == true? Constants.WOStaticStatus().assigned : Constants.WOStaticStatus().dispatched)).ID;
			  
			  wtObj.ID = wtObj.WorkTicketID;
			  wtObj.WorkTicketStatusAction = (isUndo)?  Constants.WOStaticStatus().assign : Constants.WOStaticStatus().dispatch;
			  delete wtObj.workOrderInfo;				
			  
			  this.showLoader();
			  let subscription = this.httpService.UpdateDispatchWorkOrder_Patch(wtObj).subscribe((res) => {				
				  let schedulerDatasource: any = this.scheduleObj.eventSettings.dataSource;
				  const wtTileIndex = schedulerDatasource.findIndex((item: any) => item.WorkTicketID === wtObj.WorkTicketID && item.AppointmentTypeID === this.primaryTechCodeType[0].ID);
				  const workTicketSubStatusCode = (isUndo)? Constants.WOStaticStatus().assigned : Constants.WOStaticStatus().dispatched;
  
				  if (wtTileIndex != -1) {
					  schedulerDatasource[wtTileIndex].AppointmentStatusID = statusId;
					  schedulerDatasource[wtTileIndex].AppointmentSubStatusID = subStatusId;
					  schedulerDatasource[wtTileIndex].AppointmentStatusCode = Constants.WOStaticStatus().open;
					  schedulerDatasource[wtTileIndex].AppointmentSubStatusCode = workTicketSubStatusCode;
					  
					  schedulerDatasource[wtTileIndex].WorkTicketStatusID = statusId;
					  schedulerDatasource[wtTileIndex].WorkTicketSubStatusID = subStatusId;
					  schedulerDatasource[wtTileIndex].WorkTicketStatusCode = Constants.WOStaticStatus().open;
					  schedulerDatasource[wtTileIndex].WorkTicketSubStatusCode = workTicketSubStatusCode;
					  schedulerDatasource[wtTileIndex].WorkTicketModifyDate = res.ModifyDate;
					  
					  const helpers = schedulerDatasource.filter((item: any) => item.WorkTicketID === wtObj.WorkTicketID && item.AppointmentTypeID !== this.primaryTechCodeType[0].ID);
					  for(const helper of helpers) {
						const helperTileIndex = schedulerDatasource.findIndex((item: any) => item.AppointmentID === helper.AppointmentID);
						
						if (helperTileIndex != -1) {
							schedulerDatasource[helperTileIndex].WorkTicketStatusID = statusId;
							schedulerDatasource[helperTileIndex].WorkTicketSubStatusID = subStatusId;
							schedulerDatasource[helperTileIndex].WorkTicketStatusCode = Constants.WOStaticStatus().open;
							schedulerDatasource[helperTileIndex].WorkTicketSubStatusCode = workTicketSubStatusCode;
							schedulerDatasource[helperTileIndex].WorkTicketModifyDate = res.ModifyDate;
						}
					  }
														  
					  this.scheduleObj.eventSettings.dataSource = schedulerDatasource;
					  this.scheduleObj.refreshEvents();
				  }	
				  
				  this.toastr.success((isUndo) ? Constants.DefaultWorkOrderMessages.WorkOrderRecalledMessage : Constants.DefaultWorkOrderMessages.WorkOrderDispatchedMessage, "Success");		  
				  this.hideLoader();
			  },
			  error => {
				this.hideLoader();
				if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
					this.toastr.showMultiLineError(error.error.Message, "Error");
			  });
			  this.subscriptions.push(subscription);
		  }
	  }
	  //#endregion
  
	  public DispatchEstimateFromQI(action: number) {
		const appObj = Object.assign({}, this.templatedata);
		if (appObj != null) {
			this.closeQuickInfo();
			const openId = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
			let statusModel = new CodeTypeModel();
			let subStatusModel = new CodeTypeModel();
			statusModel.ID = openId;
			statusModel.Code = Constants.WOStaticStatus().open; 
			switch(action) {
			case 0: 
				subStatusModel.ID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().dispatched).ID;
				subStatusModel.Code = Constants.WOStaticStatus().dispatched;
				break;
			default:
				subStatusModel.ID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned).ID;
				subStatusModel.Code = Constants.WOStaticStatus().assigned;
				break;
			}

			this.showLoader();
			let subscription = this.httpService.UpdateDispatchEstimate_Patch(appObj.data.AppointmentID, statusModel, subStatusModel).subscribe((res) => {				
				let schedulerDatasource: any = this.scheduleObj.eventSettings.dataSource;
				const tileIndex = schedulerDatasource.findIndex((item: any) => item.ID === appObj.data.AppointmentID);

				if (tileIndex != -1) {
					schedulerDatasource[tileIndex].AppointmentStatusID = statusModel.ID;
					schedulerDatasource[tileIndex].AppointmentSubStatusID = subStatusModel.ID;
					schedulerDatasource[tileIndex].AppointmentStatusCode = statusModel.Code;
					schedulerDatasource[tileIndex].AppointmentSubStatusCode = subStatusModel.Code;
					schedulerDatasource[tileIndex].WorkTicketModifyDate = res.ModifyDate;									  
					this.scheduleObj.eventSettings.dataSource = schedulerDatasource;
					this.scheduleObj.refreshEvents();
				}	
				
				this.toastr.success(action === 0 ? Constants.DefaultWorkOrderMessages.HelperDispatchedMessage : this.constants.DefaultWorkOrderMessages.HelperAssignedMessage, "Success");		  
				this.hideLoader();
			},
			error => {
			this.hideLoader();
			if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
				this.toastr.showMultiLineError(error.error.Message, "Error");
			});
			this.subscriptions.push(subscription);
		}
	  }

	  openEstimateDetail(eventObj) {
			let params = Object.assign({}, eventObj.data);
			params["ID"] = params.EstimateID;
			params["Customer"] = { ID: params["CustomerID"] };
			params["JobSite"] = { ID: params["JobSiteID"] };
			params["EstimateNo"] = params.EstimateNumber
			this.tabopen.OpenTab(TabParams.ViewEstimate(params, true));
	  }
	  private RequestModelMapper(obj) {
		  let model = new Request_AppointmentModel();
  
		  CommonMethods.ObjectMapper(obj, model);
		  model.ID = obj.AppointmentID;
		  model.StartTime = obj.AppointmentStartTime;
		  model.EndTime = obj.AppointmentEndTime;
		  model.Note = obj.AppointmentNote;
		  model.ModifyDate = obj.AppointmentModifyDate;
		  
		  return model;
	  }
  
	  /**
	   *  return the values for appointment type filter. will use ApptType_Data variable to look for values
	   * @param APTTypeCodes
	   */
	  private BindAPTFilterValues(APTTypeCodes: string[]) {
		  let filteredArray = [];
		  APTTypeCodes.forEach(value => {
		  if (!CommonMethods.CheckNullOrUndefined(this.ApptType_Data.find(x => x.Code.toLowerCase() == value)))
			  filteredArray.push(this.ApptType_Data.find(x => x.Code.toLowerCase() == value));
		  });
		  return filteredArray;
	  }
  
	  /**
	   * Method to PUT/POST appointment using dispatch service
	   */
	  private SaveAppointment(requestModel: Request_AppointmentModel, successToastMsg = null) {
		  return new Promise((resolve, reject) => {
			if (requestModel.ID == CommonMethods.GetID()) {
				this.httpService.Post_Dispatch_Appointment(requestModel).subscribe(
				(response) => {
					this.isLoaded = 1;
					this.setschedulerLoadingState();
					this.scheduleObj.refreshEvents();
					this.hideLoader();
					resolve(response);
				},
				error => {
					this.ShowErrorFromAPI(error);
					reject(error);
					this.isLoaded = 1;
					this.hideLoader();
				}
				);
			}
			else {
				this.httpService.Put_Dispatch_Appointment(requestModel).subscribe(
				(response) => {
					this.hideLoader();
					resolve(response);
				},
				error => {
					this.ShowErrorFromAPI(error);
					this.isLoaded = 1;
					this.hideLoader();
					reject(error);
				}
				);
			}
		  });
	  }
  
	  /**
	   * Converts response to eventData to be used for dispatch board
	   * @param response
	   * @param item
	   * @param forNewAppointment
	   */
	  private ConvertToEventData(response: any, item: CommonAppointmentModel, forNewAppointment: boolean) 
	  {
	    if (forNewAppointment) {
			let model: CommonAppointmentModel = new CommonAppointmentModel();
			model.AppointmentDate = response.AppointmentDate;
			model.AppointmentEndTime = response.EndTime;
			model.AppointmentID = response.ID;
			model.AppointmentModifyDate = response.ModifyDate;
			model.AppointmentNote = response.Note;
			model.AppointmentStartTime = response.StartTime;
			model.AppointmentStatusID = response.StatusID;
			model.AppointmentSubStatusID = response.SubStatusID;
			model.AppointmentTypeID = response.AppointmentTypeID;
			model.ID = response.ID;
			model.Priority = response.Priority;
			model.PriorityID = response.PriorityID;
			model.PromID = response.PromID;
			model.UserID = response.UserID;
			model.WorkTicketID = response.WorkTicketID;
			model.WorkTicketNumber = response.WoNumber;
			let appointTypeCode = "";
			if (response.AppointmentTypeID == this.primaryTechCodeType[0].ID){
				appointTypeCode = this.primaryTechCodeType[0].Code;
				model.WorkTicketModifyDate = response.ModifyDate;
			}
			else {
				appointTypeCode = this.ApptType_Data.find(x => x.ID == response.AppointmentTypeID).Code;
				model.AppointmentModifyDate = response.ModifyDate;
			}
			model.AppointmentTypeCode = appointTypeCode;
			return model;
		}
		else {
			item.AppointmentDate = response.AppointmentDate;
			item.AppointmentEndTime = response.EndTime;
			item.AppointmentID = response.ID;
			item.AppointmentNote = response.Note;
			item.AppointmentStartTime = response.StartTime;
			item.AppointmentStatusID = response.StatusID;
			item.AppointmentSubStatusID = response.SubStatusID;
			item.AppointmentTypeID = response.AppointmentTypeID;
			item.Priority = response.Priority;
			item.PriorityID = response.PriorityID;
			item.PromID = response.PromID;
			item.UserID = response.UserID;
			item.WorkTicketID = response.WorkTicketID;
			item.WorkTicketNumber = response.WoNumber;
			let appointTypeCode = "";
			if (response.AppointmentTypeID == this.primaryTechCodeType[0].ID) {
				appointTypeCode = this.primaryTechCodeType[0].Code;
				item.DispComment = response.Note;
				item.WorkTicketModifyDate = response.ModifyDate;
			}
			else {
				appointTypeCode = this.ApptType_Data.find(x => x.ID == response.AppointmentTypeID).Code;
				item.AppointmentModifyDate = response.ModifyDate;
				if (item.AppointmentStatusID) {
					item.AppointmentStatusCode = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.ID == item.AppointmentStatusID).Code;
					item.AppointmentSubStatusCode = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.ID == item.AppointmentSubStatusID).Code;
				}
			}
			item.AppointmentTypeCode = appointTypeCode;
			if (!CommonMethods.CheckNullOrUndefined(response.PromID))
				item.PromName = this.PromisedTime_Data.find((item: any) => item.ID == response.PromID)["Name"];
	
			return item;
		}
	  }
  
		/**
	   * Refresh filter to make things visible
	   */
	  private RefreshFilters() {
		  this.FilterType = 'All';
		  this.Filterpriority = 'All';
		  this.FilterTechType = 'All';
		  this.FilterDepartment = 'All';
		  this.FilterStateSubState = 'All';
		  this.FilterServiceType = "All";
	  }
  
		/**
	   * Delete request to service
	   * @param appointmentID
	   */
	  private DeleteAppointmentData(appointmentID) {
		  return new Promise((resolve, reject) => { 
		  this.httpService.Delete_Dispatch_Appointment(appointmentID).subscribe(
		  (response) => {
			  resolve(response);		
		  },
		  error => {
			  reject(error);
		  }
		  );
		  });
	  }
  
	  private ConvertToEventDataFromGridRow(draggedData: any, cellData, resourceDetails) {
		  let cellDate_Year = new Date(cellData.startTime).getFullYear();
		  let cellDate_Month = new Date(cellData.startTime).getMonth() + 1;
		  let cellDate_Day = new Date(cellData.startTime).getDate();
		  let WorkTicketStatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
		  let WorkTicketSubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned).ID;
		  let formattedPromDate = cellDate_Month + "/" + cellDate_Day + "/" + cellDate_Year;
		  let updatedProm_Date = cellDate_Year + "-" + cellDate_Month + "-" + cellDate_Day + "T00:00:00";
  
		  let PromiseID: string = "";
		  var promiseNameInList: any = this.PromisedTime_Data.find((item: any) => item.Name == draggedData.PromName.toString());
		  if (!isNullOrUndefined(promiseNameInList)) {
		  PromiseID = this.PromisedTime_Data.find((item: any) => item.Name == draggedData.PromName.toString())["ID"];
		  }
  
		  let eventData: { [key: string]: Object } = {
		  AppointmentDate: cellData.startTime,
		  AppointmentEndTime: (new Date(cellData.endTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(cellData.endTime).getMinutes().toString().padStart(2, '0')) + ":00",
		  AppointmentNote: draggedData.AppointmentNote,
		  AppointmentStartTime: (new Date(cellData.startTime).getHours().toString().padStart(2, '0')) + ":" + (new Date(cellData.startTime).getMinutes().toString().padStart(2, '0')) + ":00",
		  CustomerID: draggedData.CustomerID,
		  DepartmentID: draggedData.DepartmentID,
		  DeptName: draggedData.DeptName,
		  DispComment: draggedData.DispComment,
		  DisplayName: draggedData.JobsiteContactName,
		  EndTime: cellData.endTime,
		  EventType: 'WorkOrder',
		  GroupIndex: cellData.groupIndex,
		  Helpers: draggedData.Helpers,
		  ID: draggedData.ID,
		  IsAllDay: cellData.isAllDay,
		  JobSiteAddr: draggedData.JobSiteAddr,
		  JobsiteContactName: draggedData.JobsiteContactName,
		  JobSIteContactPhone: draggedData.JobsitePhoneNumber,
		  JobSiteDispName: draggedData.JobSiteDispName,
		  JobSiteID: draggedData.JobSiteID,
		  JobsitePhoneNumber: draggedData.JobsitePhoneNumber,
		  JobSiteType: draggedData.JobSiteType,
		  JobsiteTypeID: draggedData.JobsiteTypeID,
		  Message: resourceDetails.resourceData.Message,
		  MessageType: resourceDetails.resourceData.MessageType,
		  ModifyDate: draggedData.WorkTicketModifyDate,
		  Name: draggedData.Name,
		  PDate: new Date(updatedProm_Date), // update promise date as per dragged data 
		  Priority: draggedData.Priority,
		  PriorityID: draggedData.PriorityID,
		  PromBeginTime: draggedData.PromBeginTime,
		  PromDate: updatedProm_Date, // update promise date as per dragged data 
		  PromEndTime: draggedData.PromEndTime,
		  PromID: (isNullOrUndefined(PromiseID) ? "" : PromiseID.toString()), // get promise ID from promise datasource
		  PromName: draggedData.PromName,
		  ServiceType: draggedData.ServiceType,
		  ServiceTypeName: draggedData.ServiceTypeName,
		  StartTime: cellData.startTime,
		  State: Constants.WOStaticStatus().open,
		  SubState: Constants.WOStaticStatus().assigned,
		  TechDepartmentID: resourceDetails.resourceData.DepartmentGroupID,
		  TechGroupName: draggedData.TechGroupName,
		  TypeID: draggedData.TypeID,
		  UserGroupID: resourceDetails.resourceData.UserGroupID,
		  UserID: resourceDetails.resourceData.ID,
		  UserName: resourceDetails.resourceData.Text,
		  UserPhone: resourceDetails.resourceData.UserPhone,
		  WorkTicketID: draggedData.WorkTicketID,
		  WorkTicketNumber: draggedData.WorkTicketNumber,
		  WorkTicketStatusCode: Constants.WOStaticStatus().open,
		  WorkTicketStatusID: WorkTicketStatusID,
		  WorkTicketSubStatusCode: Constants.WOStaticStatus().assigned,
		  WorkTicketSubStatusID: WorkTicketSubStatusID
		  };
		  return eventData;
	  }
  
	  /**
	   * Converts event data to grid row in case of unassign work order
	   * @param data
	   */
  
	  private ConvertToGridRow(data: any) {
		let DurationHour: number = 0;
		let DurationMin: number = 0;
		let WorkTicketUnassignedID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().unassigned).ID;
		if (!isNullOrUndefined(data.EndTime) && !isNullOrUndefined(data.StartTime)) {
		if (new Date(data.EndTime).getHours() >= new Date(data.StartTime).getHours()) {
			let datedifference = (new Date(data.EndTime).getTime() - new Date(data.StartTime).getTime());
			DurationHour = Math.floor((datedifference / 60000) / 60);
			DurationMin = Math.floor((datedifference / 60000) % 60);
			if (DurationMin > 0) { DurationMin = 30; }
		}
		else {
			DurationHour = 0;
			DurationMin = 30;
		}
		}
		else {
		DurationHour = 0;
		DurationMin = 30;
		}
		
		data.AppointmentEndTime = this.ToCustomTimeFormat(DurationHour, DurationMin)
		data.AppointmentStatusCode = 'Open';
		data.AppointmentSubStatusCode = 'Unassigned';
		data.Duration = this.ToCustomTimeFormat(DurationHour, DurationMin);
		data.PDate = new Date(data.AppointmentDate);
		data.PromDate = data.AppointmentDate;
		data.WorkTicketStatusCode = 'Open';
		data.WorkTicketSubStatusCode = 'Unassigned';
		data.WorkTicketStatusName = 'Open';
		data.WorkTicketSubStatusName = 'Unassigned';
		data.WorkTicketSubStatusID = WorkTicketUnassignedID;
		const eventData = this.MapToCommonModel(data);
		return eventData;
	  }
	  
	  /**
	   * Removes a tile from dispatch board based on item.ID
	   */
	  private RemoveAppointmentTile(id) {
		  return new Promise((resolve, reject) => {
			try {
			  let schedulerDataSource: CommonAppointmentModel[] = <CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource;
			  let removeIndex = schedulerDataSource.findIndex(item => item.ID == id);
			  schedulerDataSource.splice(removeIndex, 1); // new datasource for scheduler					
			  this.scheduleObj.eventSettings.dataSource = schedulerDataSource;
			  this.RemoveHelperFromWO(id);
			  resolve(true);
		  }
		  catch (e) {
			  reject(new Error("Unable to update dispatch board"));
		  }
		  });
	  }
  
	  private MapToCommonModel(data: any) {
		let appointmentModel: CommonAppointmentModel = new CommonAppointmentModel();
		appointmentModel = data;
		return appointmentModel;
	  }

	  private RemoveHelperFromWO(id: string) {
		const workOrders =  (<CommonAppointmentModel[]>this.scheduleObj.eventSettings.dataSource).filter((item: any) => item.AppointmentTypeID === this.primaryTechCodeType[0].ID);
		for(const workOrder of workOrders) {
			const helperIndex = workOrder.Helpers.findIndex(y => y.AppointmentID === id);
			workOrder.Helpers.splice(helperIndex, 1);
		}
		this.scheduleObj.refreshEvents();
	  }
	  //#endregion
  }